var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled, { css, createGlobalStyle, keyframes } from 'styled-components';
import removeimage from '../../../../images/icons/longreadeditor/deleteimage.svg';
import removeimagehover from '../../../../images/icons/longreadeditor/deleteimagehover.svg';
import { addLongReadPost, addManyLongReadPost } from '../../../../actions/addLongReadPost';
import { setEditLongRead } from '../../../../actions/setEditLongRead';
import { getLongRead } from '../../../../actions/getLongRead';
import { getLongReadPosts } from '../../../../actions/getLongReadPosts';
import { colorObj } from '../../../../constants/colorObj';
import { paddings, heights } from '../../../../constants/paddings';
import BigImageComp from './bigimage';
import ColorMenuComp from './colormenu';
import Uppy from '@uppy/core';
import Tus from '@uppy/tus';
import { ProgressBar } from '@uppy/react';
import FileInput from '@uppy/file-input';
import { Endpoints, Lang } from '@brg/api';
import { LayoutConst, MEDIA_QUERY, MEDIA_QUERY_HEIGHT, MEDIA_QUERY_MOBILE } from '../../../../constants/media';
import CaptionEdit from './CaptionEdit';
import { toggleLongReadPostUpdate } from '../../../../actions/toggleLRPostUpdate';
import MediaInputGroup from './MediaInputGroup';
import { CaptionBlock } from '../postblocks/coloredblock';
import { CaptionMarkdownText, LeftColumn, RightColumn, TextWrapper } from "../postblocks/whitepostblock";
import TextArea, { TEXTAREA_TYPE } from '../../modules/inputs/TextArea';
import JuryBox from '../specialTools';
import formatLinks from '../../../../utilites/formatLinks';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import EditorToolbar from './EditorToolbar';
import { FontSizes, MAC13_COLORED_FONT_SIZE } from '../../../../constants/theme';
import toastHook from '../../../../utilites/toasts';
import { FlexBox, useToasts } from '@brg/ui';
import { getAppNameFromAppString } from '../../../../utilites/appTester';
import { UpdateHeaderToggle, uploadValidator } from "./updateel";
import { useModal, withModal } from '../../../../core/modules/modal.module';
import urlApi from '../../../../actions/urlApi';
import { MultipleUploadBlock } from './MultipleUploadBlock/MultipleUploadBlock';
import { withLocalization } from "../../../../hooks/useLocalization";
import { NotSavedImagesModal } from '../../../modals/NotSavedImagesModal';
import { MultipleLoaderModal } from '../../../modals/MultipleLoaderModal';
import { LoaderModal } from '../../../modals/LoaderModal';
import { SliderEditBlock } from './SiderEditBlock/SliderEditBlock';
import { PresentationBlock } from './Presentation/PresentationBlock';
import { clearWidePreviewer, toggleWidePreviewer } from '../../../../actions/toggleWidePreviewer';
import { withProfile } from '../../../../hooks/withProfile';
import { ProjectEditBlock } from "./ProjectEditBlock/ProjectEditBlock";
import { LargeText } from '../../../Text/styles';
import FormsBlock, { FORM_CENTER_POS } from '../postblocks/FormsBlock/FormsBlock';
import ButtonBlock from './Button';
import { UPRISE_TYPE } from './Button/const';
import { getCurrentLongread } from "../../../../reducers/longreadBlocks";
import { getCurrentEditLongread } from "../../../../reducers/setEditLongRead";
import { getAddLongread } from "../../../../reducers/addLongReadPost";
import { getToggleLongReadPostUpdate } from "../../../../reducers/toggleLongReadPostUpdate";
import { LessonEditBlock } from "../postblocks/CourseBlock/sections/LessonEditBlock";
import ProductsBlock from '../postblocks/ProductsBlock/ProductsBlock';
import { CoursePresentationEditBlock } from "./CoursePresentationEditBlock/CoursePresentationEditBlock";
import TwoPicturesBlock from './TwoPicturesBlock/TwoPicturesBlock';
import RadioButton from "../../../buttons/Radio";
import BigImageCard from "./bigimageCard";
import { PodcastEditBlock } from "./PodcastEditBlock/PodcastEditBlock";
import { addOrChangeAdditionalInfo } from "../../../../utilites/addOrChangeAdditionalInfo";
import { getAdditionalInfoVal } from "../../../../utilites/getAdditionalInfoVal";
import { onChangeBibliography } from '../../../../utilites/bibliography/onChangeBibliography';
import { modifyToListText } from '../../../../utilites/bibliography/modifyToListText';
import { getCardIdsFromAdditionalInfo } from '../../../../utilites/card/getCardIdsFromAdditionalInfo';
import { updateIsPayInCardsInfo } from '../../../../utilites/card/updateIsPayInCardsInfo';
import { CARDS_INFO_KEY } from '../../../../constants/cards';
import { INITIAL_RAITING, RaitingBox } from '../postblocks/components/RaitingBox';
import { WhitePostImageBlock } from './WhitePostImageBlock/WhitePostImageBlock';
import { DefaultBlock } from './DefaultBlock/DefaultBlock';
import LinkArea from '../../modules/inputs/LinkArea';
import { extractProjectId, replaceAWithHref } from '../../../../utilites/replaceHiddenProjectLink';
import { BlockWithTitleEdit } from './AnnotationEditor/BlockWithTitleEdit';
import { TileViewType } from '../../../../constants/TyleViewType';
export var MAX_FILES_COUNT = 15;
var IMAGES_STYLES = ['image', 'multiple', 'slider', 'big', 'tile'];
export var FORM_POSITION_TYPE = {
    0: 'center',
    1: 'right'
};
var Wrap = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  min-width: 1152px;\n  max-width: min-content;\n  position: relative;\n  margin-top: ", ";\n  background: ", ";\n  box-shadow: none;\n  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.12));\n\n  ", ";\n\n  border: none;\n\n  z-index: 101;\n\n  .uppy-ProgressBar {\n    z-index: 2222;\n    top: 0;\n    width: 100%;\n  }\n\n  .uppy-ProgressBar-inner {\n    background: #f1db63;\n    height: 8px;\n    transition: 1s;\n  }\n\n  .uppy-ProgressBar-percentage {\n    display: none;\n  }\n\n  textarea {\n    display: inline-block;\n    border: none;\n    width: 100%;\n    outline: none;\n    border: none;\n\n    &:focus {\n      border: none;\n    }\n  }\n\n  @media (max-width: ", "px),\n    (max-height: ", "px) {\n    min-width: ", ";\n  }\n\n  ", ";\n\n\n\n  ", ";\n\n  @media(max-width: ", "px) {\n    ", ";\n    min-width: 100%;\n  }\n\n  @media(max-width: 744px) {\n    ", ";\n    min-width: 100%;\n  }\n"], ["\n  min-width: 1152px;\n  max-width: min-content;\n  position: relative;\n  margin-top: ", ";\n  background: ", ";\n  box-shadow: none;\n  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.12));\n\n  ", ";\n\n  border: none;\n\n  z-index: 101;\n\n  .uppy-ProgressBar {\n    z-index: 2222;\n    top: 0;\n    width: 100%;\n  }\n\n  .uppy-ProgressBar-inner {\n    background: #f1db63;\n    height: 8px;\n    transition: 1s;\n  }\n\n  .uppy-ProgressBar-percentage {\n    display: none;\n  }\n\n  textarea {\n    display: inline-block;\n    border: none;\n    width: 100%;\n    outline: none;\n    border: none;\n\n    &:focus {\n      border: none;\n    }\n  }\n\n  @media (max-width: ", "px),\n    (max-height: ", "px) {\n    min-width: ", ";\n  }\n\n  ", ";\n\n\n\n  ", ";\n\n  @media(max-width: ", "px) {\n    ", ";\n    min-width: 100%;\n  }\n\n  @media(max-width: 744px) {\n    ", ";\n    min-width: 100%;\n  }\n"])), function (props) {
    if (props === null || props === void 0 ? void 0 : props.isPresentationLoader)
        return '80px';
    if (props === null || props === void 0 ? void 0 : props.withHeader)
        return '16px';
    if (props.hideOffset)
        return '0px';
    if (props.isFeed)
        return '32px';
    return '40px';
}, function (p) { return (p === null || p === void 0 ? void 0 : p.hideBackground) ? 'transparent' : (p === null || p === void 0 ? void 0 : p.blackBG) ? '#1f1f1f' : '#ffffff'; }, function (p) { return ['t-shape', 'fixed-ratio-small', 'fixed-ratio-large', 'free-type'].includes(p.viewType) ? css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    filter: none;\n  "], ["\n    filter: none;\n  "]))) : null; }, MEDIA_QUERY, MEDIA_QUERY_HEIGHT, function (props) { return props.isGalleryBp || (props === null || props === void 0 ? void 0 : props.isFeed) ? '100%' : '888px'; }, function (_a) {
    var isGalllleryNewStyle = _a.isGalllleryNewStyle;
    return isGalllleryNewStyle && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    @media (max-width: 1199px){\n      min-width: 712px;\n    }\n  "], ["\n    @media (max-width: 1199px){\n      min-width: 712px;\n    }\n  "])));
}, function (p) { return ['t-shape', 'fixed-ratio-small', 'fixed-ratio-large', 'free-type'].includes(p === null || p === void 0 ? void 0 : p.viewType) ? css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    // max-width: min-content;\n\n    @media (max-width: ", "px),\n    (max-height: ", "px) {\n      margin-left: auto;\n      margin-right: auto;\n\n      .left-column, .right-column {\n        width: 50%;\n      }\n    }\n  "], ["\n    // max-width: min-content;\n\n    @media (max-width: ", "px),\n    (max-height: ", "px) {\n      margin-left: auto;\n      margin-right: auto;\n\n      .left-column, .right-column {\n        width: 50%;\n      }\n    }\n  "])), MEDIA_QUERY, MEDIA_QUERY_HEIGHT) : null; }, MEDIA_QUERY_MOBILE, function (_a) {
    var hideOffset = _a.hideOffset;
    return hideOffset ? css(templateObject_4 || (templateObject_4 = __makeTemplateObject([" margin-top: 0;"], [" margin-top: 0;"]))) : null;
}, function (_a) {
    var hideBackground = _a.hideBackground;
    return hideBackground ? css(templateObject_5 || (templateObject_5 = __makeTemplateObject([" margin-top: 0;"], [" margin-top: 0;"]))) : null;
});
export var EditorWrap = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  padding-top: ", ";\n  min-height: ", ";\n\n  ", ";\n\n  .radio-text {\n    font-size: ", ";\n    line-height: ", ";\n  }\n\n  textarea {\n    font-family: Inter;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 20px;\n    line-height: 32px;\n    letter-spacing: -0.02em;\n    color: #151514;\n    height: 40px;\n    padding-right: 40px;\n    //margin-bottom: 20px;\n\n    ", ";\n  }\n\n  @media (max-width: ", "px),\n  (max-height: ", "px) {\n\n  }\n"], ["\n  padding-top: ", ";\n  min-height: ", ";\n\n  ", ";\n\n  .radio-text {\n    font-size: ", ";\n    line-height: ", ";\n  }\n\n  textarea {\n    font-family: Inter;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 20px;\n    line-height: 32px;\n    letter-spacing: -0.02em;\n    color: #151514;\n    height: 40px;\n    padding-right: 40px;\n    //margin-bottom: 20px;\n\n    ", ";\n  }\n\n  @media (max-width: ", "px),\n  (max-height: ", "px) {\n\n  }\n"])), function (p) { return (p === null || p === void 0 ? void 0 : p.isBiblio) ? '36px' : '38px'; }, function (p) { return ((p === null || p === void 0 ? void 0 : p.blockHgt) ? "".concat(p.blockHgt, "px") : '348px'); }, function (p) {
    return (p === null || p === void 0 ? void 0 : p.blockHgt)
        ? css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n          height: ", "px;\n        "], ["\n          height: ", "px;\n        "])), p.blockHgt) : null;
}, function (_a) {
    var inputType = _a.inputType;
    return inputType === TEXTAREA_TYPE.bibliography ? "".concat(FontSizes.common.m.fs, "px") : 'inherit';
}, function (_a) {
    var inputType = _a.inputType;
    return inputType === TEXTAREA_TYPE.bibliography ? "".concat(FontSizes.common.m.lh, "px") : 'inherit';
}, function (_a) {
    var skipReducedVersion = _a.theme.skipReducedVersion, inputType = _a.inputType;
    return skipReducedVersion
        ? null
        : css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n            @media (max-width: ", "px),\n              (max-height: ", "px) {\n              font-size: ", "px;\n              line-height: ", "px;\n              padding-right: ", "px;\n              margin-bottom: ", "px;\n            }\n          "], ["\n            @media (max-width: ", "px),\n              (max-height: ", "px) {\n              font-size: ", "px;\n              line-height: ", "px;\n              padding-right: ", "px;\n              margin-bottom: ", "px;\n            }\n          "])), MEDIA_QUERY, MEDIA_QUERY_HEIGHT, FontSizes.regularText.m.fs, FontSizes.regularText.m.lh, LayoutConst.blockPadding.m.main, LayoutConst.blockPadding.m.main);
}, MEDIA_QUERY, MEDIA_QUERY_HEIGHT);
var AttachedImageProgress = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  display: ", ";\n  position: absolute;\n  top: 0;\n  height: 8px;\n  z-index: 25;\n  width: calc(100% - 30px);\n"], ["\n  display: ", ";\n  position: absolute;\n  top: 0;\n  height: 8px;\n  z-index: 25;\n  width: calc(100% - 30px);\n"])), function (props) { return (props.isLoading ? 'block' : 'none'); });
export var EditTitle = styled(LargeText)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  background: ", ";\n  z-index: 14;\n  transition: 0.2s;\n  // min-height: ", ";\n  min-height: 348px;\n\n  textarea {\n    font-family: inherit;\n    font-weight: 600;\n    color: ", ";\n    background: transparent;\n    padding: 0;\n    box-sizing: border-box;\n\n    &::placeholder {\n      color: ", ";\n    }\n  }\n"], ["\n  background: ", ";\n  z-index: 14;\n  transition: 0.2s;\n  // min-height: ", ";\n  min-height: 348px;\n\n  textarea {\n    font-family: inherit;\n    font-weight: 600;\n    color: ", ";\n    background: transparent;\n    padding: 0;\n    box-sizing: border-box;\n\n    &::placeholder {\n      color: ", ";\n    }\n  }\n"])), function (props) { return props.bgcolor; }, function (props) { return (props.isLinkBlock ? '144px' : '348px'); }, function (props) { return props.fontColor; }, function (props) { return props.fontColor; });
var RemoveImage = styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  background: url(", ") no-repeat center;\n  z-index: 10;\n  right: 0px;\n  top: 0px;\n  cursor: pointer;\n  opacity: 0.31;\n  transition: 0.2s;\n\n  &:hover {\n    opacity: 1;\n    background: url(", ") no-repeat center;\n  }\n"], ["\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  background: url(", ") no-repeat center;\n  z-index: 10;\n  right: 0px;\n  top: 0px;\n  cursor: pointer;\n  opacity: 0.31;\n  transition: 0.2s;\n\n  &:hover {\n    opacity: 1;\n    background: url(", ") no-repeat center;\n  }\n"])), removeimage, removeimagehover);
var AttachedImage = styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  position: relative;\n  padding-right: 30px;\n\n  label {\n    margin-bottom: 0;\n  }\n\n  img {\n    transition: 0.2s;\n    width: 100%;\n    opacity: ", ";\n  }\n"], ["\n  position: relative;\n  padding-right: 30px;\n\n  label {\n    margin-bottom: 0;\n  }\n\n  img {\n    transition: 0.2s;\n    width: 100%;\n    opacity: ", ";\n  }\n"])), function (props) { return (props.isLoading ? '0.5' : '1'); });
var fadeIn = keyframes(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  from {\n    opacity: 0;\n    backdrop-filter: blur(0px);\n  }\n\n  to {\n    opacity: 0.73;\n    backdrop-filter: blur(13px);\n  }\n"], ["\n  from {\n    opacity: 0;\n    backdrop-filter: blur(0px);\n  }\n\n  to {\n    opacity: 0.73;\n    backdrop-filter: blur(13px);\n  }\n"])));
var fadeOut = keyframes(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  from {\n    opacity: 0.73;\n    backdrop-filter: blur(13px);\n  }\n\n  to {\n    opacity: 0;\n    backdrop-filter: blur(0px);\n  }\n"], ["\n  from {\n    opacity: 0.73;\n    backdrop-filter: blur(13px);\n  }\n\n  to {\n    opacity: 0;\n    backdrop-filter: blur(0px);\n  }\n"])));
var up = keyframes(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  from {\n    opacity: 0;\n    transform: translate(0, -30px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate(0, 0);\n  }\n"], ["\n  from {\n    opacity: 0;\n    transform: translate(0, -30px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate(0, 0);\n  }\n"])));
var down = keyframes(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  from {\n    transform: translate(0, 0);\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate(0, 30px);\n\n  }\n"], ["\n  from {\n    transform: translate(0, 0);\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate(0, 30px);\n\n  }\n"])));
var FixedBg = styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  z-index: 100;\n  background: linear-gradient(\n    180deg,\n    rgba(42, 48, 52, 0.91) 0%,\n    rgba(44, 47, 49, 0.65) 51.08%,\n    rgba(42, 48, 52, 0.91) 100%\n  );\n\n  p {\n    color: #fff;\n  }\n"], ["\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  z-index: 100;\n  background: linear-gradient(\n    180deg,\n    rgba(42, 48, 52, 0.91) 0%,\n    rgba(44, 47, 49, 0.65) 51.08%,\n    rgba(42, 48, 52, 0.91) 100%\n  );\n\n  p {\n    color: #fff;\n  }\n"])));
var FixedOverlay = styled.div(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n  position: ", ";\n  //bottom: 0;\n  bottom: ", "; // \u041E\u0442\u0441\u0442\u0443\u043F \u0434\u043B\u044F \u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E \u0444\u0443\u0442\u0435\u0440\u0430\n  right: 0;\n  left: 0;\n    /*padding-left:", ";\n  padding-right: ", ";*/\n  top: 0;\n  z-index: 350;\n  overflow-y: ", ";\n  pointer-events: ", ";\n\n  @media (max-width: 940px) {\n    display: ", ";\n  }\n\n  &::-webkit-scrollbar {\n    width: 0px;\n  }\n\n  & ", " {\n    ", "\n    & ", " {\n      ", "\n    }\n"], ["\n  position: ", ";\n  //bottom: 0;\n  bottom: ", "; // \u041E\u0442\u0441\u0442\u0443\u043F \u0434\u043B\u044F \u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E \u0444\u0443\u0442\u0435\u0440\u0430\n  right: 0;\n  left: 0;\n    /*padding-left:", ";\n  padding-right: ", ";*/\n  top: 0;\n  z-index: 350;\n  overflow-y: ", ";\n  pointer-events: ", ";\n\n  @media (max-width: 940px) {\n    display: ", ";\n  }\n\n  &::-webkit-scrollbar {\n    width: 0px;\n  }\n\n  & ", " {\n    ", "\n    & ", " {\n      ", "\n    }\n"])), function (_a) {
    var isModal = _a.isModal;
    return (isModal ? 'fixed' : 'static');
}, function (_a) {
    var isMultiLoad = _a.isMultiLoad;
    return isMultiLoad ? '48px' : '0';
}, function (props) {
    return props.isFocused ? 'calc((100vw - 1152px) / 2)' : '0';
}, function (props) {
    return props.isFocused ? 'calc((100vw - 1152px) / 2)' : '0';
}, function (_a) {
    var isModal = _a.isModal;
    return (isModal ? 'auto' : 'initial');
}, function (_a) {
    var isModal = _a.isModal, animation = _a.animation;
    return isModal && animation === 'out' ? 'none' : 'initial';
}, function (_a) {
    var visibleOnMobile = _a.visibleOnMobile;
    return visibleOnMobile ? 'block' : 'none';
}, Wrap, function (_a) {
    var isModal = _a.isModal, animation = _a.animation;
    if (isModal) {
        return animation === 'in'
            ? css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n              animation-name: ", ";\n              animation-fill-mode: forwards;\n              animation-duration: 0.8s;\n            "], ["\n              animation-name: ", ";\n              animation-fill-mode: forwards;\n              animation-duration: 0.8s;\n            "])), up) : css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n              animation-name: ", ";\n              animation-fill-mode: forwards;\n              animation-duration: 0.5s;\n            "], ["\n              animation-name: ", ";\n              animation-fill-mode: forwards;\n              animation-duration: 0.5s;\n            "])), down);
    }
}, FixedBg, function (_a) {
    var isModal = _a.isModal, animation = _a.animation;
    if (isModal) {
        return animation === 'in'
            ? css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n                animation-name: ", ";\n                animation-fill-mode: forwards;\n                animation-duration: 0.5s;\n              "], ["\n                animation-name: ", ";\n                animation-fill-mode: forwards;\n                animation-duration: 0.5s;\n              "])), fadeIn) : css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n                animation-name: ", ";\n                animation-fill-mode: forwards;\n                animation-duration: 0.5s;\n              "], ["\n                animation-name: ", ";\n                animation-fill-mode: forwards;\n                animation-duration: 0.5s;\n              "])), fadeOut);
    }
});
var FixedOverlay2 = styled.div(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n  position: ", ";\n  //max-width: 1182px;\n  max-width: 1152px;\n  padding-bottom: ", "px;\n  margin: 0 auto;\n  top: 25vh;\n\n  ", ";\n\n  @media(max-width: 743px) {\n    padding-bottom: ", ";\n  }\n"], ["\n  position: ", ";\n  //max-width: 1182px;\n  max-width: 1152px;\n  padding-bottom: ", "px;\n  margin: 0 auto;\n  top: 25vh;\n\n  ", ";\n\n  @media(max-width: 743px) {\n    padding-bottom: ", ";\n  }\n"])), function (_a) {
    var isModal = _a.isModal;
    return (isModal ? 'relative' : 'static');
}, function (_a) {
    var bottomOffset = _a.bottomOffset;
    return bottomOffset;
}, function (_a) {
    var skipReducedVersion = _a.theme.skipReducedVersion;
    return skipReducedVersion
        ? null
        : css(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n          @media (max-width: ", "px),\n            (max-height: ", "px) {\n            max-width: ", "px;\n          }\n        "], ["\n          @media (max-width: ", "px),\n            (max-height: ", "px) {\n            max-width: ", "px;\n          }\n        "])), MEDIA_QUERY, MEDIA_QUERY_HEIGHT, LayoutConst.container.m);
}, function (_a) {
    var isPresentation = _a.isPresentation;
    return isPresentation ? '16px' : '50px';
});
var GlobalEditor = createGlobalStyle(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n\n  body.opened__editor {\n    overflow-y: hidden;\n  }\n\n"], ["\n\n  body.opened__editor {\n    overflow-y: hidden;\n  }\n\n"])));
var MultipleWrap = styled.div(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n  img {\n    display: inline-block;\n    max-width: 200px;\n    margin: 15px;\n  }\n"], ["\n  img {\n    display: inline-block;\n    max-width: 200px;\n    margin: 15px;\n  }\n"])));
var MultipleText = styled.div(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n  color: black;\n  margin-bottom: 15px;\n"], ["\n  color: black;\n  margin-bottom: 15px;\n"])));
var NewEl = /** @class */ (function (_super) {
    __extends(NewEl, _super);
    // _isMounted = false;
    function NewEl(props) {
        var _this = _super.call(this, props) || this;
        _this.addNewLGLessonPost = function (isCardAbleToPurchase) {
            if (!_this.state.onLessonSave)
                return;
            _this.state.onLessonSave().then(function (r) {
                _this.addNewLGPost(isCardAbleToPurchase, r);
            });
        };
        _this.addNewLGPost = function (isCardAbleToPurchase, customText) {
            var _a, _b, _c, _d, _e, _f, _g;
            var isPresentation = _this.props.isPresentation;
            var isFeed = _this.props.isFeed;
            var reverseParam = isFeed; // разворачивает массив для ленты.
            var userid = localStorage.getItem('userId');
            var textLetter = _this.state.isFirstLetter
                ? "".concat(_this.state.text)
                : _this.state.text;
            var slicedTextLetter = _this.state.style === 'colored' ? textLetter.substring(0, 800) : textLetter;
            var rating = !!_this.state.useRating ?
                (((_a = _this.state.ratings) === null || _a === void 0 ? void 0 : _a['custom']) ? _this.state.ratings : { like: INITIAL_RAITING }) : {};
            var _h = _this.props.doiserStates, areaId = _h.areaId, countryId = _h.countryId, type = _h.type;
            var loadingSrc = _this.state.style === 'podcast' ? _this.state.audioSrc
                : _this.state.style === 'big' ||
                    _this.state.style === 'image' ||
                    _this.state.style === 'as_cover'
                    ? _this.state.bigImageSrc
                    : _this.state.prevImageSrc;
            var caption = ((_b = ['annotation', 'block_with_title']) === null || _b === void 0 ? void 0 : _b.includes(_this.state.style)) && !!((_c = _this.state.caption) === null || _c === void 0 ? void 0 : _c.length) ? { caption: _this.state.caption } : {};
            var autoCaption = (_this.state.postTextPos === 'caption-bottom' &&
                !!(slicedTextLetter === null || slicedTextLetter === void 0 ? void 0 : slicedTextLetter.length) &&
                !((_d = _this.state.imageCaption) === null || _d === void 0 ? void 0 : _d.length) &&
                !_this.state.editingCaption) ? slicedTextLetter : _this.state.imageCaption;
            var autoText = (_this.state.postTextPos !== 'caption-bottom' &&
                !!((_e = _this.state.imageCaption) === null || _e === void 0 ? void 0 : _e.length)) ? _this.state.imageCaption : slicedTextLetter;
            var podcastText = _this.state.style === 'podcast'
                ? (_this.state.iframeLink || _this.state.text)
                : autoText;
            var finalStyle = ((_f = ['normal_image', 'normal_card']) === null || _f === void 0 ? void 0 : _f.includes(_this.state.style)) ? 'normal' : _this.state.style;
            // случай для неск картинок
            if (_this.state.multipleLoadSrc.length > 0) {
                _this.setState({
                    multiLoadisStart: true,
                    imagesUploaded: false,
                });
                return;
            }
            if (_this.state.style === 'as_cover') {
                _this.setState({
                    imagesUploaded: false
                });
            }
            if (_this.state.style === 'forms') {
                _this.setState({ isLoading: true });
            }
            var newAdditionalInfo = addOrChangeAdditionalInfo(_this.state.additionalInfo || [], [
                { "name": "projectId", "value": (_g = _this.props) === null || _g === void 0 ? void 0 : _g.projectId },
                { "name": CARDS_INFO_KEY, "value": updateIsPayInCardsInfo(_this.state.additionalInfo || [], isCardAbleToPurchase ? true : false) },
                { "name": "tileViewType", "value": _this.state.tileViewType }
            ]);
            // если одна картинка
            if (_this.state.multipleLoadSrc.length === 0) {
                _this.props.addLongReadPost(__assign({ id: userid, title: _this.state.text, text: (customText || podcastText), color: _this.state.colorName, imageid: _this.state.imageId, lgid: _this.props.lgid, isFL: _this.state.isFirstLetter, imgCaption: autoCaption, style: finalStyle, num: _this.props.num, imageData: loadingSrc, thematic: _this.props.thematic, titlePosition: _this.state.postTextPos, projectIds: _this.state.projectIds, onAfterLoad: _this.handleSetLoadCompete, formId: _this.state.formId, formPosition: _this.state.formPosition, anchorText: _this.state.anchorText, buttons: _this.state.buttons, cardIds: _this.state.cardIds, generalProps: _this.props.generalProps, additionalInfo: newAdditionalInfo, useRating: _this.state.useRating, ratings: rating, linkText: _this.state.linkText, reverseParam: reverseParam }, caption));
            }
            _this.onBlueArea('');
            if (_this.props.onNewPost) {
                setTimeout(function () { return _this.props.onNewPost(); }, 1000);
            }
            _this.setState({
                text: '',
                title: '',
                addButtonsOpened: false,
                color: colorObj.white,
                fontColor: colorObj.fonts.white,
                colorName: 'white',
                isColorChoose: false,
                isTitleOpened: false,
                imageId: '',
                imageCaption: '',
                prevImageSrc: '',
                audioSrc: '',
                bigImageSrc: '',
                style: isPresentation ? 'as_cover' : isFeed ? '' : 'normal',
                isTextTooBig: false,
                prevColorStatus: 'white',
                isFirstLetter: false,
                firstLetter: '',
                postTextPos: '',
                projectIds: [],
                formId: '',
                formPosition: FORM_CENTER_POS,
                anchorText: '',
                iframeLink: '',
                useRating: false,
                // multipleLoadId: [],
                // multipleLoadSrc: []
            });
            _this.handleTogglePreviewer(false, null);
            _this.uppy.reset();
        };
        _this.handlePostButtonsChange = function (button) {
            _this.setState({ buttons: [button] });
        };
        _this.getClearedImageData = function () {
            return {
                bigImageSrc: '',
                multiLoadGrouppedImg: [],
                multipleLoadSrc: [],
                imageId: '',
                multipleLoadId: [],
                text: '',
                title: '',
                caption: '',
                imageCaption: '',
                prevImageSrc: '',
                audioSrc: '',
            };
        };
        _this.checkUnsavedData = function () { var _a; return (_this.state.bigImageSrc !== '' || !!((_a = _this.state.multiLoadGrouppedImg) === null || _a === void 0 ? void 0 : _a.length)); };
        _this.replaceHiddenProjectLink = function (id, field) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = urlApi()) === null || _a === void 0 ? void 0 : _a.getProject({ id: id }).then(function (r) { return r.status === 200 && r.json(); }).then(function (project) {
                            var _a;
                            var _b, _c;
                            var isHiddenProject = project.status === 10;
                            if (isHiddenProject) {
                                _this.props.toasts.error('Нельзя добавить ссылку на скрытый проект');
                            }
                            _this.setState((_a = {},
                                _a[field] = isHiddenProject ? replaceAWithHref((_b = _this.state) === null || _b === void 0 ? void 0 : _b[field]) : (_c = _this.state) === null || _c === void 0 ? void 0 : _c[field],
                                _a.linkProjectId = '',
                                _a));
                        }))];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleSetLoadCompete = function (val) {
            _this.setState({
                imagesUploaded: true,
            });
        };
        _this.handleSetFormPosition = function (val) {
            _this.setState({
                formPosition: val,
            });
        };
        _this.handleSetFormId = function (id) {
            _this.setState({
                formId: id,
            });
        };
        _this.handleSetIsMultiLoadingStart = function (val) {
            _this.setState({
                isMultipleFetchStart: val,
                imagesUploaded: true,
            });
            // setTimeout(() => {
            //   this.setState({
            //     imagesUploaded: null,
            // })
            // }, 1000)
        };
        _this.handleWhitePostButton = function () {
            var _a;
            _this.setState({
                style: 'normal',
                bigImageSrc: '',
                cardId: '',
                additionalInfo: (_a = _this.state.additionalInfo) === null || _a === void 0 ? void 0 : _a.filter(function (i) { return (i === null || i === void 0 ? void 0 : i.name) !== CARDS_INFO_KEY; })
            });
        };
        _this.handleWhitePostImageButton = function (ev) {
            var _a, _b, _c;
            var style = (_b = (_a = ev.target) === null || _a === void 0 ? void 0 : _a.dataset) === null || _b === void 0 ? void 0 : _b['type'];
            _this.setState({
                style: style,
                bigImageSrc: '',
                cardId: '',
                additionalInfo: (_c = _this.state.additionalInfo) === null || _c === void 0 ? void 0 : _c.filter(function (i) { return (i === null || i === void 0 ? void 0 : i.name) !== CARDS_INFO_KEY; })
            });
        };
        _this.handleAddLesson = function () {
            _this.setState({ style: 'course_lesson', text: '' });
        };
        _this.handleAddPodcast = function () {
            _this.setState({ style: 'podcast', text: '' });
        };
        _this.handleAddCoursePresentation = function () {
            _this.setState({ style: 'course_presentation' });
        };
        _this.handleToggleMultiCaption = function (value) {
            var current = _this.state.multiLoadCaptionMode === value;
            _this.setState({ multiLoadCaptionMode: current ? '' : value });
        };
        _this.handleMultiImgCaptionValueChange = function (id, value, mode) {
            var imgList = _this.state.multiLoadGrouppedImg.filter(function (img) { return (img === null || img === void 0 ? void 0 : img.id) === id; });
            var img = imgList[0];
            if (mode === 'caption') {
                img.isCaptionSetted = true;
                img.isTextSetted = false;
            }
            else {
                img.isCaptionSetted = false,
                    img.isTextSetted = true;
            }
            img[mode] = value;
            // console.log('multiLoadGroupState6', this.state.multiLoadGrouppedImg, this.state.multiLoadGrouppedImg.map((data) => {
            //   if (data?.id === img?.id) {
            //     return img
            //   }
            //   return data
            // }))
            _this.setState({
                multiLoadGrouppedImg: _this.state.multiLoadGrouppedImg.map(function (data) {
                    if ((data === null || data === void 0 ? void 0 : data.id) === (img === null || img === void 0 ? void 0 : img.id)) {
                        return img;
                    }
                    return data;
                })
            });
        };
        _this.handleRemoveMultiloadImgClick = function (id) {
            var _a, _b;
            var imgList = _this.state.multiLoadGrouppedImg.filter(function (img) { return (img === null || img === void 0 ? void 0 : img.id) !== id; });
            var isOneLeftAfterRemove = (imgList === null || imgList === void 0 ? void 0 : imgList.length) === 1;
            //Если после удаления остается одно изображение то открываем bigImg загрузчик
            // console.log('multiLoadGroupState7', imgList)
            _this.setState({
                multiLoadGrouppedImg: isOneLeftAfterRemove ? [] : imgList,
                bigImageSrc: isOneLeftAfterRemove ? (_a = imgList === null || imgList === void 0 ? void 0 : imgList[0]) === null || _a === void 0 ? void 0 : _a.src : '',
                imageId: isOneLeftAfterRemove ? (_b = imgList[0]) === null || _b === void 0 ? void 0 : _b.id : _this.state.imageId,
                multipleLoadSrc: isOneLeftAfterRemove ? [] : _this.state.multipleLoadSrc,
                style: isOneLeftAfterRemove ? 'big' : 'multiple'
            });
        };
        _this.handleColoredPostButton = function () {
            var projectId = _this.props.projectId || _this.props.lgid;
            var storageKey = projectId ? "lastCustomColor_".concat(projectId) : 'lastCustomColor';
            var lastCustomColor = localStorage.getItem(storageKey);
            if (_this.state.style === 'annotation') {
                return;
            }
            var lastColor = lastCustomColor;
            if (!lastCustomColor) {
                lastColor = _this.props.posts.reduce(function (result, _a, index) {
                    var color = _a.color, style = _a.style;
                    if (style === 'colored' && index < _this.props.num) {
                        return color;
                    }
                    return result;
                }, null);
            }
            var hex = lastColor && lastColor.startsWith('#') ? lastColor :
                _this.state.color === colorObj.white ? '#000000' : _this.state.color;
            _this.setState({
                color: hex,
                isTitleOpened: true,
                fontColor: _this.invertColor(hex, 'white', '#151514'),
                colorName: hex,
                isFirstLetter: false,
                text: "".concat(_this.state.text),
                firstLetter: '',
                style: 'colored',
                prevColorStatus: hex
            });
        };
        _this.handleLinkPostButton = function () {
            // Сначала пытаемся получить последний использованный кастомный цвет из localStorage
            var projectId = _this.props.projectId || _this.props.lgid;
            var storageKey = projectId ? "lastCustomColor_".concat(projectId) : 'lastCustomColor';
            var lastCustomColor = localStorage.getItem(storageKey);
            // Если нет сохраненного цвета, ищем последний цвет из существующих блоков
            var lastColor = lastCustomColor;
            if (!lastCustomColor) {
                lastColor = _this.props.posts.reduce(function (result, _a, index) {
                    var color = _a.color, style = _a.style;
                    if (style === 'link' && index < _this.props.num) {
                        return color;
                    }
                    return result;
                }, null);
            }
            // Если найден кастомный цвет (HEX), используем его, иначе используем черный по умолчанию
            var hex = lastColor && lastColor.startsWith('#') ? lastColor :
                _this.state.color === colorObj.white ? '#000000' : _this.state.color;
            _this.setState({
                color: hex,
                isTitleOpened: true,
                fontColor: _this.invertColor(hex, 'white', '#151514'),
                colorName: hex,
                isFirstLetter: false,
                text: "".concat(_this.state.text),
                firstLetter: '',
                style: 'link',
                prevColorStatus: hex,
                linkText: _this.state.linkText
            });
        };
        _this.handleSortedMultipleImgChange = function (list) {
            // console.log('multiLoadGroupState8', [...list])
            _this.setState({
                multiLoadGrouppedImg: __spreadArray([], list, true)
            });
        };
        _this.handleSortedProjects = function (projects) {
            _this.setState({
                projectIds: (projects === null || projects === void 0 ? void 0 : projects.map(function (project) { return project === null || project === void 0 ? void 0 : project.id; })) || []
            });
        };
        _this.handleSetCoursePresentation = function (projectId) {
            _this.setState({
                projectIds: [projectId]
            });
        };
        _this.handleDeleteProjects = function (deletedId) {
            var _a;
            var t = _this.props.t;
            if (!window.confirm(t('confirmation.project_block_item_delete')))
                return;
            _this.setState({
                projectIds: (_a = _this.state.projectIds) === null || _a === void 0 ? void 0 : _a.filter(function (id) { return id !== deletedId; })
            });
        };
        _this.updateFileList = function (fileName) {
            if (!_this.fileRef.current) {
                return;
            }
            var dt = new DataTransfer();
            if (!fileName) {
                _this.fileRef.current.files = dt === null || dt === void 0 ? void 0 : dt.files;
                return;
            }
            var currentFiles = Array.from(_this.fileRef.current.files);
            var newFiles = currentFiles.filter(function (f) { return f.name !== fileName; });
            newFiles.forEach(function (file) {
                dt.items.add(file);
            });
            var fileList = dt.files;
            _this.fileRef.current.files = fileList;
        };
        _this.handleImgRemove = function (id, name, needToConfirm) {
            var _a, _b, _c;
            var t = _this.props.t;
            if (needToConfirm) {
                if (!window.confirm(t('confirmation.image_delete')))
                    return;
            }
            var isEmpty = !((_b = (_a = _this.state.multiLoadGrouppedImg) === null || _a === void 0 ? void 0 : _a.filter(function (i) { return (i === null || i === void 0 ? void 0 : i.id) !== id; })) === null || _b === void 0 ? void 0 : _b.length);
            var isSpBlock = _this.state.style === 'super-puper-vote';
            var isSlider = _this.state.style === 'slider';
            _this.updateFileList(name);
            // console.log('multiLoadGroupState9', this.state.multiLoadGrouppedImg, this.state.multiLoadGrouppedImg?.filter(
            //   (i) => i?.id !== id
            // ))
            _this.setState({
                multiLoadGrouppedImg: (_c = _this.state.multiLoadGrouppedImg) === null || _c === void 0 ? void 0 : _c.filter(function (i) { return (i === null || i === void 0 ? void 0 : i.id) !== id; }),
                spVoteError: isSpBlock
            });
            if (_this.state.multiLoadGrouppedImg.length <= 1) {
                _this.setState({
                    style: 'normal'
                });
            }
            if (isEmpty && isSpBlock) {
                _this.setState({
                    multiLoadGrouppedImg: [],
                    multipleLoadSrc: [],
                    multipleLoadId: [],
                    spVoteError: false,
                });
                _this.uppy.cancelAll();
                _this.uppy.reset();
            }
        };
        _this.handleVideoButton = function () {
            // if (this.checkUnsavedData()) {
            //     this.setState({
            //       isUnsavedImages: true,
            //       prevStateValue: {
            //         style: 'video',
            //         color: '#FFFFFF',
            //         fontColor: '#151514',
            //         text: ''
            //       }
            //     })
            //   return;
            // }
            _this.setState({
                style: 'video',
                color: '#FFFFFF',
                fontColor: '#151514',
                text: ''
            });
        };
        _this.handleSlideTextChange = function (id, text, textPosition) {
            var _a;
            var isPositionUpdate = text === 'updatePosition';
            var index = (_a = _this.state.multiLoadGrouppedImg) === null || _a === void 0 ? void 0 : _a.findIndex(function (i) { return [i === null || i === void 0 ? void 0 : i.id, i === null || i === void 0 ? void 0 : i.postAttachmentId].includes(id); });
            var newArray = __spreadArray([], _this.state.multiLoadGrouppedImg, true);
            newArray[index] = __assign(__assign(__assign({}, newArray[index]), (isPositionUpdate ? {} : { text: text })), { textPosition: textPosition });
            // console.log('multiLoadGroupState10', newArray)
            _this.setState({
                multiLoadGrouppedImg: newArray
            });
        };
        _this.handleButtonLink = function () {
            _this.setState({
                secondaryStyle: _this.state.secondaryStyle === 'button-link' ? '' : 'button-link'
            });
        };
        _this.handleAnchorButton = function () {
            _this.setState({
                secondaryStyle: _this.state.secondaryStyle === 'button-anchor' ? '' : 'button-anchor'
            });
        };
        _this.handleAudioButton = function () {
            //   if (this.checkUnsavedData()) {
            //     this.setState({
            //       isUnsavedImages: true,
            //       prevStateValue: {
            //         style: 'audio',
            //         color: '#FFFFFF',
            //         fontColor: '#151514',
            //         text: ''
            //       }
            //     })
            //   return;
            // }
            _this.setState({
                style: 'audio',
                color: '#FFFFFF',
                fontColor: '#151514',
                text: ''
            });
        };
        _this.handleImageSources = function () {
            // if (this.checkUnsavedData()) {
            //   this.setState({
            //     isUnsavedImages: true,
            //     prevStateValue: {
            //       style: 'image_sources',
            //       color: '#FFFFFF',
            //       fontColor: '#151514',
            //     }
            //   })
            //   return;
            // }
            _this.setState({
                style: 'image_sources',
                color: '#FFFFFF',
                fontColor: '#151514'
            });
        };
        _this.handleBibliography = function () {
            // if (this.checkUnsavedData()) {
            //   this.setState({
            //     isUnsavedImages: true,
            //     prevStateValue: {
            //       style: 'bibliography',
            //       color: '#FFFFFF',
            //       fontColor: '#151514',
            //     }
            //   })
            //   return;
            // }
            _this.setState({
                style: 'bibliography',
                color: '#FFFFFF',
                fontColor: '#151514'
            });
        };
        _this.handleSPvote = function () {
            _this.setState({
                style: 'super-puper-vote',
                color: '#FFFFFF',
                fontColor: '#151514'
            });
        };
        _this.handleAddSlider = function () {
            // this.setState({
            //   style: 'slider',
            //   color: '#FFFFFF',
            //   fontColor: '#151514'
            // })
        };
        _this.handleAddTile = function () {
            _this.setState({ style: 'tile' });
        };
        _this.handleTogglePreviewer = function () {
            clearWidePreviewer();
        };
        _this.handleCardButton = function (type) {
            var _a = _this.props, modal = _a.modal, lgid = _a.lgid, num = _a.num, getLongReadPosts = _a.getLongReadPosts, setEditLongRead = _a.setEditLongRead, bookId = _a.bookId;
            modal.show('cardSelect', {
                themeColor: _this.props.colorStyle,
                onCardSelect: function (cardId) {
                    /*        urlApi()
                              .insertCard({
                                cardId,
                                longreadId: lgid,
                                position: num
                              })*/
                    /*          .then(() => {
                      if (bookId) urlApi().insertCardIntoBook({
                        cardId,
                        longreadId: lgid,
                        bookId: bookId
                      })
                    }) */
                    /*          .then(() => {
                                setTimeout(() => {
                                  getLongReadPosts('', lgid)
                                }, 1000)
                              })*/
                    // setEditLongRead(false, num)
                    modal.hide();
                    _this.setState({
                        additionalInfo: addOrChangeAdditionalInfo(_this.state.additionalInfo || [], [{ "name": CARDS_INFO_KEY, "value": JSON.stringify([{ cardId: cardId, isPay: false }]) }]),
                        style: type || 'card'
                    });
                }
            });
        };
        _this.handleProductsButton = function () {
            var _a = _this.props, modal = _a.modal, lgid = _a.lgid, num = _a.num, getLongReadPosts = _a.getLongReadPosts, setEditLongRead = _a.setEditLongRead, bookId = _a.bookId, teamId = _a.teamId;
            modal.show('productsSelect', {
                cardIds: getCardIdsFromAdditionalInfo(_this.state.additionalInfo, _this.state.cardIds),
                teamId: teamId,
                onSubmit: function (cardIds) {
                    modal.hide();
                    var additionalInfoUpdated = addOrChangeAdditionalInfo(_this.state.additionalInfo || [], [{ "name": CARDS_INFO_KEY, "value": JSON.stringify(cardIds === null || cardIds === void 0 ? void 0 : cardIds.map(function (cardId) { return ({ cardId: cardId, isPay: false }); })) }]);
                    var cardIdsUpdated = getCardIdsFromAdditionalInfo(additionalInfoUpdated, _this.state.cardIds);
                    _this.setState({
                        additionalInfo: additionalInfoUpdated,
                        cardIds: cardIdsUpdated,
                        style: 'products'
                    });
                }
            });
        };
        _this.handleProductsChange = function (cardIds) {
            var additionalInfoUpdated = addOrChangeAdditionalInfo(_this.state.additionalInfo || [], [{ "name": CARDS_INFO_KEY, "value": JSON.stringify(cardIds === null || cardIds === void 0 ? void 0 : cardIds.map(function (cardId) { return ({ cardId: cardId, isPay: false }); })) }]);
            var cardIdsUpdated = getCardIdsFromAdditionalInfo(additionalInfoUpdated, _this.state.cardIds);
            _this.setState({
                additionalInfo: additionalInfoUpdated,
                cardIds: cardIdsUpdated
            });
        };
        _this.handleProjects = function () {
            var _a;
            var _b = _this.props, maxProjects = _b.maxProjects, teamContexts = _b.teamContexts, teamExtraFilter = _b.teamExtraFilter, isPresentation = _b.isPresentation, onOpenSetProjectsModal = _b.onOpenSetProjectsModal;
            onOpenSetProjectsModal({
                maxProjects: maxProjects,
                teamContexts: teamContexts,
                teamExtraFilter: teamExtraFilter,
                isPresentation: isPresentation,
                alreadyProjects: ((_a = _this.state) === null || _a === void 0 ? void 0 : _a.projectIds) || [],
                onSelectProjects: function (projectIds) {
                    _this.setState({
                        style: 'projects',
                        projectIds: projectIds || []
                    });
                }
            });
        };
        _this.handleAddSpecialTools = function () {
            _this.setState({
                style: 'special-tools'
            });
        };
        _this.handleAddForms = function () {
            _this.setState({
                style: 'forms'
            });
        };
        _this.setCaption = function (value) {
            _this.setState({
                text: '',
                imageCaption: value,
                editingCaption: false,
                postTextPos: 'caption-bottom'
            });
        };
        _this.handleCaptionButton = function (position) {
            if (_this.state.style === 'two_pictures') {
                _this.setState({
                    editingCaption: true
                });
            }
            else if (_this.state.style === 'slider') {
                _this.setState({
                    editingCaption: true,
                    multiLoadCaptionMode: 'small'
                });
            }
            else if (_this.state.style === 'as_cover') {
                _this.setState({
                    editingCaption: true,
                    // postTextPos: 'inside'
                    postTextPos: position
                });
            }
            else if (_this.state.style === 'projects') {
                _this.setState({
                    editingCaption: true
                });
            }
            else {
                _this.setState({
                    style: 'image',
                    editingCaption: true,
                    postTextPos: 'caption-bottom'
                });
            }
        };
        _this.handleTextButton = function (position) {
            if (_this.state.style === 'slider') {
                _this.setState(function (_a) {
                    var editingText = _a.editingText;
                    return ({
                        editingText: !editingText,
                        editingCaption: false,
                        multiLoadCaptionMode: 'big',
                        postTextPos: position
                    });
                });
            }
            else if (_this.state.style === 'as_cover') {
                _this.setState({
                    editingText: true,
                    postTextPos: 'outside'
                });
            }
            else {
                _this.setState({
                    style: 'big',
                    postTextPos: position,
                    // imageCaption: ''
                });
            }
        };
        _this.handleClose = function () {
            var _a;
            var isPresentatiton = _this.props.isPresentation;
            var isColored = _this.state.style === 'colored' || _this.state.style === 'link';
            var isText = (_a = ['normal', 'normal_card', 'normal_image', 'normal_emblem']) === null || _a === void 0 ? void 0 : _a.includes(_this.state.style);
            var firstAsCoverSetted = _this.props.firstAsCover && _this.state.style === 'as_cover';
            if (isPresentatiton) {
                _this.updateFileList();
            }
            if (!isColored && !isText) {
                _this.onBlueArea();
            }
            _this.setState(__assign({ style: firstAsCoverSetted ? 'as_cover' : '', multiLoadGrouppedImg: [], multipleLoadSrc: [], multipleLoadId: [], firstOfCoverLoad: false, imageId: '', imageCaption: '', prevImageSrc: '', audioSrc: '', bigImageSrc: '', isColorChoose: false, isUnsavedImages: false, text: '', title: '', iframeLink: '' }, (_this.props.isFeed ? { isFocused: false } : {})
            // formPosition: FORM_CENTER_POS
            ));
            if (_this.props.isFeed) {
                document.body.classList.remove('opened__editor');
            }
            _this.props.toggleMobileEditor && _this.props.toggleMobileEditor(false);
            _this.uppy.reset();
        };
        _this.handleToggleUnsavedModal = function (val, prevStyle) {
            var prevValue = _this.state.prevStateValue;
            if (val) {
                _this.setState({
                    isUnsavedImages: false,
                });
                return;
            }
            // this.setState({
            //   isUnsavedImages: true,
            //   ...this.getClearedImageData(),
            //   ...prevValue,
            //   prevStateValue: null
            // })
            _this.handleClose();
        };
        _this.handleUnsavedChange = function () {
            if (IMAGES_STYLES.includes(_this.state.style)) {
                _this.setState({
                    isUnsavedImages: true,
                });
                return;
            }
            _this.handleClose();
        };
        _this.handleAnchorChange = function (text) {
            _this.setState({
                anchorText: text
            });
        };
        _this.removeImage = function () {
            _this.setState({
                imageId: '',
                imageCaption: '',
                prevImageSrc: '',
                bigImageSrc: ''
            });
            _this.uppy.reset();
        };
        _this.invertColor = function (bgColor, lightColor, darkColor) {
            var color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
            var r = parseInt(color.substring(0, 2), 16); // hexToR
            var g = parseInt(color.substring(2, 4), 16); // hexToG
            var b = parseInt(color.substring(4, 6), 16); // hexToB
            return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? darkColor : lightColor;
        };
        _this.chooseColor = function (color, isUserColor, hex) {
            // пост меняется на обычный если выбран белый цвет, не знаю, нужно ли еще, пока убрали, т.к. сбивает с толку
            // if ( 
            //   color === 'white' ||
            //   (isUserColor && (this.state.style !== 'colored' || this.state.style !== 'link')  && hex.toLowerCase() === '#FEFEFE'.toLowerCase())
            // ) {
            //   this.setState({
            //     color: colorObj[color],
            //     isTitleOpened: false,
            //     fontColor: colorObj.fonts[color],
            //     colorName: color,
            //     style: 'normal',
            //     prevColorStatus: color
            //     // multipleLoadId: [],
            //     // multipleLoadSrc: []
            //   })
            // } else 
            var calcStyle = _this.state.style === 'link' ? 'link' :
                _this.state.style === 'annotation' ? 'annotation' : 'colored';
            if (isUserColor && _this.state.style === "link") {
                if (hex && hex.startsWith('#')) {
                    var projectId = _this.props.projectId || _this.props.lgid;
                    var storageKey = projectId ? "lastCustomColor_".concat(projectId) : 'lastCustomColor';
                    localStorage.setItem(storageKey, hex);
                }
                _this.setState({
                    color: hex,
                    isTitleOpened: true,
                    fontColor: _this.invertColor(hex, 'white', '#151514'),
                    colorName: hex,
                    isFirstLetter: false,
                    text: "".concat(_this.state.text),
                    firstLetter: '',
                    style: calcStyle,
                    prevColorStatus: hex,
                    linkText: _this.state.linkText
                });
            }
            else if (isUserColor) {
                if (hex && hex.startsWith('#')) {
                    var projectId = _this.props.projectId || _this.props.lgid;
                    var storageKey = projectId ? "lastCustomColor_".concat(projectId) : 'lastCustomColor';
                    localStorage.setItem(storageKey, hex);
                }
                _this.setState({
                    color: hex,
                    isTitleOpened: true,
                    fontColor: _this.invertColor(hex, 'white', '#151514'),
                    colorName: hex,
                    isFirstLetter: false,
                    text: "".concat(_this.state.text),
                    firstLetter: '',
                    style: calcStyle,
                    prevColorStatus: hex
                    // multipleLoadId: [],
                    // multipleLoadSrc: []
                });
            }
            else {
                _this.setState({
                    color: colorObj[color],
                    isTitleOpened: true,
                    fontColor: colorObj.fonts[color],
                    colorName: color,
                    isFirstLetter: false,
                    text: "".concat(_this.state.text),
                    firstLetter: '',
                    style: calcStyle,
                    prevColorStatus: color
                    // multipleLoadId: [],
                    // multipleLoadSrc: []
                });
            }
        };
        _this.handleTextareaFocus = function (e) {
            var _a, _b, _c, _d;
            if (_this.state.secondaryStyle !== '')
                return false;
            var defaultTA = (_b = (_a = _this.textareaRef.current) === null || _a === void 0 ? void 0 : _a.firstChild) === null || _b === void 0 ? void 0 : _b.firstChild;
            defaultTA && defaultTA.focus();
            if (!_this.state.useRating) {
                var coloredTA = (_d = (_c = _this.coloredTextareaRef.current) === null || _c === void 0 ? void 0 : _c.firstChild) === null || _d === void 0 ? void 0 : _d.firstChild;
                coloredTA && coloredTA.focus();
            }
        };
        _this.onColoredTextareaResize = function (e) {
            var _a, _b, _c, _d;
            var height = e.target.offsetHeight;
            var htmlValue = e.target.value;
            var textLength = (_a = e.target.value) === null || _a === void 0 ? void 0 : _a.length;
            var linkProjectId = extractProjectId(htmlValue);
            var maxLengthRules = ((_b = ['annotation', 'block_with_title']) === null || _b === void 0 ? void 0 : _b.includes(_this.state.style)) ? 75 : 800;
            var calcStyle = ((_c = ['annotation', 'block_with_title']) === null || _c === void 0 ? void 0 : _c.includes(_this.state.style)) ?
                _this.state.style : 'normal';
            var calcValue = ((_d = ['annotation', 'block_with_title']) === null || _d === void 0 ? void 0 : _d.includes(_this.state.style)) ?
                htmlValue === null || htmlValue === void 0 ? void 0 : htmlValue.substring(0, maxLengthRules) : htmlValue;
            _this.setState({
                text: calcValue,
                linkProjectId: linkProjectId,
            }, function () {
                if (textLength > maxLengthRules) {
                    _this.props.toasts.error("\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0434\u043B\u0438\u043D\u0430: ".concat(maxLengthRules, " \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432"));
                    _this.setState({
                        text: e.target.value.substring(0, 2400),
                        color: colorObj.white,
                        isTitleOpened: false,
                        fontColor: colorObj.fonts.white,
                        isTextTooBig: true,
                        isColorChoose: false,
                        prevColorStatus: _this.state.colorName,
                        colorName: 'white',
                        style: calcStyle
                    });
                }
            });
            if (textLength > maxLengthRules) {
                setTimeout(function () {
                    return _this.setState({
                        color: colorObj.white,
                        isTitleOpened: false,
                        fontColor: colorObj.fonts.white,
                        isTextTooBig: true,
                        isColorChoose: false,
                        prevColorStatus: _this.state.colorName,
                        colorName: 'white',
                        style: calcStyle
                    });
                });
                // setTimeout(() => this.standartTA.current.focusTextInput(), 1000)
            }
            setTimeout(function () { return _this.setSizes(); });
        };
        _this.onCaptionChange = function (e) {
            var height = e.target.offsetHeight;
            var htmlValue = e.target.value.substring(0, 800);
            var textLength = e.target.value;
            var linkProjectId = extractProjectId(htmlValue);
            _this.setState({
                caption: htmlValue,
            }, function () {
                if (textLength > 800) {
                    _this.props.toasts.error('Максимальная длина: 800 символов');
                }
            });
        };
        _this.onLinkResize = function (e) {
            var height = e.target.offsetHeight;
            _this.setState({
                text: e.target.value
            }, function () {
                if (_this.state.text.length > 200) {
                    _this.props.toasts.error('Максимальная длина: 200 символов');
                    _this.setState({
                        text: e.target.value.substring(0, 200),
                        color: colorObj.white,
                        isTitleOpened: false,
                        fontColor: colorObj.fonts.white,
                        isTextTooBig: true,
                        isColorChoose: false,
                        prevColorStatus: _this.state.colorName,
                        colorName: 'white',
                        style: 'normal',
                        linkText: _this.state.linkText
                    });
                }
            });
            if (_this.state.text.length > 200) {
                setTimeout(function () {
                    return _this.setState({
                        color: colorObj.white,
                        isTitleOpened: false,
                        fontColor: colorObj.fonts.white,
                        isTextTooBig: true,
                        isColorChoose: false,
                        prevColorStatus: _this.state.colorName,
                        colorName: 'white',
                        style: 'normal'
                    });
                });
            }
            setTimeout(function () { return _this.setSizes(); });
        };
        _this.handleSetLink = function (link) {
            var linkProjectId = extractProjectId(link);
            _this.setState({ linkText: link, linkProjectId: linkProjectId });
        };
        _this.onSourcesTextareaChange = function (e) {
            onChangeBibliography(e, _this.state.style, function (val) { return _this.props.toasts.error(val); }, function (val) { return _this.setState(val); });
        };
        _this.onSourcesTextareaKeyUp = function (e) {
            _this.setState(function (prevState) { return (__assign(__assign({}, prevState), { text: modifyToListText(prevState.text, e) })); });
        };
        _this.onStandartTextareaChange = function (e) {
            var linkProjectId = extractProjectId(e.target.value);
            if (e.target.value.length < 2400) {
                _this.setState({
                    text: e.target.value,
                    linkProjectId: linkProjectId
                });
            }
            if (e.target.value.length >= 2400) {
                _this.props.toasts.error('Максимальная длина: 2400 символов');
                _this.setState({
                    text: e.target.value.substring(0, 2400)
                }, function () {
                    if (_this.state.text.length >= 2400) {
                        _this.setState({
                            text: e.target.value.substring(0, 2400)
                        });
                    }
                });
            }
            if (_this.state.text.length < 50) {
                _this.setState({
                    isFirstLetter: false,
                    text: "".concat(e.target.value),
                    firstLetter: ''
                });
            }
        };
        _this.escFunction = function (event) {
            if (event.keyCode === 27) {
                _this.onBlueArea(event);
            }
        };
        _this.setSizes = function () {
            var innerWidth = window.innerWidth;
            // отступ цветного блока
            if (_this.coloredTA.current !== null) {
                var textHeight = _this.coloredTA.current.offsetHeight;
                _this.setPaddings(textHeight, innerWidth);
            }
        };
        _this.setPaddings = function (textHeight, innerWidth) {
            var paddingsCurrent, heightsCurrent, calculatedHeightStyle;
            // проверяем ширину экрана
            if (innerWidth > MEDIA_QUERY) {
                paddingsCurrent = paddings.max;
                heightsCurrent = heights.max;
            }
            else {
                paddingsCurrent = paddings.min;
                heightsCurrent = heights.min;
            }
            // выставляем нужный паддинг
            calculatedHeightStyle = Math.round(textHeight / heightsCurrent);
            if (calculatedHeightStyle >= 4) {
                calculatedHeightStyle = 4;
            }
            _this.setState({
                coloredPadding: paddingsCurrent[calculatedHeightStyle]
            });
        };
        _this.handleTogglePostLikes = function (useRating) {
            _this.setState({ useRating: useRating });
        };
        _this.handleToggleRatingDataChange = function (val, ev) {
            var _a;
            var _b;
            var target = ev.target;
            var value = val;
            var key = (_b = target === null || target === void 0 ? void 0 : target.dataset) === null || _b === void 0 ? void 0 : _b['key'];
            var data = _this.state.ratings;
            data = {
                custom: __assign(__assign(__assign({}, INITIAL_RAITING), data.custom), (_a = {}, _a[key === 'name' ? 'name' : 'value'] = (key === 'name' ? value
                    : Number(value)), _a))
            };
            _this.setState({ ratings: data });
        };
        _this.onChangeImage = function (event, index) { return __awaiter(_this, void 0, void 0, function () {
            var _a, toasts, profile, files, appName, allowed, _b;
            var _this = this;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.props, toasts = _a.toasts, profile = _a.profile;
                        files = (_c = Array.from(event.target.files)) === null || _c === void 0 ? void 0 : _c.slice(0, 1);
                        appName = getAppNameFromAppString(this.props.appName);
                        _b = ['geograffee', 'deziiign', 'competition'].includes(appName);
                        if (!_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, uploadValidator({
                                files: files,
                                toasts: toasts,
                                profile: profile,
                                style: 'two_pictures'
                            })];
                    case 1:
                        _b = (_d.sent());
                        _d.label = 2;
                    case 2:
                        allowed = _b;
                        // console.log('onChangeIMAGE', '|', event, '|', index, '|', files, '|', event.target.files, '|', allowed, [...this.state.multiLoadGrouppedImg])
                        if (!allowed) {
                            event.target.value = '';
                            return [2 /*return*/];
                        }
                        this.uppy.reset();
                        files.forEach(function (file, i) {
                            var fr = new FileReader();
                            try {
                                _this.uppy.addFile({
                                    source: 'file input',
                                    name: file.name,
                                    type: file.type || 'application/octet-stream',
                                    data: file,
                                    meta: {
                                        contentType: file.type || 'application/octet-stream'
                                    }
                                });
                            }
                            catch (err) {
                                if (err.isRestriction) {
                                    // handle restrictions
                                    console.error('Restriction error:', err);
                                }
                                else {
                                    // handle other errors
                                    console.error(err);
                                }
                            }
                            fr.onload = function () {
                                var _a;
                                var newImg = (_a = __spreadArray([], _this.state.multiLoadGrouppedImg, true)) === null || _a === void 0 ? void 0 : _a.filter(function (img) {
                                    return (img === null || img === void 0 ? void 0 : img.name) != (file === null || file === void 0 ? void 0 : file.name);
                                    // return img.id
                                    // const nameMatch = !img.id && file.name
                                    // return img?.name != nameMatch
                                });
                                // const itemToStay = [...this.state.multiLoadGrouppedImg].find(img => img?.name != file?.name)
                                var replacedImg = newImg.find(function (img) { return (img === null || img === void 0 ? void 0 : img.name) === (file === null || file === void 0 ? void 0 : file.name); });
                                // console.log('newImg', newImg, this.state.multiLoadGrouppedImg, newImg[index])
                                var newItem = __assign(__assign({}, replacedImg), { name: file.name, isUploaded: false, files: undefined, progress: 0, src: fr.result });
                                // newImg[index] = {
                                //   ...newImg[index],
                                //   name: file.name,
                                //   isUploaded: false,
                                //   files: undefined,
                                //   progress: 0,
                                //   src: fr.result
                                // }
                                if (newImg.length > 1) {
                                    newImg[index] = newItem;
                                }
                                else {
                                    if (index === 0) {
                                        newImg.unshift(newItem);
                                    }
                                    if (index === 1) {
                                        newImg.push(newItem);
                                    }
                                }
                                // console.log('newImg multiLoadGroupState11', newImg, this.state, index, file)
                                _this.setState({
                                    multiLoadGrouppedImg: newImg
                                });
                            };
                            fr.readAsDataURL(file);
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.addFile = function (event, style, droppedFiles) { return __awaiter(_this, void 0, void 0, function () {
            var _a, toasts, profile, appName, isSPvote, isSlider, isCover, isTwoPictures, isPodcast, isEmblem, isAdditionalMultiLoad, files, multipleFilesCheckResult, fr_1;
            var _this = this;
            var _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = this.props, toasts = _a.toasts, profile = _a.profile;
                        appName = getAppNameFromAppString(this.props.appName);
                        isSPvote = style === 'super-puper-vote';
                        isSlider = (_b = ['slider', 'tile']) === null || _b === void 0 ? void 0 : _b.includes(style);
                        isCover = style === 'as_cover';
                        isTwoPictures = style === 'two_pictures';
                        isPodcast = style === 'podcast';
                        isEmblem = style === 'normal_emblem';
                        isAdditionalMultiLoad = !!((_c = this.state.multiLoadGrouppedImg) === null || _c === void 0 ? void 0 : _c.length) || isSlider;
                        multipleFilesCheckResult = [];
                        if (event === null) {
                            files = droppedFiles;
                        }
                        else {
                            files = isPodcast ? (_d = Array.from(event.target.files)) === null || _d === void 0 ? void 0 : _d.slice(0, 1) : Array.from(event.target.files);
                        }
                        if ((isSPvote || isTwoPictures) && ((files === null || files === void 0 ? void 0 : files.length) === 1 || (files === null || files === void 0 ? void 0 : files.length) > 2)) {
                            if ((files === null || files === void 0 ? void 0 : files.length) < 2) {
                                toasts.error('Выберите два изображения');
                            }
                            if ((files === null || files === void 0 ? void 0 : files.length) > 2) {
                                toasts.error('Максимальное количество изображений - 2');
                            }
                            this.setState({
                                spVoteError: true
                            });
                            return [2 /*return*/];
                        }
                        if (!((files === null || files === void 0 ? void 0 : files.length) > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all(files.map(function (img) { return __awaiter(_this, void 0, void 0, function () {
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            _a = ['geograffee', 'deziiign', 'competition'].includes(appName);
                                            if (!_a) return [3 /*break*/, 2];
                                            return [4 /*yield*/, uploadValidator({
                                                    files: [img],
                                                    toasts: toasts,
                                                    isWideImageType: isCover,
                                                    profile: profile,
                                                    style: style
                                                })];
                                        case 1:
                                            _a = (_b.sent());
                                            _b.label = 2;
                                        case 2: return [2 /*return*/, (_a)];
                                    }
                                });
                            }); }))];
                    case 1:
                        multipleFilesCheckResult = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (multipleFilesCheckResult === null || multipleFilesCheckResult === void 0 ? void 0 : multipleFilesCheckResult.includes(false)) {
                            event.target.value = '';
                            return [2 /*return*/];
                        }
                        files.sort(function (a, b) {
                            var fileNameA = a.name[0];
                            var fileNameB = b.name[0];
                            return +fileNameB - +fileNameA;
                        });
                        // случай для одного загруженного файла, все как обычно
                        if (files.length === 1 && !isAdditionalMultiLoad) {
                            fr_1 = new FileReader();
                            this.uppy.reset();
                            this.setState({
                                multiLoadGrouppedImg: [],
                                multipleLoadSrc: [],
                                multipleLoadId: [],
                                firstOfCoverLoad: true,
                                isLoading: true,
                                style: style
                            });
                            files.forEach(function (file) {
                                try {
                                    _this.uppy.addFile({
                                        source: 'file input',
                                        name: file.name,
                                        type: file.type || 'application/octet-stream',
                                        data: file,
                                        meta: {
                                            contentType: file.type || 'application/octet-stream'
                                        }
                                    });
                                }
                                catch (err) {
                                    if (err.isRestriction) {
                                        // handle restrictions
                                        console.error('Restriction error:', err);
                                    }
                                    else {
                                        // handle other errors
                                        console.error(err);
                                    }
                                }
                                fr_1.onload = function () {
                                    var _a;
                                    if (style === 'small') {
                                        _this.setState({
                                            prevImageSrc: fr_1.result
                                        });
                                    }
                                    if (isPodcast) {
                                        _this.setState({
                                            text: ((_a = files[0]) === null || _a === void 0 ? void 0 : _a.name) || '',
                                            audioSrc: fr_1.result,
                                            firstOfCoverLoad: false
                                        });
                                    }
                                    if (style === 'big' || style === 'image' || style === 'as_cover' || style === 'normal_image' || style === 'normal_emblem') {
                                        _this.setState({
                                            bigImageSrc: fr_1.result,
                                            style: style,
                                            isColorChoose: true,
                                            firstOfCoverLoad: false
                                        });
                                    }
                                };
                                fr_1.readAsDataURL(files[0]);
                            });
                        }
                        // случай для нескольких загруженных файлов, отрефакторить как время будет
                        if (files.length > 1 || isAdditionalMultiLoad) {
                            if ((files === null || files === void 0 ? void 0 : files.length) > MAX_FILES_COUNT) {
                                this.props.toasts.error('Максимальное количество изображений 15');
                                return [2 /*return*/];
                            }
                            this.uppy.reset();
                            if (this.state.imageId && isSlider) {
                                // console.log('multiLoadGroupState12', ...this.state.multiLoadGrouppedImg, {
                                //   caption: "",
                                //   id: this.state.imageId,
                                //   isCaptionSetted: false,
                                //   isTextSetted: false,
                                //   isUploaded: true,
                                //   name: "",
                                //   src: this.state.prevImageSrc || this.state.bigImageSrc,
                                //   progress: 100
                                // })
                                this.setState({
                                    bigImageSrc: '',
                                    prevImageSrc: '',
                                    imageId: '',
                                    multiLoadGrouppedImg: __spreadArray([{
                                            caption: "",
                                            id: this.state.imageId,
                                            isCaptionSetted: false,
                                            isTextSetted: false,
                                            isUploaded: true,
                                            name: "",
                                            src: this.state.prevImageSrc || this.state.bigImageSrc,
                                            progress: 100
                                        }], this.state.multiLoadGrouppedImg, true),
                                    multipleLoadSrc: __spreadArray([this.state.prevImageSrc || this.state.bigImageSrc], this.state.multipleLoadSrc, true),
                                    multipleLoadId: [],
                                    spVoteError: false,
                                    style: isSPvote || isSlider || isTwoPictures ? style : 'multiple'
                                });
                            }
                            else {
                                this.setState({
                                    bigImageSrc: '',
                                    // multiLoadGrouppedImg: [],
                                    multipleLoadSrc: [],
                                    multipleLoadId: [],
                                    spVoteError: false,
                                    style: isSPvote || isSlider || isTwoPictures ? style : 'multiple'
                                });
                            }
                            files.forEach(function (file, i) {
                                var fr = new FileReader();
                                try {
                                    _this.uppy.addFile({
                                        source: 'file input',
                                        name: file.name,
                                        type: file.type || 'application/octet-stream',
                                        data: file,
                                        meta: {
                                            contentType: file.type || 'application/octet-stream'
                                        }
                                    });
                                }
                                catch (err) {
                                    if (err.isRestriction) {
                                        // handle restrictions
                                        console.error('Restriction error:', err);
                                    }
                                    else {
                                        // handle other errors
                                        console.error(err);
                                    }
                                }
                                fr.onload = function () {
                                    var _a;
                                    var copiedState = __spreadArray([], _this.state.multipleLoadSrc, true);
                                    var total = copiedState.push(fr.result);
                                    /* Добавляем base64 src */
                                    var grouppedImg = __spreadArray([], _this.state.multiLoadGrouppedImg, true);
                                    var newImg = (_a = __spreadArray([], _this.state.multiLoadGrouppedImg, true)) === null || _a === void 0 ? void 0 : _a.map(function (img) {
                                        if ((img === null || img === void 0 ? void 0 : img.name) === (file === null || file === void 0 ? void 0 : file.name)) {
                                            return __assign(__assign({}, img), { src: fr.result });
                                        }
                                        return img;
                                    });
                                    // console.log('multiLoadGroupState13', newImg)
                                    _this.setState({
                                        multipleLoadSrc: copiedState,
                                        multiLoadGrouppedImg: newImg
                                        // imageId: 'multiple',
                                    });
                                };
                                fr.readAsDataURL(file);
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.closeChooser = function () {
            _this.setState({
                isColorChoose: false,
                isTitleOpened: false,
                fontColor: colorObj.fonts.white,
                color: colorObj.white,
                colorName: 'white',
                style: 'normal',
                prevColorStatus: 'white'
            });
        };
        _this.onFocusArea = function (e) {
            e.target.setSelectionRange(e.target.value.length, e.target.value.length);
            _this.setState({
                isFocused: true
            });
            _this.props.setEditLongRead(true, _this.props.num);
            if (_this.wrapRef.current !== null) {
                _this.wrapRef.current.scrollIntoView({ block: 'center' });
            }
            var isFirstCover = _this.props.firstAsCover;
            var blocksLength = _this.props.blocksLength;
            // todo use styled components
            if (!isFirstCover && blocksLength > 0) {
                document.body.classList.add('opened__editor');
            }
        };
        _this.handleTileViewTypeChange = function (type) {
            _this.setState({
                tileViewType: type
            });
        };
        _this.handleTextPositionChange = function (text, position) {
            var isEmpty = !(text === null || text === void 0 ? void 0 : text.length);
            if (position === 'caption-bottom') {
                _this.setState({
                    imageCaption: text,
                    text: ''
                });
            }
            else {
                _this.setState({
                    text: text,
                    postTextPos: isEmpty ? '' : position,
                    imageCaption: ''
                });
            }
        };
        _this.handleSlideChecked = function (checked) {
            _this.setState({
                isRibbon: checked
            });
        };
        _this.handleChangeAdditionalStyle = function () {
            _this.setState({ secondaryStyle: '' });
        };
        _this.handleTitleBlock = function () {
            _this.setState({ style: 'block_with_title' });
        };
        _this.onBlueArea = function (e) {
            _this.setState({
                isFocused: false,
                style: 'normal'
            });
            if (_this.props.blocksLength === 0) {
                _this.props.setChooserEditor();
            }
            _this.setState({ animation: 'out' });
            _this.animationTimeout = setTimeout(function () {
                _this.props.setEditLongRead(false, -1);
            }, 500);
            setTimeout(function () {
                document.body.classList.remove('opened__editor');
            }, 0);
        };
        _this.addText = function (e) {
            if (e.target.value.length < 300) {
                _this.setState({
                    text: e.target.value,
                    imageCaption: ''
                });
            }
            if (e.target.value.length >= 300) {
                _this.setState({
                    text: e.target.value.substring(0, 298),
                    imageCaption: ''
                }, function () {
                    if (_this.state.text.length >= 300) {
                        _this.setState({
                            text: e.target.value.substring(0, 298),
                            imageCaption: ''
                        });
                    }
                });
            }
        };
        _this.state = {
            text: '',
            title: '',
            caption: '',
            editingCaption: false,
            postTextPos: 'inside',
            addButtonsOpened: false,
            color: colorObj.white,
            fontColor: colorObj.fonts.white,
            colorName: 'white',
            isColorChoose: false,
            isTitleOpened: false,
            tileViewType: TileViewType.twoRow,
            imageId: '',
            imageCaption: '',
            prevImageSrc: '',
            audioSrc: '',
            bigImageSrc: '',
            style: '',
            secondaryStyle: '',
            isTextTooBig: false,
            prevColorStatus: 'white',
            isFirstLetter: false,
            firstLetter: '',
            isLoading: false,
            isFocused: false,
            isRibbon: false,
            linkProjectId: '',
            coloredPadding: 57,
            multipleLoadId: [],
            multipleLoadSrc: [],
            multiLoadisStart: false,
            multiLoadPosition: 0,
            multiLoadCaptionMode: '',
            multiLoadGrouppedImg: [],
            projectIds: [],
            isMultiLoad: false,
            isMultipleFetchStart: false,
            animation: 'in',
            isUnsavedImages: false,
            prevStateValue: null,
            isTest: false,
            imagesUploaded: null,
            firstOfCoverLoad: false,
            spVoteError: false,
            formId: '',
            formPosition: FORM_CENTER_POS,
            anchorText: '',
            iframeLink: '',
            linkText: '',
            buttons: [],
            lessonPostDisabled: true,
            cardIds: [],
            useRating: false,
            ratings: {
            // like: {
            //   name: [{lang: 'ru', name: 'Официальный рейтинг'}, {lang: 'en', name: 'Official rating'}],
            //   value: 0
            // }
            },
            onLessonSave: function () { }
        };
        _this.fileRef = React.createRef();
        _this.standartTA = React.createRef();
        _this.bigimageRef = React.createRef();
        _this.coloredTA = React.createRef();
        _this.wrapRef = React.createRef();
        _this.overlayRef = React.createRef();
        _this.textareaRef = React.createRef();
        _this.coloredTextareaRef = React.createRef();
        // потом возможно в отдельную сущность вынести
        _this.uppy = new Uppy({
            restrictions: { maxNumberOfFiles: MAX_FILES_COUNT },
            allowMultipleUploads: true,
            meta: { type: 'image/jpeg' },
            autoProceed: true,
            onBeforeUpload: function (files) {
                var _a, _b, _c;
                var isSlider = _this.state.style === 'slider';
                var isTile = _this.state.style === 'tile';
                var isTwoPictures = _this.state.style === 'two_pictures';
                var total = (_a = _this.state.multiLoadGrouppedImg) === null || _a === void 0 ? void 0 : _a.length;
                var maxFiles = isTwoPictures ? 2 : isTile ? 9 : MAX_FILES_COUNT;
                var isMaxFilesCount = (isSlider || isTile || (isTwoPictures && !((_b = _this.state.multiLoadGrouppedImg) === null || _b === void 0 ? void 0 : _b.length))) && total > maxFiles;
                if (isMaxFilesCount) {
                    _this.props.toasts.error("\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E ".concat(isSlider ? 'cлайдов' : 'изображений', " - ").concat(maxFiles));
                    // console.log('multiLoadGroupState1', [...this.state.multiLoadGrouppedImg].slice(0, maxFiles), this.state.multiLoadGrouppedImg, maxFiles)
                    _this.setState({
                        multiLoadGrouppedImg: __spreadArray([], _this.state.multiLoadGrouppedImg, true).slice(0, maxFiles)
                    });
                }
                if (((_c = Object.keys(files)) === null || _c === void 0 ? void 0 : _c.length) > 1) {
                    var isSPvote = _this.state.style === 'super-puper-vote';
                    _this.setState({
                        style: isSPvote
                            ? 'super-puper-vote'
                            : isSlider
                                ? 'slider'
                                : isTile
                                    ? 'tile'
                                    : _this.state.style === 'two_pictures'
                                        ? 'two_pictures'
                                        : 'multiple',
                        isMultiLoad: true
                    });
                }
            }
        })
            .use(Tus, {
            endpoint: "".concat(Endpoints.uploader, "/upload/"),
            chunkSize: 4194304
        })
            .use(FileInput, {
            target: _this.fileRef.current,
            id: 'fileRef',
            pretty: true,
            inputName: 'files[]',
            locale: {}
        })
            .use(FileInput, {
            target: _this.bigimageRef.current,
            id: 'bigimage',
            pretty: true,
            inputName: 'files[]',
            locale: {}
        });
        _this.uppy.on('file-added', function (file) {
            var _a;
            var isMultipleLoad = ['multiple', 'super-puper-vote', 'slider', 'two_pictures', 'tile'].includes(_this.state.style)
                || !!((_a = _this.state.multiLoadGrouppedImg) === null || _a === void 0 ? void 0 : _a.length);
            /* Добавляем имя и дополнительные поля */
            if (isMultipleLoad) {
                var result = [];
                result.push.apply(result, __spreadArray(__spreadArray([], _this.state.multiLoadGrouppedImg, false), [{
                        name: file === null || file === void 0 ? void 0 : file.name,
                        isUploaded: false,
                        caption: '',
                        isCaptionSetted: false,
                        text: '',
                        isTextSetted: false,
                        progress: 0,
                    }], false));
                // console.log('multiLoadGroupState2', result)
                _this.setState({
                    multiLoadGrouppedImg: result
                });
            }
        });
        _this.uppy.on('upload-progress', function (file, progress) {
            var _a;
            if (_this.state.isMultiLoad) {
                var uppyState_1 = (_a = _this.uppy.getState()) === null || _a === void 0 ? void 0 : _a.files;
                setTimeout(function () {
                    var _loop_1 = function (key) {
                        var name_1 = uppyState_1[key].name;
                        var progress_1 = uppyState_1[key].progress.percentage;
                        /* Добавляем проценты прогресса */
                        // console.log(`PROGRESS FOR ${name} ->  ${progress}`)
                        var result = __spreadArray([], _this.state.multiLoadGrouppedImg, true).map(function (i) {
                            var isUploaded = (i === null || i === void 0 ? void 0 : i.progress) === 100;
                            if (isUploaded) {
                                return i;
                            }
                            if ((i === null || i === void 0 ? void 0 : i.name) === name_1) {
                                return __assign(__assign({}, i), { progress: progress_1 });
                            }
                            return i;
                        });
                        // console.log('multiLoadGroupState3', result)
                        _this.setState({
                            multiLoadGrouppedImg: result
                        });
                    };
                    for (var key in uppyState_1) {
                        _loop_1(key);
                    }
                }, 1500);
            }
        });
        _this.uppy.on('upload-success', function (file, response) {
            var _a;
            var isSuccess = ((_a = response === null || response === void 0 ? void 0 : response.uploadURL) === null || _a === void 0 ? void 0 : _a.length) > 1;
            setTimeout(function () {
                if (isSuccess) {
                    /* Добавляем поле об успешном добавлении */
                    var result = __spreadArray([], _this.state.multiLoadGrouppedImg, true).map(function (i) {
                        if ((i === null || i === void 0 ? void 0 : i.name) === (file === null || file === void 0 ? void 0 : file.name)) {
                            return __assign(__assign({}, i), { isUploaded: true });
                        }
                        return i;
                    });
                    // console.log('multiLoadGroupState4', result)
                    _this.setState({
                        multiLoadGrouppedImg: result
                    });
                }
            }, 1500);
        });
        _this.uppy.on('complete', function (result) {
            var _a;
            var isAdditionalMultiLoad = !!((_a = _this.state.multiLoadGrouppedImg) === null || _a === void 0 ? void 0 : _a.length);
            try {
                if (result.successful.length > 1 || isAdditionalMultiLoad) {
                    // загрузка сразу пачки картинок, добавляем айди от каждой
                    result.successful.forEach(function (item, idx) {
                        var url = item.uploadURL;
                        var linkT = url.split('/');
                        var lngh = linkT.length - 1;
                        var id = linkT[lngh];
                        var grouppedImg = __spreadArray([], _this.state.multiLoadGrouppedImg, true);
                        var imgIndex = grouppedImg.findIndex(function (i) {
                            return (i === null || i === void 0 ? void 0 : i.name) === (item === null || item === void 0 ? void 0 : item.name) && !(i === null || i === void 0 ? void 0 : i.isUploaded);
                        });
                        var newImg = [];
                        if (grouppedImg.find(function (i) { return (i === null || i === void 0 ? void 0 : i.id) === id; })) {
                            _this.props.toasts.error("\u0424\u0430\u0439\u043B \u0441 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435\u043C ".concat(item === null || item === void 0 ? void 0 : item.name, " \u0443\u0436\u0435 \u0431\u044B\u043B \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D"));
                            newImg = grouppedImg.filter(function (i, index) { return index !== imgIndex; });
                        }
                        else {
                            newImg = grouppedImg.map(function (i) {
                                if ((i === null || i === void 0 ? void 0 : i.name) === (item === null || item === void 0 ? void 0 : item.name)) {
                                    return __assign(__assign({}, i), { id: id });
                                }
                                return i;
                            });
                        }
                        // console.log('multiLoadGroupState5', newImg)
                        _this.setState({
                            multiLoadGrouppedImg: newImg
                        });
                    });
                    return;
                }
                if (result.successful.length === 1) {
                    var url = result.successful[0].uploadURL;
                    var linkT = url.split('/');
                    var lngh = linkT.length - 1;
                    var id = linkT[lngh];
                    _this.setState({
                        imageId: id,
                        isLoading: false
                    });
                    // setTimeout(() => {
                    //   this.setState({
                    //     imageId: id,
                    //     isLoading: false
                    //   })
                    // }, [3000])
                }
            }
            catch (e) {
                console.error(e);
            }
        });
        return _this;
    }
    NewEl.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        var _a, _b, _c, _d;
        if (this.props.addlgpost.isFetching === false &&
            ((_a = this.state.multiLoadGrouppedImg) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
            this.state.multiLoadisStart === true) {
            var userid = localStorage.getItem('userId');
            var reverseParam = this.props.isFeed;
            var isSlider = this.state.style === 'slider' || this.state.style === 'tile';
            var isTwoPictures = this.state.style === 'two_pictures';
            var isRibbon = this.state.isRibbon;
            var grouppedImage = this.state.multiLoadGrouppedImg;
            var newAdditionalInfo = addOrChangeAdditionalInfo(this.state.additionalInfo || [], [
                { "name": "tileViewType", "value": this.state.tileViewType }
            ]);
            this.props.addManyLongReadPost(grouppedImage, userid, this.props.lgid, false, '', isSlider || isTwoPictures ? this.state.text : '', 'white', this.props.num, this.props.thematic, this.handleSetIsMultiLoadingStart, this.state.style, isSlider || isTwoPictures ? this.state.imageCaption : '', this.state.postTextPos, this.state.anchorText, this.props.generalProps, this.state.style !== 'multiple' ? this.state.useRating : null, isRibbon, reverseParam, newAdditionalInfo);
            var newmulptipleId = __spreadArray([], this.state.multipleLoadId, true);
            var newmultiPost = __spreadArray([], this.state.multipleLoadSrc, true);
            // const removedPost = newmultiPost.splice(0, 1)
            // const removedId = newmulptipleId.splice(0, 1)
            this.setState({
                multipleLoadSrc: newmultiPost,
                multipleLoadId: newmulptipleId,
                multiLoadPosition: this.state.multiLoadPosition++,
                multiLoadisStart: false,
                isMultipleFetchStart: true
            }, function () {
                if (_this.state.multipleLoadSrc.length === 0) {
                    window.location.reload();
                }
            });
            if (this.props.isFeed) {
                setTimeout(function () {
                    _this.setState({
                        multiLoadGrouppedImg: [],
                        multipleLoadSrc: [],
                        style: '',
                        isMultipleFetchStart: false
                    });
                }, 2000);
            }
        }
        if (((_b = [
            'colored',
            'link',
            'normal_image',
            'normal',
            'normal_card',
            'normal_emblem'
        ]) === null || _b === void 0 ? void 0 : _b.includes(this.state.style)) &&
            !!((_c = this.state.linkProjectId) === null || _c === void 0 ? void 0 : _c.length)) {
            var field = ((_d = [
                'colored',
                'normal_image',
                'normal',
                'normal_card',
                'normal_emblem'
            ]) === null || _d === void 0 ? void 0 : _d.includes(this.state.style)) ? 'text' : 'linkText';
            this.replaceHiddenProjectLink(this.state.linkProjectId, field);
        }
    };
    NewEl.prototype.componentWillUnmount = function () {
        this.uppy.close();
        this.props.toggleMobileEditor && this.props.toggleMobileEditor(false);
        document.removeEventListener('keydown', this.escFunction, false);
    };
    NewEl.prototype.componentDidMount = function () {
        // document.body.classList.add('opened__editor')
        document.addEventListener('keydown', this.escFunction, false);
        if (this.props.importantStyle === 'annotation') {
            var hex = this.state.color === colorObj.white ? '#000000' : this.state.color;
            this.setState({
                style: this.props.importantStyle,
                fontColor: this.invertColor(hex, 'white', '#151514'),
                colorName: hex,
                color: hex
            });
        }
        if (this.props.ev && this.props.ev.length > 0) {
            if (this.props.dropZone === 'small') {
                this.addFile(null, 'small', this.props.ev);
            }
            if (this.props.dropZone === 'big') {
                this.addFile(null, 'big', this.props.ev);
            }
            if (this.props.dropZone === 'image') {
                this.addFile(null, 'image', this.props.ev);
            }
            if (this.props.dropZone === 'multiple') {
                this.addFile(null, 'multiple', this.props.ev);
            }
            if (this.props.dropZone === 'super-puper-vote') {
                this.addFile(null, 'super-puper-vote', this.props.ev);
            }
            if (this.props.dropZone === 'slider') {
                this.addFile(null, 'slider', this.props.ev);
            }
            if (this.props.dropZone === 'tile') {
                this.addFile(null, 'tile', this.props.ev);
            }
            if (this.props.dropZone === 'two_pictures') {
                this.addFile(null, 'two_pictures', this.props.ev);
            }
            if (this.props.dropZone === 'as_cover') {
                this.addFile(null, 'presentation', this.props.ev);
            }
        }
        // if (this.props.isPresentation && this.props.firstAsCover) {
        //   this.setState({
        //     style: 'as_cover'
        //   })
        // }
        if (this.props.dropZone === 'video') {
            this.setState({
                style: 'video'
            });
        }
        if (this.props.dropZone === 'audio') {
            this.setState({
                style: 'audio'
            });
        }
    };
    NewEl.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        var isMultiLoadDisabled = (_a = this.state.multiLoadGrouppedImg) === null || _a === void 0 ? void 0 : _a.every(function (img) { return img.isUploaded; });
        var isMultipleLoadingStart = this.state.isMultipleFetchStart;
        var isMultiLoad = this.state.style === 'multiple';
        var isSPvote = this.state.style === 'super-puper-vote';
        var isSlider = (_b = ['slider', 'tile']) === null || _b === void 0 ? void 0 : _b.includes(this.state.style);
        var isProjects = this.state.style === 'projects';
        var isForms = this.state.style === 'forms';
        var isProducts = this.state.style === 'products';
        var isCard = this.state.style === 'card';
        var isTwoPictures = this.state.style === 'two_pictures';
        var canSaveWPimage = (this.state.style === 'normal_image' && (this.state.bigImageSrc === '' || this.state.text.length === 0));
        var canSaveWPcard = (this.state.style === 'normal_card' && (!((_c = this.state.additionalInfo) === null || _c === void 0 ? void 0 : _c.find(function (i) { return (i === null || i === void 0 ? void 0 : i.name) === CARDS_INFO_KEY; })) || this.state.text.length === 0));
        var isDisabled = this.state.style === 'podcast' ? (((_d = this.state.text) === null || _d === void 0 ? void 0 : _d.length) === 0 && ((_e = this.state.iframeLink) === null || _e === void 0 ? void 0 : _e.length) === 0) : this.state.style === 'course_lesson' ? this.state.lessonPostDisabled : (this.state.style === 'projects' || this.state.style === 'course_presentation') ? ((_f = this.state.projectIds) === null || _f === void 0 ? void 0 : _f.length) === 0
            : this.state.style === 'multiple' ? (!isMultiLoadDisabled || isMultipleLoadingStart)
                : isForms ? this.state.formId === ''
                    : (isProducts || isCard) ? !((_g = getCardIdsFromAdditionalInfo(this.state.additionalInfo, this.state.cardIds)) === null || _g === void 0 ? void 0 : _g.length) : (isSPvote || isSlider || isTwoPictures) ? (!isMultiLoadDisabled
                        || isMultipleLoadingStart
                        || this.state.spVoteError
                        || ((_h = this.state.multiLoadGrouppedImg) === null || _h === void 0 ? void 0 : _h.length) < 2
                        || (isSlider && ((_j = this.state.multiLoadGrouppedImg) === null || _j === void 0 ? void 0 : _j.length) > MAX_FILES_COUNT)
                        || (isTwoPictures && this.state.ratioError))
                        : this.state.style === 'as_cover' ? (this.state.imageId === '') :
                            (canSaveWPimage || canSaveWPcard) ? true
                                : (this.state.style === 'normal_card' && (!((_k = this.state.additionalInfo) === null || _k === void 0 ? void 0 : _k.find(function (i) { return (i === null || i === void 0 ? void 0 : i.name) === CARDS_INFO_KEY; })) || this.state.text.length === 0)) ? true
                                    : !!((this.state.text.length === 0 && this.state.imageId === '') || this.state.isLoading);
        var isImageUploaded = this.state.imageId !== '';
        var multipleImagesLoad = (_l = this.state.multiLoadGrouppedImg) === null || _l === void 0 ? void 0 : _l.every(function (img) { return img.src; });
        var _0 = this.props, blocksLength = _0.blocksLength, alreadyHasBibliography = _0.alreadyHasBibliography, alreadyHasImageSources = _0.alreadyHasImageSources, t = _0.t, hasSpecialSourcesBlocks = _0.hasSpecialSourcesBlocks, canAddSpBLock = _0.canAddSpBLock, isFeed = _0.isFeed, commentsAllowed = _0.commentsAllowed;
        var showInModal = blocksLength > 0;
        var isModal = (this.props.editLongRead.isEdit && showInModal && !commentsAllowed);
        var hideOffset = (this.props.isLMS && !isModal) || (this.props.isPresentation && window.innerWidth <= 992) /*&& !!this.props.posts?.length*/;
        var _1 = this.state, style = _1.style, imageCaption = _1.imageCaption, editingCaption = _1.editingCaption, postTextPos = _1.postTextPos;
        var colorStyle = this.props.colorStyle;
        var additionalStyle = this.state.secondaryStyle;
        var isImage = ['image', 'big'].includes(style);
        var isMedia = ['video', 'audio'].includes(style);
        var isImageCaptionSetted = this.state.style === 'image' && this.state.imageCaption !== '';
        var isBigImageTextSetted = this.state.style === 'big' && this.state.text !== '';
        var currentActiveCaption = isImageCaptionSetted ? 'small-caption' : isBigImageTextSetted ? 'big-caption' : null;
        var hasImage = this.state.bigImageSrc !== '' || !!((_m = this.state.multiLoadGrouppedImg) === null || _m === void 0 ? void 0 : _m.length);
        var hasCover = (_o = this.props.posts) === null || _o === void 0 ? void 0 : _o.some(function (post) { return (post === null || post === void 0 ? void 0 : post.style) === 'as_cover'; });
        var isExam = (_p = this.props.posts) === null || _p === void 0 ? void 0 : _p.some(function (post) { return (post === null || post === void 0 ? void 0 : post.style) === 'course_exam'; });
        var isPresentation = ((this.props.firstAsCover && this.props.isPresentation) || style === 'as_cover') && !isModal;
        var firstBlockAsCover = ((this.props.firstAsCover && !isPresentation) || this.props.style === 'as_cover') && !isModal && !hasCover;
        var ratingEditorVisible = !!this.state.useRating;
        var isPresentationLoader = this.props.firstAsCover && !isModal && !this.props.isLMS;
        var ImagesNotUploaded = (this.state.imagesUploaded === false && !isPresentation) || (!isPresentation && this.state.isLoading);
        var showLoader = !!this.state.firstOfCoverLoad;
        var showPresentationLoader = isPresentation && (!!this.state.isLoading || this.state.imagesUploaded === false);
        var height = (_r = (_q = this.overlayRef) === null || _q === void 0 ? void 0 : _q.current) === null || _r === void 0 ? void 0 : _r.scrollHeight;
        var scroll = (_t = (_s = this.overlayRef) === null || _s === void 0 ? void 0 : _s.current) === null || _t === void 0 ? void 0 : _t.scrollTop;
        var bottomOffset = this.props.isFeed ? 0 : 50;
        var updatePortal = !hasCover && blocksLength === 0;
        var hideBackground = isPresentation; /*&& (this.state.postTextPos === 'outside' || !!this.props.editorComponent)*/
        var blackBG = (this.state.style === 'multiple' || isSlider) && !!((_u = this.state.multiLoadGrouppedImg) === null || _u === void 0 ? void 0 : _u.length);
        var captionColorStyle = isModal ? 'contrast' : colorStyle;
        var isBottom = !isImage && !isMultiLoad && !isPresentation && !isSlider && !isProjects && !isTwoPictures;
        var isTop = isImage || isSlider || isPresentation || isProjects || isMultiLoad || isTwoPictures;
        var textValue = !((_v = this.state.text) === null || _v === void 0 ? void 0 : _v.length) ? imageCaption : !(imageCaption === null || imageCaption === void 0 ? void 0 : imageCaption.length) ? this.state.text : this.state.text;
        var disableReason = isTwoPictures && this.state.ratioError
            ? 'Высота блока слишком большая. Минимальное \n соотношение сторон - 0.6. Выберите \n изображения с другими пропорциями.'
            : null;
        var cardIds = getCardIdsFromAdditionalInfo(this.state.additionalInfo, this.state.cardIds);
        var appName = getAppNameFromAppString(this.props.appName);
        var isGallllery = ['gallllery'].includes(appName);
        // console.log('srcList newel',this.state.multiLoadGrouppedImg)
        var editorToolbar = (React.createElement(EditorToolbar, { style: style, position: isBottom ? 'bottom' : isTop ? 'top' : 'none', additionalStyle: additionalStyle, variant: 'add', typeConnection: this.props.typeConnection, bookId: this.props.bookId, cardId: (cardIds === null || cardIds === void 0 ? void 0 : cardIds.length) > 0 ? cardIds[0] : this.state.cardId, disableReason: disableReason, hasBibliography: !alreadyHasBibliography && hasSpecialSourcesBlocks, hasImageSources: !alreadyHasImageSources && hasSpecialSourcesBlocks, isExam: isExam, localAllowedActions: this.props.allowedActions, canAddSpBLock: canAddSpBLock, editingCaption: editingCaption, postDisabled: isDisabled, spVoteError: this.state.spVoteError, onAdditionalStyleDelete: this.handleChangeAdditionalStyle, onClose: this.handleUnsavedChange, onAddCaption: this.handleCaptionButton, onAddText: this.handleTextButton, onAddVideo: this.handleVideoButton, onAddProjects: this.handleProjects, onAddAudio: this.handleAudioButton, onAddButtonLink: this.handleButtonLink, onAddAnchorButton: this.handleAnchorButton, onAddImageSources: this.handleImageSources, onAddBibliography: this.handleBibliography, onAddCard: this.handleCardButton, onAddProduct: this.handleProductsButton, onAddSpecialTools: this.handleAddSpecialTools, onAddColoredPost: this.handleColoredPostButton, onAddLinkPost: this.handleLinkPostButton, onAddWhitePost: this.handleWhitePostButton, onAddWhitePostImages: this.handleWhitePostImageButton, onAddLesson: this.handleAddLesson, onAddPodcast: this.handleAddPodcast, onAddCoursePresentation: this.handleAddCoursePresentation, onTogglePostLikes: this.handleTogglePostLikes, onSubmit: style === 'course_lesson' ? this.addNewLGLessonPost : this.addNewLGPost, onAddImage: this.addFile, onAddTitlePost: this.handleTitleBlock, onAddVotePost: this.handleSPvote, onAddSlider: this.handleAddSlider, onAddTile: this.handleAddTile, onAddForms: this.handleAddForms, anchorText: this.state.anchorText, onAnchorChange: this.handleAnchorChange, onToggleWidePreviewer: this.handleTogglePreviewer, onToggleMultiCaption: this.handleToggleMultiCaption, fileRef: this.fileRef, specialTools: this.props.specialTools, appName: this.props.appName, postWithRaiting: this.state.useRating, multiLoadCaptionMode: this.state.multiLoadCaptionMode, additionalInfo: this.state.additionalInfo, setAdditionalInfo: function (additionalInfo) {
                _this.setState({ additionalInfo: additionalInfo });
            }, currentActiveCaption: currentActiveCaption, hasImage: hasImage, isPresentationLoader: isPresentationLoader, postTextPos: this.state.postTextPos, isPresentation: isPresentation, setSliderControlsPlacer: function () {
                var sliderControlsPlacer = document.querySelector('#slider-controls-portal');
                _this.setState({ sliderControlsPlacer: sliderControlsPlacer });
            }, colorPickerComponent: React.createElement(React.Fragment, null, (style === 'colored' || style === "link" || style === 'annotation') && (React.createElement(ColorMenuComp, { color: this.state.color, closeChooser: this.closeChooser, chooseColor: this.chooseColor, bigimageRef: this.bigimageRef, addFile: this.addFile, clickedAction: this.addNewLGPost, isDisabled: isDisabled, postType: this.state.style, style: 'add', src: this.state.bigImageSrc }))), isGalleryBp: this.props.isGalleryBp }));
        return (React.createElement(React.Fragment, null,
            React.createElement(FixedOverlay, { ref: this.overlayRef, isModal: isModal, animation: this.state.animation, isMultiLoad: isMultiLoad, visibleOnMobile: !!isPresentation },
                React.createElement(FixedOverlay2, { isModal: isModal, isPresentation: isPresentation, bottomOffset: bottomOffset },
                    isModal && React.createElement(FixedBg, { onClick: function (e) { return _this.onBlueArea(e); } }),
                    (this.state.style === 'image_sources' ||
                        this.state.style === 'bibliography') && (React.createElement(UpdateHeaderToggle, { colorStyle: colorStyle, isModal: isModal }, t('editor.' + this.state.style))),
                    showLoader && React.createElement(LoaderModal, { placeholder: t('modal.load') }),
                    React.createElement(Wrap, { isGalllleryNewStyle: isGallllery, isGalleryBp: this.props.isGalleryBp, ref: this.wrapRef, isFeed: this.props.isFeed, isFocused: this.props.editLongRead.isEdit, colorStyle: this.props.colorStyle, withHeader: this.state.style === 'image_sources' ||
                            this.state.style === 'bibliography', hideBackground: hideBackground, hideOffset: hideOffset, blackBG: blackBG, className: this.state.className, isModal: isModal, viewType: this.props.viewType, isPresentationLoader: isPresentationLoader },
                        ImagesNotUploaded && React.createElement(MultipleLoaderModal, null),
                        this.state.isUnsavedImages && React.createElement(NotSavedImagesModal, { onClick: this.handleToggleUnsavedModal, prevStyle: style, height: height, scroll: scroll }),
                        !((_w = this.props) === null || _w === void 0 ? void 0 : _w.isLMSMain) && isTop && editorToolbar,
                        editingCaption && ['slider', 'image', 'projects', 'two_pictures', 'tile'].includes(style) && (React.createElement(CaptionEdit, { value: textValue, onSubmit: function (value) { return _this.setCaption(value); }, onCancel: function () { return _this.setState({ editingCaption: false }); } })),
                        style === 'big' || style === 'image' ? (React.createElement(React.Fragment, null,
                            additionalStyle !== '' && (React.createElement(ButtonBlock, { type: additionalStyle, uprise: UPRISE_TYPE.dropdown, onAddNewButton: this.handlePostButtonsChange })),
                            React.createElement(BigImageComp, { isLoading: this.state.isLoading, uppy: this.uppy, src: this.state.bigImageSrc, TAvalue: textValue, TAOnChange: this.addText, style: this.state.style, textPosition: postTextPos }))) : style === 'card' ? (React.createElement(BigImageCard, { isLoading: this.state.isLoading, uppy: this.uppy, src: this.state.bigImageSrc, TAvalue: textValue, cardIds: getCardIdsFromAdditionalInfo(this.state.additionalInfo, this.state.cardIds), TAOnChange: this.addText, style: this.state.style, textPosition: postTextPos })) : isPresentation ? (React.createElement(PresentationBlock, { theme: this.props.theme, blocksLength: this.props.blockLength, colorStyle: this.props.colorStyle, src: this.state.bigImageSrc, fileRef: this.fileRef, onAddImage: this.addFile, TAvalue: this.state.text, TAOnChange: this.addText, postDisabled: isDisabled, isEditingCaption: editingCaption, postTextPos: this.state.postTextPos, onPresentationHeaderChange: this.props.onPresentationHeaderChange, editorComponent: this.props.editorComponent, isImagesUploaded: isImageUploaded, onSubmit: this.addNewLGPost, isLoading: showPresentationLoader, updatePortal: updatePortal })) : style === 'multiple' && multipleImagesLoad ? (React.createElement(MultipleUploadBlock, { isLoading: ImagesNotUploaded, uppy: this.uppy, captionMode: this.state.multiLoadCaptionMode, onCaptionChange: this.handleMultiImgCaptionValueChange, onTextChange: this.handleMultiImgCaptionValueChange, 
                            // onImgRemove={this.handleRemoveMultiloadImgClick}
                            onSetSortedImg: this.handleSortedMultipleImgChange, onImgRemove: this.handleImgRemove, srcList: this.state.multiLoadGrouppedImg })) : ((_x = ['annotation', 'block_with_title']) === null || _x === void 0 ? void 0 : _x.includes(this.state.style)) ? (React.createElement(BlockWithTitleEdit, { onClick: this.handleTextareaFocus, ref: this.coloredTextareaRef, style: this.state.style, onChange: function (e) { return _this.onColoredTextareaResize(e); }, onCaptionChange: function (e) { return _this.onCaptionChange(e); }, 
                            // onFocus={(e) => this.onFocusArea(e)}
                            text: this.state.text, fontColor: this.state.fontColor, caption: this.state.caption, bgcolor: this.state.color })) : this.state.style === 'colored' ? (React.createElement(EditTitle, { bgcolor: this.state.color, isFeed: this.props.isFeed, fontColor: this.state.fontColor, onClick: this.handleTextareaFocus, viewType: this.props.viewType },
                            React.createElement("div", { ref: this.coloredTextareaRef },
                                React.createElement(TextArea, { value: this.state.text, onChange: function (e) { return _this.onColoredTextareaResize(e); }, placeholder: t('editor.inputs.placeholder'), 
                                    // onResize={this.onColoredTextareaResize}
                                    ref: this.coloredTA, onFocus: function (e) { return _this.onFocusArea(e); }, postType: this.state.style, autoFocus: true, resize: false }),
                                additionalStyle !== '' && (React.createElement(ButtonBlock, { type: additionalStyle, uprise: UPRISE_TYPE.colored, onAddNewButton: this.handlePostButtonsChange }))),
                            ratingEditorVisible && (React.createElement(RaitingBox, { onChange: this.handleToggleRatingDataChange, data: this.state.ratings })))) : this.state.style === 'link' ? (React.createElement(EditTitle, { bgcolor: this.state.color, fontColor: this.state.fontColor, onClick: this.handleTextareaFocus, isFeed: this.props.isFeed, viewType: this.props.viewType, isLinkBlock: true },
                            React.createElement("div", { ref: this.coloredTextareaRef },
                                React.createElement(LinkArea, { value: this.state.text, onChange: function (e) { return _this.onLinkResize(e); }, linkText: this.state.linkText, onLinkChange: function (linkText) { return _this.handleSetLink(linkText); }, placeholder: t('editor.inputs.link_placeholder'), ref: this.coloredTA, onFocus: function (e) { return _this.onFocusArea(e); }, fontColor: this.state.fontColor, bgcolor: this.state.color, postType: this.state.style, autoFocus: true, resize: false }),
                                additionalStyle !== '' && (React.createElement(ButtonBlock, { type: additionalStyle, uprise: UPRISE_TYPE.colored, onAddNewButton: this.handlePostButtonsChange }))))) : this.state.style === 'forms' ? (React.createElement(FormsBlock, { isEditing: false, onSetFormPosition: this.handleSetFormPosition, onFormIdSet: this.handleSetFormId, isLoading: this.state.isLoading })) : this.state.style === 'podcast' ? (React.createElement(PodcastEditBlock, { podcastTimecodes: JSON.parse(getAdditionalInfoVal(this.state.additionalInfo, 'podcastTimeCodes') || "[]"), isLoading: this.state.isLoading, audioSrc: this.state.audioSrc, podcastName: this.state.text, iframeLink: this.state.iframeLink, onClearPodcastFile: function () {
                                _this.setState({ text: '', audioSrc: '', iframeLink: '' });
                                if (_this.fileRef.current)
                                    _this.fileRef.current.value = '';
                            }, onSetPodcastTimeCodes: function (podcastTimeCodes) {
                                _this.setState({ additionalInfo: addOrChangeAdditionalInfo(_this.state.additionalInfo, [{ "name": "podcastTimeCodes", "value": JSON.stringify(podcastTimeCodes) }]) });
                            }, onSetPodcastTotalTime: function (podcastTime) {
                                _this.setState({ additionalInfo: addOrChangeAdditionalInfo(_this.state.additionalInfo, [{ "name": "podcastTime", "value": String(podcastTime) }]) });
                            }, onSetIframeLink: function (iframeLink) {
                                _this.setState({ iframeLink: iframeLink });
                            }, fileRef: this.fileRef, onAddImage: this.addFile })) : this.state.style === 'course_lesson' ? (React.createElement(LessonEditBlock, { lessonId: this.state.text, isLoading: this.state.isLoading, onSubmit: function (text) { return _this.setState({ text: text }); }, setLessonPostDisabled: function (lessonPostDisabled) { return _this.setState({ lessonPostDisabled: lessonPostDisabled }); }, setOnLessonSave: function (onLessonSave) { return _this.setState({ onLessonSave: onLessonSave }); } })) : this.state.style === 'image_sources' ||
                            this.state.style === 'bibliography' ? (React.createElement("div", null,
                            React.createElement(EditorWrap, { onClick: this.handleTextareaFocus, isBiblio: true, inputType: TEXTAREA_TYPE.bibliography },
                                React.createElement(TextWrapper, null,
                                    React.createElement(LeftColumn, { isBiblio: true },
                                        React.createElement(FlexBox, { direction: "column", directionMobile: "column", offsetLeft: 36, gy: 16 },
                                            (!alreadyHasBibliography || this.state.style === 'bibliography') && React.createElement(RadioButton, { checked: this.state.style === 'bibliography', onChange: function () { return _this.setState({ style: 'bibliography' }); }, name: 'bibliography' },
                                                React.createElement("span", { style: { color: '#909090', marginLeft: '4px' }, className: 'radio-text' }, t('editor.bibliography'))),
                                            (!alreadyHasImageSources || this.state.style === 'image_sources') && React.createElement(RadioButton, { checked: this.state.style === 'image_sources', onChange: function () { return _this.setState({ style: 'image_sources' }); }, name: 'image_sources' },
                                                React.createElement("span", { style: { color: '#909090', marginLeft: '4px' }, className: 'radio-text' }, t('editor.image_sources'))))),
                                    React.createElement(RightColumn, null,
                                        React.createElement("div", { ref: this.textareaRef },
                                            React.createElement(TextArea, { value: this.state.text, onChange: function (e) { return _this.onSourcesTextareaChange(e); }, onKeyUp: function (e) { return _this.onSourcesTextareaKeyUp(e); }, placeholder: t('editor.inputs.placeholder'), onResize: this.onSourcesTextareaChange, maxLength: this.state.style === 'image_sources' ? 100000 : 50000, onFocus: function (e) { return _this.onFocusArea(e); }, postType: this.state.style, type: TEXTAREA_TYPE.bibliography, autoFocus: true }))))))) : this.state.style === 'super-puper-vote' ? (React.createElement(MultipleUploadBlock, { isLoading: this.state.isLoading, uppy: this.uppy, srcList: this.state.multiLoadGrouppedImg, onSetSortedImg: this.handleSortedMultipleImgChange, onImgRemove: this.handleImgRemove, isVoting: true })) : this.state.style === 'two_pictures' ? (React.createElement(TwoPicturesBlock, { isLoading: this.state.isLoading || !isMultiLoadDisabled, uppy: this.uppy, srcList: this.state.multiLoadGrouppedImg, onChange: this.handleSortedMultipleImgChange, onSlideTextChange: this.handleSlideTextChange, onImgRemove: this.handleImgRemove, onRatioError: function (value) { return _this.setState({ ratioError: value }); }, textPosition: postTextPos, controlsPlacer: this.state.sliderControlsPlacer, onCaptionEdit: this.handleCaptionButton, onChangeImage: this.onChangeImage, fileRef: this.fileRef, isEditable: true })) : style === 'slider' || style === 'tile' ? (React.createElement(SliderEditBlock, { isLoading: ImagesNotUploaded, uppy: this.uppy, srcList: this.state.multiLoadGrouppedImg, onSetSortedImg: this.handleSortedMultipleImgChange, onImgRemove: this.handleImgRemove, onSlideTextChange: this.handleSlideTextChange, onTileViewTypeChange: this.handleTileViewTypeChange, TAvalue: textValue, TAOnChange: this.handleTextPositionChange, handleSlideChecked: this.handleSlideChecked, editingText: this.state.editingText, captionMode: this.state.multiLoadCaptionMode, controlsPlacer: this.state.sliderControlsPlacer, caption: textValue, style: style, tileViewType: this.state.tileViewType })) : style === 'projects' ? (React.createElement(ProjectEditBlock, { style: style, projectIds: this.state.projectIds, onSetSortedProject: this.handleSortedProjects, onDeleteProject: this.handleDeleteProjects })) : style === 'products' ? (React.createElement(ProductsBlock, { cardIds: getCardIdsFromAdditionalInfo(this.state.additionalInfo, this.state.cardIds), onChange: this.handleProductsChange, isEditable: true })) : style === 'course_presentation' ? (React.createElement(CoursePresentationEditBlock, { style: style, onSelect: this.handleSetCoursePresentation, selectedProject: this.state.projectIds })) : isMedia ? (React.createElement(MediaInputGroup, { style: style, value: this.state.text, onSubmit: function (text) { return _this.setState({ text: text }); } })) : ((_y = ['normal_image', 'normal', 'normal_card', 'normal_emblem']) === null || _y === void 0 ? void 0 : _y.includes(style)) ? (React.createElement("div", null,
                            React.createElement(EditorWrap, { onClick: this.handleTextareaFocus },
                                React.createElement(TextWrapper, { isEmblem: style === 'normal_emblem' },
                                    React.createElement(LeftColumn, { className: 'left-column' },
                                        React.createElement(WhitePostImageBlock, { fileRef: this.fileRef, uppy: this.uppy, style: style, onAddCard: this.handleCardButton, onAddImage: this.addFile, onImageRemove: this.removeImage, cardIds: getCardIdsFromAdditionalInfo(this.state.additionalInfo, this.state.cardIds), src: this.state.bigImageSrc })),
                                    React.createElement(RightColumn, { className: 'right-column' },
                                        React.createElement("div", { ref: this.textareaRef },
                                            React.createElement(TextArea, { value: textValue, onChange: function (e) { return _this.onStandartTextareaChange(e); }, placeholder: t('editor.inputs.placeholder'), onFocus: function (e) { return _this.onFocusArea(e); }, postType: this.state.style, 
                                                // onBlur={(e) => this.onBlueArea(e)} пока не удаляю
                                                autoFocus: true })),
                                        this.state.prevImageSrc === '' ? ('') : (React.createElement(AttachedImage, { isLoading: this.state.isLoading },
                                            React.createElement(AttachedImageProgress, { isLoading: this.state.isLoading },
                                                React.createElement(ProgressBar, { uppy: this.uppy, hideAfterFinish: true })),
                                            React.createElement("img", { src: this.state.prevImageSrc, alt: 'prev' }),
                                            React.createElement(RemoveImage, { onClick: function () { return _this.removeImage(); } }))),
                                        additionalStyle !== '' && (React.createElement(ButtonBlock, { type: additionalStyle, uprise: UPRISE_TYPE.normal, onAddNewButton: this.handlePostButtonsChange }))))))) : (React.createElement(DefaultBlock, { colorStyle: this.props.colorStyle })),
                        isBottom && editorToolbar),
                    imageCaption && !((_z = ['top', 'center', 'bottom']) === null || _z === void 0 ? void 0 : _z.includes(postTextPos)) && (React.createElement(CaptionBlock, { colorStyle: captionColorStyle },
                        React.createElement(CaptionMarkdownText, { rehypePlugins: [rehypeRaw, rehypeSanitize] }, formatLinks(imageCaption)))))),
            React.createElement(GlobalEditor, null)));
    };
    return NewEl;
}(Component));
var mapStateToProps = function (store, _a) {
    var currentId = _a.lgid;
    var newLongread = getCurrentLongread(store, currentId);
    var newEditLongread = getCurrentEditLongread(store, currentId);
    var addLongread = getAddLongread(store, currentId);
    var toggleLongReadPostUpdate = getToggleLongReadPostUpdate(store, currentId);
    return {
        editLongRead: newEditLongread,
        blocksLength: newLongread.blocks.length,
        alreadyHasImageSources: newLongread.blocks
            ? newLongread.blocks.some(function (block) { return (block === null || block === void 0 ? void 0 : block.style) === 'image_sources'; })
            : false,
        alreadyHasBibliography: newLongread.blocks
            ? newLongread.blocks.some(function (block) { return (block === null || block === void 0 ? void 0 : block.style) === 'bibliography'; })
            : false,
        addlgpost: addLongread,
        updateStatus: toggleLongReadPostUpdate.updateStatus,
        posts: newLongread.blocks
        // countryInnerPageData: store.countryInnerPage.data,
        // doiserStates: store.doiserStates
    };
};
var mapDispatchToProps = function (dispatch, _a) {
    var currentId = _a.lgid;
    return {
        // setCreator: (creatorOptions) => dispatch(setCreator(creatorOptions))
        addLongReadPost: function (args) {
            return dispatch(addLongReadPost(args));
        },
        addManyLongReadPost: function (arr, id, title, text, color, imageid, lgid, isFL, imgCaption, style, num, imageData, thematic, anchorText, generalProps, useRating, ratings, isRibbon, reverseParam, additionalInfo) {
            return dispatch(addManyLongReadPost(arr, id, title, text, color, imageid, lgid, isFL, imgCaption, style, num, imageData, thematic, anchorText, generalProps, useRating, ratings, isRibbon, reverseParam, additionalInfo));
        },
        getLongRead: function (idArea, idCountry, type) {
            return dispatch(getLongRead(idArea, idCountry, type));
        },
        setEditLongRead: function (status, num) { return dispatch(setEditLongRead(status, num, currentId)); },
        getLongReadPosts: function (idUser, idLongRead, sign, thematic) {
            return dispatch(getLongReadPosts(idUser, idLongRead, sign, thematic));
        },
        toggleLongReadPostUpdate: function (postid, updateStatus) {
            return dispatch(toggleLongReadPostUpdate(postid, updateStatus, currentId));
        },
        toggleWidePreviewer: function (val, src) {
            return dispatch(toggleWidePreviewer(val, src));
        },
        clearWidePreviewer: function () {
            return dispatch(clearWidePreviewer());
        }
    };
};
NewEl.propTypes = {};
var ConnectedComponent = connect(mapStateToProps, mapDispatchToProps)(toastHook(withProfile(withModal(withLocalization(NewEl))), useToasts));
export default ConnectedComponent;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28;
//# sourceMappingURL=newel.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled, { css, createGlobalStyle, keyframes } from 'styled-components';
import removeimage from '../../../../images/icons/longreadeditor/deleteimage.svg';
import removeimagehover from '../../../../images/icons/longreadeditor/deleteimagehover.svg';
import { addLongReadPost, addManyLongReadPost } from '../../../../actions/addLongReadPost';
import { setEditLongRead } from '../../../../actions/setEditLongRead';
import { getLongRead } from '../../../../actions/getLongRead';
import { getLongReadPosts } from '../../../../actions/getLongReadPosts';
import { colorObj } from '../../../../constants/colorObj';
import { paddings, heights } from '../../../../constants/paddings';
import BigImageComp from './bigimage';
import ColorMenuComp from './colormenu';
import Uppy from '@uppy/core';
import Tus from '@uppy/tus';
import { ProgressBar } from '@uppy/react';
import FileInput from '@uppy/file-input';
import { Endpoints, Lang } from '@brg/api';
import { LayoutConst, MEDIA_QUERY, MEDIA_QUERY_HEIGHT, MEDIA_QUERY_MOBILE } from '../../../../constants/media';
import CaptionEdit from './CaptionEdit';
import { toggleLongReadPostUpdate } from '../../../../actions/toggleLRPostUpdate';
import MediaInputGroup from './MediaInputGroup';
import { CaptionBlock } from '../postblocks/coloredblock';
import { CaptionMarkdownText, LeftColumn, RightColumn, TextWrapper } from "../postblocks/whitepostblock";
import TextArea, { TEXTAREA_TYPE } from '../../modules/inputs/TextArea';
import JuryBox from '../specialTools';
import formatLinks from '../../../../utilites/formatLinks';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import EditorToolbar from './EditorToolbar';
import { FontSizes, MAC13_COLORED_FONT_SIZE } from '../../../../constants/theme';
import toastHook from '../../../../utilites/toasts';
import { FlexBox, useToasts } from '@brg/ui';
import { getAppNameFromAppString } from '../../../../utilites/appTester';
import { UpdateHeaderToggle, uploadValidator } from "./updateel";
import { useModal, withModal } from '../../../../core/modules/modal.module';
import urlApi from '../../../../actions/urlApi';
import { MultipleUploadBlock } from './MultipleUploadBlock/MultipleUploadBlock';
import { withLocalization } from "../../../../hooks/useLocalization";
import { NotSavedImagesModal } from '../../../modals/NotSavedImagesModal';
import { MultipleLoaderModal } from '../../../modals/MultipleLoaderModal';
import { LoaderModal } from '../../../modals/LoaderModal';
import { SliderEditBlock } from './SiderEditBlock/SliderEditBlock';
import { PresentationBlock } from './Presentation/PresentationBlock';
import { clearWidePreviewer, toggleWidePreviewer } from '../../../../actions/toggleWidePreviewer';
import { withProfile } from '../../../../hooks/withProfile';
import { ProjectEditBlock } from "./ProjectEditBlock/ProjectEditBlock";
import { LargeText } from '../../../Text/styles';
import FormsBlock, { FORM_CENTER_POS } from '../postblocks/FormsBlock/FormsBlock';
import ButtonBlock from './Button';
import { UPRISE_TYPE } from './Button/const';
import { getCurrentLongread } from "../../../../reducers/longreadBlocks";
import { getCurrentEditLongread } from "../../../../reducers/setEditLongRead";
import { getAddLongread } from "../../../../reducers/addLongReadPost";
import { getToggleLongReadPostUpdate } from "../../../../reducers/toggleLongReadPostUpdate";
import { LessonEditBlock } from "../postblocks/CourseBlock/sections/LessonEditBlock";
import ProductsBlock from '../postblocks/ProductsBlock/ProductsBlock';
import { CoursePresentationEditBlock } from "./CoursePresentationEditBlock/CoursePresentationEditBlock";
import TwoPicturesBlock from './TwoPicturesBlock/TwoPicturesBlock';
import RadioButton from "../../../buttons/Radio";
import BigImageCard from "./bigimageCard";
import { PodcastEditBlock } from "./PodcastEditBlock/PodcastEditBlock";
import { addOrChangeAdditionalInfo } from "../../../../utilites/addOrChangeAdditionalInfo";
import { getAdditionalInfoVal } from "../../../../utilites/getAdditionalInfoVal";
import { onChangeBibliography } from '../../../../utilites/bibliography/onChangeBibliography';
import { modifyToListText } from '../../../../utilites/bibliography/modifyToListText';
import { getCardIdsFromAdditionalInfo } from '../../../../utilites/card/getCardIdsFromAdditionalInfo';
import { updateIsPayInCardsInfo } from '../../../../utilites/card/updateIsPayInCardsInfo';
import { CARDS_INFO_KEY } from '../../../../constants/cards';
import { INITIAL_RAITING, RaitingBox } from '../postblocks/components/RaitingBox';
import { WhitePostImageBlock } from './WhitePostImageBlock/WhitePostImageBlock';
import { DefaultBlock } from './DefaultBlock/DefaultBlock';
import LinkArea from '../../modules/inputs/LinkArea';
import { extractProjectId, replaceAWithHref } from '../../../../utilites/replaceHiddenProjectLink';
import { BlockWithTitleEdit } from './AnnotationEditor/BlockWithTitleEdit';
import { TileViewType } from '../../../../constants/TyleViewType';
export var MAX_FILES_COUNT = 15;
var IMAGES_STYLES = ['image', 'multiple', 'slider', 'big', 'tile'];
export var FORM_POSITION_TYPE = {
    0: 'center',
    1: 'right'
};
var Wrap = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  min-width: 1152px;\n  max-width: min-content;\n  position: relative;\n  margin-top: ", ";\n  background: ", ";\n  box-shadow: none;\n  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.12));\n\n  ", ";\n\n  border: none;\n\n  z-index: 101;\n\n  .uppy-ProgressBar {\n    z-index: 2222;\n    top: 0;\n    width: 100%;\n  }\n\n  .uppy-ProgressBar-inner {\n    background: #f1db63;\n    height: 8px;\n    transition: 1s;\n  }\n\n  .uppy-ProgressBar-percentage {\n    display: none;\n  }\n\n  textarea {\n    display: inline-block;\n    border: none;\n    width: 100%;\n    outline: none;\n    border: none;\n\n    &:focus {\n      border: none;\n    }\n  }\n\n  @media (max-width: ", "px),\n    (max-height: ", "px) {\n    min-width: ", ";\n  }\n\n  ", ";\n\n\n\n  ", ";\n\n  @media(max-width: ", "px) {\n    ", ";\n    min-width: 100%;\n  }\n\n  @media(max-width: 744px) {\n    ", ";\n    min-width: 100%;\n  }\n"], ["\n  min-width: 1152px;\n  max-width: min-content;\n  position: relative;\n  margin-top: ", ";\n  background: ", ";\n  box-shadow: none;\n  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.12));\n\n  ", ";\n\n  border: none;\n\n  z-index: 101;\n\n  .uppy-ProgressBar {\n    z-index: 2222;\n    top: 0;\n    width: 100%;\n  }\n\n  .uppy-ProgressBar-inner {\n    background: #f1db63;\n    height: 8px;\n    transition: 1s;\n  }\n\n  .uppy-ProgressBar-percentage {\n    display: none;\n  }\n\n  textarea {\n    display: inline-block;\n    border: none;\n    width: 100%;\n    outline: none;\n    border: none;\n\n    &:focus {\n      border: none;\n    }\n  }\n\n  @media (max-width: ", "px),\n    (max-height: ", "px) {\n    min-width: ", ";\n  }\n\n  ", ";\n\n\n\n  ", ";\n\n  @media(max-width: ", "px) {\n    ", ";\n    min-width: 100%;\n  }\n\n  @media(max-width: 744px) {\n    ", ";\n    min-width: 100%;\n  }\n"])), function (props) {
    if (props === null || props === void 0 ? void 0 : props.isPresentationLoader)
        return '80px';
    if (props === null || props === void 0 ? void 0 : props.withHeader)
        return '16px';
    if (props.hideOffset)
        return '0px';
    if (props.isFeed)
        return '32px';
    return '40px';
}, function (p) { return (p === null || p === void 0 ? void 0 : p.hideBackground) ? 'transparent' : (p === null || p === void 0 ? void 0 : p.blackBG) ? '#1f1f1f' : '#ffffff'; }, function (p) { return ['t-shape', 'fixed-ratio-small', 'fixed-ratio-large', 'free-type'].includes(p.viewType) ? css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    filter: none;\n  "], ["\n    filter: none;\n  "]))) : null; }, MEDIA_QUERY, MEDIA_QUERY_HEIGHT, function (props) { return props.isGalleryBp || (props === null || props === void 0 ? void 0 : props.isFeed) ? '100%' : '888px'; }, function (_a) {
    var isGalllleryNewStyle = _a.isGalllleryNewStyle;
    return isGalllleryNewStyle && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    @media (max-width: 1199px){\n      min-width: 712px;\n    }\n  "], ["\n    @media (max-width: 1199px){\n      min-width: 712px;\n    }\n  "])));
}, function (p) { return ['t-shape', 'fixed-ratio-small', 'fixed-ratio-large', 'free-type'].includes(p === null || p === void 0 ? void 0 : p.viewType) ? css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    // max-width: min-content;\n\n    @media (max-width: ", "px),\n    (max-height: ", "px) {\n      margin-left: auto;\n      margin-right: auto;\n\n      .left-column, .right-column {\n        width: 50%;\n      }\n    }\n  "], ["\n    // max-width: min-content;\n\n    @media (max-width: ", "px),\n    (max-height: ", "px) {\n      margin-left: auto;\n      margin-right: auto;\n\n      .left-column, .right-column {\n        width: 50%;\n      }\n    }\n  "])), MEDIA_QUERY, MEDIA_QUERY_HEIGHT) : null; }, MEDIA_QUERY_MOBILE, function (_a) {
    var hideOffset = _a.hideOffset;
    return hideOffset ? css(templateObject_4 || (templateObject_4 = __makeTemplateObject([" margin-top: 0;"], [" margin-top: 0;"]))) : null;
}, function (_a) {
    var hideBackground = _a.hideBackground;
    return hideBackground ? css(templateObject_5 || (templateObject_5 = __makeTemplateObject([" margin-top: 0;"], [" margin-top: 0;"]))) : null;
});
export var EditorWrap = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  padding-top: ", ";\n  min-height: ", ";\n\n  ", ";\n\n  .radio-text {\n    font-size: ", ";\n    line-height: ", ";\n  }\n\n  textarea {\n    font-family: Inter;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 20px;\n    line-height: 32px;\n    letter-spacing: -0.02em;\n    color: #151514;\n    height: 40px;\n    padding-right: 40px;\n    //margin-bottom: 20px;\n\n    ", ";\n  }\n\n  @media (max-width: ", "px),\n  (max-height: ", "px) {\n\n  }\n"], ["\n  padding-top: ", ";\n  min-height: ", ";\n\n  ", ";\n\n  .radio-text {\n    font-size: ", ";\n    line-height: ", ";\n  }\n\n  textarea {\n    font-family: Inter;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 20px;\n    line-height: 32px;\n    letter-spacing: -0.02em;\n    color: #151514;\n    height: 40px;\n    padding-right: 40px;\n    //margin-bottom: 20px;\n\n    ", ";\n  }\n\n  @media (max-width: ", "px),\n  (max-height: ", "px) {\n\n  }\n"])), function (p) { return (p === null || p === void 0 ? void 0 : p.isBiblio) ? '36px' : '38px'; }, function (p) { return ((p === null || p === void 0 ? void 0 : p.blockHgt) ? "".concat(p.blockHgt, "px") : '348px'); }, function (p) {
    return (p === null || p === void 0 ? void 0 : p.blockHgt)
        ? css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n          height: ", "px;\n        "], ["\n          height: ", "px;\n        "])), p.blockHgt) : null;
}, function (_a) {
    var inputType = _a.inputType;
    return inputType === TEXTAREA_TYPE.bibliography ? "".concat(FontSizes.common.m.fs, "px") : 'inherit';
}, function (_a) {
    var inputType = _a.inputType;
    return inputType === TEXTAREA_TYPE.bibliography ? "".concat(FontSizes.common.m.lh, "px") : 'inherit';
}, function (_a) {
    var skipReducedVersion = _a.theme.skipReducedVersion, inputType = _a.inputType;
    return skipReducedVersion
        ? null
        : css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n            @media (max-width: ", "px),\n              (max-height: ", "px) {\n              font-size: ", "px;\n              line-height: ", "px;\n              padding-right: ", "px;\n              margin-bottom: ", "px;\n            }\n          "], ["\n            @media (max-width: ", "px),\n              (max-height: ", "px) {\n              font-size: ", "px;\n              line-height: ", "px;\n              padding-right: ", "px;\n              margin-bottom: ", "px;\n            }\n          "])), MEDIA_QUERY, MEDIA_QUERY_HEIGHT, FontSizes.regularText.m.fs, FontSizes.regularText.m.lh, LayoutConst.blockPadding.m.main, LayoutConst.blockPadding.m.main);
}, MEDIA_QUERY, MEDIA_QUERY_HEIGHT);
var AttachedImageProgress = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  display: ", ";\n  position: absolute;\n  top: 0;\n  height: 8px;\n  z-index: 25;\n  width: calc(100% - 30px);\n"], ["\n  display: ", ";\n  position: absolute;\n  top: 0;\n  height: 8px;\n  z-index: 25;\n  width: calc(100% - 30px);\n"])), function (props) { return (props.isLoading ? 'block' : 'none'); });
export var EditTitle = styled(LargeText)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  background: ", ";\n  z-index: 14;\n  transition: 0.2s;\n  // min-height: ", ";\n  min-height: 348px;\n\n  textarea {\n    font-family: inherit;\n    font-weight: 600;\n    color: ", ";\n    background: transparent;\n    padding: 0;\n    box-sizing: border-box;\n\n    &::placeholder {\n      color: ", ";\n    }\n  }\n"], ["\n  background: ", ";\n  z-index: 14;\n  transition: 0.2s;\n  // min-height: ", ";\n  min-height: 348px;\n\n  textarea {\n    font-family: inherit;\n    font-weight: 600;\n    color: ", ";\n    background: transparent;\n    padding: 0;\n    box-sizing: border-box;\n\n    &::placeholder {\n      color: ", ";\n    }\n  }\n"])), function (props) { return props.bgcolor; }, function (props) { return (props.isLinkBlock ? '144px' : '348px'); }, function (props) { return props.fontColor; }, function (props) { return props.fontColor; });
var RemoveImage = styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  background: url(", ") no-repeat center;\n  z-index: 10;\n  right: 0px;\n  top: 0px;\n  cursor: pointer;\n  opacity: 0.31;\n  transition: 0.2s;\n\n  &:hover {\n    opacity: 1;\n    background: url(", ") no-repeat center;\n  }\n"], ["\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  background: url(", ") no-repeat center;\n  z-index: 10;\n  right: 0px;\n  top: 0px;\n  cursor: pointer;\n  opacity: 0.31;\n  transition: 0.2s;\n\n  &:hover {\n    opacity: 1;\n    background: url(", ") no-repeat center;\n  }\n"])), removeimage, removeimagehover);
var AttachedImage = styled.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  position: relative;\n  padding-right: 30px;\n\n  label {\n    margin-bottom: 0;\n  }\n\n  img {\n    transition: 0.2s;\n    width: 100%;\n    opacity: ", ";\n  }\n"], ["\n  position: relative;\n  padding-right: 30px;\n\n  label {\n    margin-bottom: 0;\n  }\n\n  img {\n    transition: 0.2s;\n    width: 100%;\n    opacity: ", ";\n  }\n"])), function (props) { return (props.isLoading ? '0.5' : '1'); });
var fadeIn = keyframes(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  from {\n    opacity: 0;\n    backdrop-filter: blur(0px);\n  }\n\n  to {\n    opacity: 0.73;\n    backdrop-filter: blur(13px);\n  }\n"], ["\n  from {\n    opacity: 0;\n    backdrop-filter: blur(0px);\n  }\n\n  to {\n    opacity: 0.73;\n    backdrop-filter: blur(13px);\n  }\n"])));
var fadeOut = keyframes(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  from {\n    opacity: 0.73;\n    backdrop-filter: blur(13px);\n  }\n\n  to {\n    opacity: 0;\n    backdrop-filter: blur(0px);\n  }\n"], ["\n  from {\n    opacity: 0.73;\n    backdrop-filter: blur(13px);\n  }\n\n  to {\n    opacity: 0;\n    backdrop-filter: blur(0px);\n  }\n"])));
var up = keyframes(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  from {\n    opacity: 0;\n    transform: translate(0, -30px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate(0, 0);\n  }\n"], ["\n  from {\n    opacity: 0;\n    transform: translate(0, -30px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate(0, 0);\n  }\n"])));
var down = keyframes(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  from {\n    transform: translate(0, 0);\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate(0, 30px);\n\n  }\n"], ["\n  from {\n    transform: translate(0, 0);\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    transform: translate(0, 30px);\n\n  }\n"])));
var FixedBg = styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  z-index: 100;\n  background: linear-gradient(\n    180deg,\n    rgba(42, 48, 52, 0.91) 0%,\n    rgba(44, 47, 49, 0.65) 51.08%,\n    rgba(42, 48, 52, 0.91) 100%\n  );\n\n  p {\n    color: #fff;\n  }\n"], ["\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  z-index: 100;\n  background: linear-gradient(\n    180deg,\n    rgba(42, 48, 52, 0.91) 0%,\n    rgba(44, 47, 49, 0.65) 51.08%,\n    rgba(42, 48, 52, 0.91) 100%\n  );\n\n  p {\n    color: #fff;\n  }\n"])));
var FixedOverlay = styled.div(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n  position: ", ";\n  //bottom: 0;\n  bottom: ", "; // \u041E\u0442\u0441\u0442\u0443\u043F \u0434\u043B\u044F \u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E \u0444\u0443\u0442\u0435\u0440\u0430\n  right: 0;\n  left: 0;\n    /*padding-left:", ";\n  padding-right: ", ";*/\n  top: 0;\n  z-index: 350;\n  overflow-y: ", ";\n  pointer-events: ", ";\n\n  @media (max-width: 940px) {\n    display: ", ";\n  }\n\n  &::-webkit-scrollbar {\n    width: 0px;\n  }\n\n  & ", " {\n    ", "\n    & ", " {\n      ", "\n    }\n"], ["\n  position: ", ";\n  //bottom: 0;\n  bottom: ", "; // \u041E\u0442\u0441\u0442\u0443\u043F \u0434\u043B\u044F \u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E \u0444\u0443\u0442\u0435\u0440\u0430\n  right: 0;\n  left: 0;\n    /*padding-left:", ";\n  padding-right: ", ";*/\n  top: 0;\n  z-index: 350;\n  overflow-y: ", ";\n  pointer-events: ", ";\n\n  @media (max-width: 940px) {\n    display: ", ";\n  }\n\n  &::-webkit-scrollbar {\n    width: 0px;\n  }\n\n  & ", " {\n    ", "\n    & ", " {\n      ", "\n    }\n"])), function (_a) {
    var isModal = _a.isModal;
    return (isModal ? 'fixed' : 'static');
}, function (_a) {
    var isMultiLoad = _a.isMultiLoad;
    return isMultiLoad ? '48px' : '0';
}, function (props) {
    return props.isFocused ? 'calc((100vw - 1152px) / 2)' : '0';
}, function (props) {
    return props.isFocused ? 'calc((100vw - 1152px) / 2)' : '0';
}, function (_a) {
    var isModal = _a.isModal;
    return (isModal ? 'auto' : 'initial');
}, function (_a) {
    var isModal = _a.isModal, animation = _a.animation;
    return isModal && animation === 'out' ? 'none' : 'initial';
}, function (_a) {
    var visibleOnMobile = _a.visibleOnMobile;
    return visibleOnMobile ? 'block' : 'none';
}, Wrap, function (_a) {
    var isModal = _a.isModal, animation = _a.animation;
    if (isModal) {
        return animation === 'in'
            ? css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n              animation-name: ", ";\n              animation-fill-mode: forwards;\n              animation-duration: 0.8s;\n            "], ["\n              animation-name: ", ";\n              animation-fill-mode: forwards;\n              animation-duration: 0.8s;\n            "])), up) : css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n              animation-name: ", ";\n              animation-fill-mode: forwards;\n              animation-duration: 0.5s;\n            "], ["\n              animation-name: ", ";\n              animation-fill-mode: forwards;\n              animation-duration: 0.5s;\n            "])), down);
    }
}, FixedBg, function (_a) {
    var isModal = _a.isModal, animation = _a.animation;
    if (isModal) {
        return animation === 'in'
            ? css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n                animation-name: ", ";\n                animation-fill-mode: forwards;\n                animation-duration: 0.5s;\n              "], ["\n                animation-name: ", ";\n                animation-fill-mode: forwards;\n                animation-duration: 0.5s;\n              "])), fadeIn) : css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n                animation-name: ", ";\n                animation-fill-mode: forwards;\n                animation-duration: 0.5s;\n              "], ["\n                animation-name: ", ";\n                animation-fill-mode: forwards;\n                animation-duration: 0.5s;\n              "])), fadeOut);
    }
});
var FixedOverlay2 = styled.div(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n  position: ", ";\n  //max-width: 1182px;\n  max-width: 1152px;\n  padding-bottom: ", "px;\n  margin: 0 auto;\n  top: 25vh;\n\n  ", ";\n\n  @media(max-width: 743px) {\n    padding-bottom: ", ";\n  }\n"], ["\n  position: ", ";\n  //max-width: 1182px;\n  max-width: 1152px;\n  padding-bottom: ", "px;\n  margin: 0 auto;\n  top: 25vh;\n\n  ", ";\n\n  @media(max-width: 743px) {\n    padding-bottom: ", ";\n  }\n"])), function (_a) {
    var isModal = _a.isModal;
    return (isModal ? 'relative' : 'static');
}, function (_a) {
    var bottomOffset = _a.bottomOffset;
    return bottomOffset;
}, function (_a) {
    var skipReducedVersion = _a.theme.skipReducedVersion;
    return skipReducedVersion
        ? null
        : css(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n          @media (max-width: ", "px),\n            (max-height: ", "px) {\n            max-width: ", "px;\n          }\n        "], ["\n          @media (max-width: ", "px),\n            (max-height: ", "px) {\n            max-width: ", "px;\n          }\n        "])), MEDIA_QUERY, MEDIA_QUERY_HEIGHT, LayoutConst.container.m);
}, function (_a) {
    var isPresentation = _a.isPresentation;
    return isPresentation ? '16px' : '50px';
});
var GlobalEditor = createGlobalStyle(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n\n  body.opened__editor {\n    overflow-y: hidden;\n  }\n\n"], ["\n\n  body.opened__editor {\n    overflow-y: hidden;\n  }\n\n"])));
var MultipleWrap = styled.div(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n  img {\n    display: inline-block;\n    max-width: 200px;\n    margin: 15px;\n  }\n"], ["\n  img {\n    display: inline-block;\n    max-width: 200px;\n    margin: 15px;\n  }\n"])));
var MultipleText = styled.div(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n  color: black;\n  margin-bottom: 15px;\n"], ["\n  color: black;\n  margin-bottom: 15px;\n"])));
var NewEl = /** @class */ (function (_super) {
    __extends(NewEl, _super);
    // _isMounted = false;
    function NewEl(props) {
        var _this = _super.call(this, props) || this;
        _this.addNewLGLessonPost = function (isCardAbleToPurchase) {
            if (!_this.state.onLessonSave)
                return;
            _this.state.onLessonSave().then(function (r) {
                _this.addNewLGPost(isCardAbleToPurchase, r);
            });
        };
        _this.addNewLGPost = function (isCardAbleToPurchase, customText) {
            var _a, _b, _c, _d, _e, _f, _g;
            var isPresentation = _this.props.isPresentation;
            var isFeed = _this.props.isFeed;
            var reverseParam = isFeed; // разворачивает массив для ленты.
            var userid = localStorage.getItem('userId');
            var textLetter = _this.state.isFirstLetter
                ? "".concat(_this.state.text)
                : _this.state.text;
            var slicedTextLetter = _this.state.style === 'colored' ? textLetter.substring(0, 800) : textLetter;
            var rating = !!_this.state.useRating ?
                (((_a = _this.state.ratings) === null || _a === void 0 ? void 0 : _a['custom']) ? _this.state.ratings : { like: INITIAL_RAITING }) : {};
            var _h = _this.props.doiserStates, areaId = _h.areaId, countryId = _h.countryId, type = _h.type;
            var loadingSrc = _this.state.style === 'podcast' ? _this.state.audioSrc
                : _this.state.style === 'big' ||
                    _this.state.style === 'image' ||
                    _this.state.style === 'as_cover'
                    ? _this.state.bigImageSrc
                    : _this.state.prevImageSrc;
            var caption = ((_b = ['annotation', 'block_with_title']) === null || _b === void 0 ? void 0 : _b.includes(_this.state.style)) && !!((_c = _this.state.caption) === null || _c === void 0 ? void 0 : _c.length) ? { caption: _this.state.caption } : {};
            var autoCaption = (_this.state.postTextPos === 'caption-bottom' &&
                !!(slicedTextLetter === null || slicedTextLetter === void 0 ? void 0 : slicedTextLetter.length) &&
                !((_d = _this.state.imageCaption) === null || _d === void 0 ? void 0 : _d.length) &&
                !_this.state.editingCaption) ? slicedTextLetter : _this.state.imageCaption;
            var autoText = (_this.state.postTextPos !== 'caption-bottom' &&
                !!((_e = _this.state.imageCaption) === null || _e === void 0 ? void 0 : _e.length)) ? _this.state.imageCaption : slicedTextLetter;
            var podcastText = _this.state.style === 'podcast'
                ? (_this.state.iframeLink || _this.state.text)
                : autoText;
            var finalStyle = ((_f = ['normal_image', 'normal_card']) === null || _f === void 0 ? void 0 : _f.includes(_this.state.style)) ? 'normal' : _this.state.style;
            // случай для неск картинок
            if (_this.state.multipleLoadSrc.length > 0) {
                _this.setState({
                    multiLoadisStart: true,
                    imagesUploaded: false,
                });
                return;
            }
            if (_this.state.style === 'as_cover') {
                _this.setState({
                    imagesUploaded: false
                });
            }
            if (_this.state.style === 'forms') {
                _this.setState({ isLoading: true });
            }
            var newAdditionalInfo = addOrChangeAdditionalInfo(_this.state.additionalInfo || [], [
                { "name": "projectId", "value": (_g = _this.props) === null || _g === void 0 ? void 0 : _g.projectId },
                { "name": CARDS_INFO_KEY, "value": updateIsPayInCardsInfo(_this.state.additionalInfo || [], isCardAbleToPurchase ? true : false) },
                { "name": "tileViewType", "value": _this.state.tileViewType }
            ]);
            // если одна картинка
            if (_this.state.multipleLoadSrc.length === 0) {
                _this.props.addLongReadPost(__assign({ id: userid, title: _this.state.text, text: (customText || podcastText), color: _this.state.colorName, imageid: _this.state.imageId, lgid: _this.props.lgid, isFL: _this.state.isFirstLetter, imgCaption: autoCaption, style: finalStyle, num: _this.props.num, imageData: loadingSrc, thematic: _this.props.thematic, titlePosition: _this.state.postTextPos, projectIds: _this.state.projectIds, onAfterLoad: _this.handleSetLoadCompete, formId: _this.state.formId, formPosition: _this.state.formPosition, anchorText: _this.state.anchorText, buttons: _this.state.buttons, cardIds: _this.state.cardIds, generalProps: _this.props.generalProps, additionalInfo: newAdditionalInfo, useRating: _this.state.useRating, ratings: rating, linkText: _this.state.linkText, reverseParam: reverseParam }, caption));
            }
            _this.onBlueArea('');
            if (_this.props.onNewPost) {
                setTimeout(function () { return _this.props.onNewPost(); }, 1000);
            }
            _this.setState({
                text: '',
                title: '',
                addButtonsOpened: false,
                color: colorObj.white,
                fontColor: colorObj.fonts.white,
                colorName: 'white',
                isColorChoose: false,
                isTitleOpened: false,
                imageId: '',
                imageCaption: '',
                prevImageSrc: '',
                audioSrc: '',
                bigImageSrc: '',
                style: isPresentation ? 'as_cover' : isFeed ? '' : 'normal',
                isTextTooBig: false,
                prevColorStatus: 'white',
                isFirstLetter: false,
                firstLetter: '',
                postTextPos: '',
                projectIds: [],
                formId: '',
                formPosition: FORM_CENTER_POS,
                anchorText: '',
                iframeLink: '',
                useRating: false,
                // multipleLoadId: [],
                // multipleLoadSrc: []
            });
            _this.handleTogglePreviewer(false, null);
            _this.uppy.reset();
        };
        _this.handlePostButtonsChange = function (button) {
            _this.setState({ buttons: [button] });
        };
        _this.getClearedImageData = function () {
            return {
                bigImageSrc: '',
                multiLoadGrouppedImg: [],
                multipleLoadSrc: [],
                imageId: '',
                multipleLoadId: [],
                text: '',
                title: '',
                caption: '',
                imageCaption: '',
                prevImageSrc: '',
                audioSrc: '',
            };
        };
        _this.checkUnsavedData = function () { var _a; return (_this.state.bigImageSrc !== '' || !!((_a = _this.state.multiLoadGrouppedImg) === null || _a === void 0 ? void 0 : _a.length)); };
        _this.replaceHiddenProjectLink = function (id, field) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = urlApi()) === null || _a === void 0 ? void 0 : _a.getProject({ id: id }).then(function (r) { return r.status === 200 && r.json(); }).then(function (project) {
                            var _a;
                            var _b, _c;
                            var isHiddenProject = project.status === 10;
                            if (isHiddenProject) {
                                _this.props.toasts.error('Нельзя добавить ссылку на скрытый проект');
                            }
                            _this.setState((_a = {},
                                _a[field] = isHiddenProject ? replaceAWithHref((_b = _this.state) === null || _b === void 0 ? void 0 : _b[field]) : (_c = _this.state) === null || _c === void 0 ? void 0 : _c[field],
                                _a.linkProjectId = '',
                                _a));
                        }))];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleSetLoadCompete = function (val) {
            _this.setState({
                imagesUploaded: true,
            });
        };
        _this.handleSetFormPosition = function (val) {
            _this.setState({
                formPosition: val,
            });
        };
        _this.handleSetFormId = function (id) {
            _this.setState({
                formId: id,
            });
        };
        _this.handleSetIsMultiLoadingStart = function (val) {
            _this.setState({
                isMultipleFetchStart: val,
                imagesUploaded: true,
            });
            // setTimeout(() => {
            //   this.setState({
            //     imagesUploaded: null,
            // })
            // }, 1000)
        };
        _this.handleWhitePostButton = function () {
            var _a;
            _this.setState({
                style: 'normal',
                bigImageSrc: '',
                cardId: '',
                additionalInfo: (_a = _this.state.additionalInfo) === null || _a === void 0 ? void 0 : _a.filter(function (i) { return (i === null || i === void 0 ? void 0 : i.name) !== CARDS_INFO_KEY; })
            });
        };
        _this.handleWhitePostImageButton = function (ev) {
            var _a, _b, _c;
            var style = (_b = (_a = ev.target) === null || _a === void 0 ? void 0 : _a.dataset) === null || _b === void 0 ? void 0 : _b['type'];
            _this.setState({
                style: style,
                bigImageSrc: '',
                cardId: '',
                additionalInfo: (_c = _this.state.additionalInfo) === null || _c === void 0 ? void 0 : _c.filter(function (i) { return (i === null || i === void 0 ? void 0 : i.name) !== CARDS_INFO_KEY; })
            });
        };
        _this.handleAddLesson = function () {
            _this.setState({ style: 'course_lesson', text: '' });
        };
        _this.handleAddPodcast = function () {
            _this.setState({ style: 'podcast', text: '' });
        };
        _this.handleAddCoursePresentation = function () {
            _this.setState({ style: 'course_presentation' });
        };
        _this.handleToggleMultiCaption = function (value) {
            var current = _this.state.multiLoadCaptionMode === value;
            _this.setState({ multiLoadCaptionMode: current ? '' : value });
        };
        _this.handleMultiImgCaptionValueChange = function (id, value, mode) {
            var imgList = _this.state.multiLoadGrouppedImg.filter(function (img) { return (img === null || img === void 0 ? void 0 : img.id) === id; });
            var img = imgList[0];
            if (mode === 'caption') {
                img.isCaptionSetted = true;
                img.isTextSetted = false;
            }
            else {
                img.isCaptionSetted = false,
                    img.isTextSetted = true;
            }
            img[mode] = value;
            // console.log('multiLoadGroupState6', this.state.multiLoadGrouppedImg, this.state.multiLoadGrouppedImg.map((data) => {
            //   if (data?.id === img?.id) {
            //     return img
            //   }
            //   return data
            // }))
            _this.setState({
                multiLoadGrouppedImg: _this.state.multiLoadGrouppedImg.map(function (data) {
                    if ((data === null || data === void 0 ? void 0 : data.id) === (img === null || img === void 0 ? void 0 : img.id)) {
                        return img;
                    }
                    return data;
                })
            });
        };
        _this.handleRemoveMultiloadImgClick = function (id) {
            var _a, _b;
            var imgList = _this.state.multiLoadGrouppedImg.filter(function (img) { return (img === null || img === void 0 ? void 0 : img.id) !== id; });
            var isOneLeftAfterRemove = (imgList === null || imgList === void 0 ? void 0 : imgList.length) === 1;
            //Если после удаления остается одно изображение то открываем bigImg загрузчик
            // console.log('multiLoadGroupState7', imgList)
            _this.setState({
                multiLoadGrouppedImg: isOneLeftAfterRemove ? [] : imgList,
                bigImageSrc: isOneLeftAfterRemove ? (_a = imgList === null || imgList === void 0 ? void 0 : imgList[0]) === null || _a === void 0 ? void 0 : _a.src : '',
                imageId: isOneLeftAfterRemove ? (_b = imgList[0]) === null || _b === void 0 ? void 0 : _b.id : _this.state.imageId,
                multipleLoadSrc: isOneLeftAfterRemove ? [] : _this.state.multipleLoadSrc,
                style: isOneLeftAfterRemove ? 'big' : 'multiple'
            });
        };
        _this.handleColoredPostButton = function () {
            var projectId = _this.props.projectId || _this.props.lgid;
            var storageKey = projectId ? "lastCustomColor_".concat(projectId) : 'lastCustomColor';
            var lastCustomColor = localStorage.getItem(storageKey);
            if (_this.state.style === 'annotation') {
                return;
            }
            var lastColor = lastCustomColor;
            if (!lastCustomColor) {
                lastColor = _this.props.posts.reduce(function (result, _a, index) {
                    var color = _a.color, style = _a.style;
                    if (style === 'colored' && index < _this.props.num) {
                        return color;
                    }
                    return result;
                }, null);
            }
            var hex = lastColor && lastColor.startsWith('#') ? lastColor :
                _this.state.color === colorObj.white ? '#000000' : _this.state.color;
            _this.setState({
                color: hex,
                isTitleOpened: true,
                fontColor: _this.invertColor(hex, 'white', '#151514'),
                colorName: hex,
                isFirstLetter: false,
                text: "".concat(_this.state.text),
                firstLetter: '',
                style: 'colored',
                prevColorStatus: hex
            });
        };
        _this.handleLinkPostButton = function () {
            // Сначала пытаемся получить последний использованный кастомный цвет из localStorage
            var projectId = _this.props.projectId || _this.props.lgid;
            var storageKey = projectId ? "lastCustomColor_".concat(projectId) : 'lastCustomColor';
            var lastCustomColor = localStorage.getItem(storageKey);
            // Если нет сохраненного цвета, ищем последний цвет из существующих блоков
            var lastColor = lastCustomColor;
            if (!lastCustomColor) {
                lastColor = _this.props.posts.reduce(function (result, _a, index) {
                    var color = _a.color, style = _a.style;
                    if (style === 'link' && index < _this.props.num) {
                        return color;
                    }
                    return result;
                }, null);
            }
            // Если найден кастомный цвет (HEX), используем его, иначе используем черный по умолчанию
            var hex = lastColor && lastColor.startsWith('#') ? lastColor :
                _this.state.color === colorObj.white ? '#000000' : _this.state.color;
            _this.setState({
                color: hex,
                isTitleOpened: true,
                fontColor: _this.invertColor(hex, 'white', '#151514'),
                colorName: hex,
                isFirstLetter: false,
                text: "".concat(_this.state.text),
                firstLetter: '',
                style: 'link',
                prevColorStatus: hex,
                linkText: _this.state.linkText
            });
        };
        _this.handleSortedMultipleImgChange = function (list) {
            // console.log('multiLoadGroupState8', [...list])
            _this.setState({
                multiLoadGrouppedImg: __spreadArray([], list, true)
            });
        };
        _this.handleSortedProjects = function (projects) {
            _this.setState({
                projectIds: (projects === null || projects === void 0 ? void 0 : projects.map(function (project) { return project === null || project === void 0 ? void 0 : project.id; })) || []
            });
        };
        _this.handleSetCoursePresentation = function (projectId) {
            _this.setState({
                projectIds: [projectId]
            });
        };
        _this.handleDeleteProjects = function (deletedId) {
            var _a;
            var t = _this.props.t;
            if (!window.confirm(t('confirmation.project_block_item_delete')))
                return;
            _this.setState({
                projectIds: (_a = _this.state.projectIds) === null || _a === void 0 ? void 0 : _a.filter(function (id) { return id !== deletedId; })
            });
        };
        _this.updateFileList = function (fileName) {
            if (!_this.fileRef.current) {
                return;
            }
            var dt = new DataTransfer();
            if (!fileName) {
                _this.fileRef.current.files = dt === null || dt === void 0 ? void 0 : dt.files;
                return;
            }
            var currentFiles = Array.from(_this.fileRef.current.files);
            var newFiles = currentFiles.filter(function (f) { return f.name !== fileName; });
            newFiles.forEach(function (file) {
                dt.items.add(file);
            });
            var fileList = dt.files;
            _this.fileRef.current.files = fileList;
        };
        _this.handleImgRemove = function (id, name, needToConfirm) {
            var _a, _b, _c;
            var t = _this.props.t;
            if (needToConfirm) {
                if (!window.confirm(t('confirmation.image_delete')))
                    return;
            }
            var isEmpty = !((_b = (_a = _this.state.multiLoadGrouppedImg) === null || _a === void 0 ? void 0 : _a.filter(function (i) { return (i === null || i === void 0 ? void 0 : i.id) !== id; })) === null || _b === void 0 ? void 0 : _b.length);
            var isSpBlock = _this.state.style === 'super-puper-vote';
            var isSlider = _this.state.style === 'slider';
            _this.updateFileList(name);
            // console.log('multiLoadGroupState9', this.state.multiLoadGrouppedImg, this.state.multiLoadGrouppedImg?.filter(
            //   (i) => i?.id !== id
            // ))
            _this.setState({
                multiLoadGrouppedImg: (_c = _this.state.multiLoadGrouppedImg) === null || _c === void 0 ? void 0 : _c.filter(function (i) { return (i === null || i === void 0 ? void 0 : i.id) !== id; }),
                spVoteError: isSpBlock
            });
            if (_this.state.multiLoadGrouppedImg.length <= 1) {
                _this.setState({
                    style: 'normal'
                });
            }
            if (isEmpty && isSpBlock) {
                _this.setState({
                    multiLoadGrouppedImg: [],
                    multipleLoadSrc: [],
                    multipleLoadId: [],
                    spVoteError: false,
                });
                _this.uppy.cancelAll();
                _this.uppy.reset();
            }
        };
        _this.handleVideoButton = function () {
            // if (this.checkUnsavedData()) {
            //     this.setState({
            //       isUnsavedImages: true,
            //       prevStateValue: {
            //         style: 'video',
            //         color: '#FFFFFF',
            //         fontColor: '#151514',
            //         text: ''
            //       }
            //     })
            //   return;
            // }
            _this.setState({
                style: 'video',
                color: '#FFFFFF',
                fontColor: '#151514',
                text: ''
            });
        };
        _this.handleSlideTextChange = function (id, text, textPosition) {
            var _a;
            var isPositionUpdate = text === 'updatePosition';
            var index = (_a = _this.state.multiLoadGrouppedImg) === null || _a === void 0 ? void 0 : _a.findIndex(function (i) { return [i === null || i === void 0 ? void 0 : i.id, i === null || i === void 0 ? void 0 : i.postAttachmentId].includes(id); });
            var newArray = __spreadArray([], _this.state.multiLoadGrouppedImg, true);
            newArray[index] = __assign(__assign(__assign({}, newArray[index]), (isPositionUpdate ? {} : { text: text })), { textPosition: textPosition });
            // console.log('multiLoadGroupState10', newArray)
            _this.setState({
                multiLoadGrouppedImg: newArray
            });
        };
        _this.handleButtonLink = function () {
            _this.setState({
                secondaryStyle: _this.state.secondaryStyle === 'button-link' ? '' : 'button-link'
            });
        };
        _this.handleAnchorButton = function () {
            _this.setState({
                secondaryStyle: _this.state.secondaryStyle === 'button-anchor' ? '' : 'button-anchor'
            });
        };
        _this.handleAudioButton = function () {
            //   if (this.checkUnsavedData()) {
            //     this.setState({
            //       isUnsavedImages: true,
            //       prevStateValue: {
            //         style: 'audio',
            //         color: '#FFFFFF',
            //         fontColor: '#151514',
            //         text: ''
            //       }
            //     })
            //   return;
            // }
            _this.setState({
                style: 'audio',
                color: '#FFFFFF',
                fontColor: '#151514',
                text: ''
            });
        };
        _this.handleImageSources = function () {
            // if (this.checkUnsavedData()) {
            //   this.setState({
            //     isUnsavedImages: true,
            //     prevStateValue: {
            //       style: 'image_sources',
            //       color: '#FFFFFF',
            //       fontColor: '#151514',
            //     }
            //   })
            //   return;
            // }
            _this.setState({
                style: 'image_sources',
                color: '#FFFFFF',
                fontColor: '#151514'
            });
        };
        _this.handleBibliography = function () {
            // if (this.checkUnsavedData()) {
            //   this.setState({
            //     isUnsavedImages: true,
            //     prevStateValue: {
            //       style: 'bibliography',
            //       color: '#FFFFFF',
            //       fontColor: '#151514',
            //     }
            //   })
            //   return;
            // }
            _this.setState({
                style: 'bibliography',
                color: '#FFFFFF',
                fontColor: '#151514'
            });
        };
        _this.handleSPvote = function () {
            _this.setState({
                style: 'super-puper-vote',
                color: '#FFFFFF',
                fontColor: '#151514'
            });
        };
        _this.handleAddSlider = function () {
            // this.setState({
            //   style: 'slider',
            //   color: '#FFFFFF',
            //   fontColor: '#151514'
            // })
        };
        _this.handleAddTile = function () {
            _this.setState({ style: 'tile' });
        };
        _this.handleTogglePreviewer = function () {
            clearWidePreviewer();
        };
        _this.handleCardButton = function (type) {
            var _a = _this.props, modal = _a.modal, lgid = _a.lgid, num = _a.num, getLongReadPosts = _a.getLongReadPosts, setEditLongRead = _a.setEditLongRead, bookId = _a.bookId;
            modal.show('cardSelect', {
                themeColor: _this.props.colorStyle,
                onCardSelect: function (cardId) {
                    /*        urlApi()
                              .insertCard({
                                cardId,
                                longreadId: lgid,
                                position: num
                              })*/
                    /*          .then(() => {
                      if (bookId) urlApi().insertCardIntoBook({
                        cardId,
                        longreadId: lgid,
                        bookId: bookId
                      })
                    }) */
                    /*          .then(() => {
                                setTimeout(() => {
                                  getLongReadPosts('', lgid)
                                }, 1000)
                              })*/
                    // setEditLongRead(false, num)
                    modal.hide();
                    _this.setState({
                        additionalInfo: addOrChangeAdditionalInfo(_this.state.additionalInfo || [], [{ "name": CARDS_INFO_KEY, "value": JSON.stringify([{ cardId: cardId, isPay: false }]) }]),
                        style: type || 'card'
                    });
                }
            });
        };
        _this.handleProductsButton = function () {
            var _a = _this.props, modal = _a.modal, lgid = _a.lgid, num = _a.num, getLongReadPosts = _a.getLongReadPosts, setEditLongRead = _a.setEditLongRead, bookId = _a.bookId, teamId = _a.teamId;
            modal.show('productsSelect', {
                cardIds: getCardIdsFromAdditionalInfo(_this.state.additionalInfo, _this.state.cardIds),
                teamId: teamId,
                onSubmit: function (cardIds) {
                    modal.hide();
                    var additionalInfoUpdated = addOrChangeAdditionalInfo(_this.state.additionalInfo || [], [{ "name": CARDS_INFO_KEY, "value": JSON.stringify(cardIds === null || cardIds === void 0 ? void 0 : cardIds.map(function (cardId) { return ({ cardId: cardId, isPay: false }); })) }]);
                    var cardIdsUpdated = getCardIdsFromAdditionalInfo(additionalInfoUpdated, _this.state.cardIds);
                    _this.setState({
                        additionalInfo: additionalInfoUpdated,
                        cardIds: cardIdsUpdated,
                        style: 'products'
                    });
                }
            });
        };
        _this.handleProductsChange = function (cardIds) {
            var additionalInfoUpdated = addOrChangeAdditionalInfo(_this.state.additionalInfo || [], [{ "name": CARDS_INFO_KEY, "value": JSON.stringify(cardIds === null || cardIds === void 0 ? void 0 : cardIds.map(function (cardId) { return ({ cardId: cardId, isPay: false }); })) }]);
            var cardIdsUpdated = getCardIdsFromAdditionalInfo(additionalInfoUpdated, _this.state.cardIds);
            _this.setState({
                additionalInfo: additionalInfoUpdated,
                cardIds: cardIdsUpdated
            });
        };
        _this.handleProjects = function () {
            var _a;
            var _b = _this.props, maxProjects = _b.maxProjects, teamContexts = _b.teamContexts, teamExtraFilter = _b.teamExtraFilter, isPresentation = _b.isPresentation, onOpenSetProjectsModal = _b.onOpenSetProjectsModal;
            onOpenSetProjectsModal({
                maxProjects: maxProjects,
                teamContexts: teamContexts,
                teamExtraFilter: teamExtraFilter,
                isPresentation: isPresentation,
                alreadyProjects: ((_a = _this.state) === null || _a === void 0 ? void 0 : _a.projectIds) || [],
                onSelectProjects: function (projectIds) {
                    _this.setState({
                        style: 'projects',
                        projectIds: projectIds || []
                    });
                }
            });
        };
        _this.handleAddSpecialTools = function () {
            _this.setState({
                style: 'special-tools'
            });
        };
        _this.handleAddForms = function () {
            _this.setState({
                style: 'forms'
            });
        };
        _this.setCaption = function (value) {
            _this.setState({
                text: '',
                imageCaption: value,
                editingCaption: false,
                postTextPos: 'caption-bottom'
            });
        };
        _this.handleCaptionButton = function (position) {
            if (_this.state.style === 'two_pictures') {
                _this.setState({
                    editingCaption: true
                });
            }
            else if (_this.state.style === 'slider') {
                _this.setState({
                    editingCaption: true,
                    multiLoadCaptionMode: 'small'
                });
            }
            else if (_this.state.style === 'as_cover') {
                _this.setState({
                    editingCaption: true,
                    // postTextPos: 'inside'
                    postTextPos: position
                });
            }
            else if (_this.state.style === 'projects') {
                _this.setState({
                    editingCaption: true
                });
            }
            else {
                _this.setState({
                    style: 'image',
                    editingCaption: true,
                    postTextPos: 'caption-bottom'
                });
            }
        };
        _this.handleTextButton = function (position) {
            if (_this.state.style === 'slider') {
                _this.setState(function (_a) {
                    var editingText = _a.editingText;
                    return ({
                        editingText: !editingText,
                        editingCaption: false,
                        multiLoadCaptionMode: 'big',
                        postTextPos: position
                    });
                });
            }
            else if (_this.state.style === 'as_cover') {
                _this.setState({
                    editingText: true,
                    postTextPos: 'outside'
                });
            }
            else {
                _this.setState({
                    style: 'big',
                    postTextPos: position,
                    // imageCaption: ''
                });
            }
        };
        _this.handleClose = function () {
            var _a;
            var isPresentatiton = _this.props.isPresentation;
            var isColored = _this.state.style === 'colored' || _this.state.style === 'link';
            var isText = (_a = ['normal', 'normal_card', 'normal_image', 'normal_emblem']) === null || _a === void 0 ? void 0 : _a.includes(_this.state.style);
            var firstAsCoverSetted = _this.props.firstAsCover && _this.state.style === 'as_cover';
            if (isPresentatiton) {
                _this.updateFileList();
            }
            if (!isColored && !isText) {
                _this.onBlueArea();
            }
            _this.setState(__assign({ style: firstAsCoverSetted ? 'as_cover' : '', multiLoadGrouppedImg: [], multipleLoadSrc: [], multipleLoadId: [], firstOfCoverLoad: false, imageId: '', imageCaption: '', prevImageSrc: '', audioSrc: '', bigImageSrc: '', isColorChoose: false, isUnsavedImages: false, text: '', title: '', iframeLink: '' }, (_this.props.isFeed ? { isFocused: false } : {})
            // formPosition: FORM_CENTER_POS
            ));
            if (_this.props.isFeed) {
                document.body.classList.remove('opened__editor');
            }
            _this.props.toggleMobileEditor && _this.props.toggleMobileEditor(false);
            _this.uppy.reset();
        };
        _this.handleToggleUnsavedModal = function (val, prevStyle) {
            var prevValue = _this.state.prevStateValue;
            if (val) {
                _this.setState({
                    isUnsavedImages: false,
                });
                return;
            }
            // this.setState({
            //   isUnsavedImages: true,
            //   ...this.getClearedImageData(),
            //   ...prevValue,
            //   prevStateValue: null
            // })
            _this.handleClose();
        };
        _this.handleUnsavedChange = function () {
            if (IMAGES_STYLES.includes(_this.state.style)) {
                _this.setState({
                    isUnsavedImages: true,
                });
                return;
            }
            _this.handleClose();
        };
        _this.handleAnchorChange = function (text) {
            _this.setState({
                anchorText: text
            });
        };
        _this.removeImage = function () {
            _this.setState({
                imageId: '',
                imageCaption: '',
                prevImageSrc: '',
                bigImageSrc: ''
            });
            _this.uppy.reset();
        };
        _this.invertColor = function (bgColor, lightColor, darkColor) {
            var color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
            var r = parseInt(color.substring(0, 2), 16); // hexToR
            var g = parseInt(color.substring(2, 4), 16); // hexToG
            var b = parseInt(color.substring(4, 6), 16); // hexToB
            return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? darkColor : lightColor;
        };
        _this.chooseColor = function (color, isUserColor, hex) {
            // пост меняется на обычный если выбран белый цвет, не знаю, нужно ли еще, пока убрали, т.к. сбивает с толку
            // if ( 
            //   color === 'white' ||
            //   (isUserColor && (this.state.style !== 'colored' || this.state.style !== 'link')  && hex.toLowerCase() === '#FEFEFE'.toLowerCase())
            // ) {
            //   this.setState({
            //     color: colorObj[color],
            //     isTitleOpened: false,
            //     fontColor: colorObj.fonts[color],
            //     colorName: color,
            //     style: 'normal',
            //     prevColorStatus: color
            //     // multipleLoadId: [],
            //     // multipleLoadSrc: []
            //   })
            // } else 
            var calcStyle = _this.state.style === 'link' ? 'link' :
                _this.state.style === 'annotation' ? 'annotation' : 'colored';
            if (isUserColor && _this.state.style === "link") {
                if (hex && hex.startsWith('#')) {
                    var projectId = _this.props.projectId || _this.props.lgid;
                    var storageKey = projectId ? "lastCustomColor_".concat(projectId) : 'lastCustomColor';
                    localStorage.setItem(storageKey, hex);
                }
                _this.setState({
                    color: hex,
                    isTitleOpened: true,
                    fontColor: _this.invertColor(hex, 'white', '#151514'),
                    colorName: hex,
                    isFirstLetter: false,
                    text: "".concat(_this.state.text),
                    firstLetter: '',
                    style: calcStyle,
                    prevColorStatus: hex,
                    linkText: _this.state.linkText
                });
            }
            else if (isUserColor) {
                if (hex && hex.startsWith('#')) {
                    var projectId = _this.props.projectId || _this.props.lgid;
                    var storageKey = projectId ? "lastCustomColor_".concat(projectId) : 'lastCustomColor';
                    localStorage.setItem(storageKey, hex);
                }
                _this.setState({
                    color: hex,
                    isTitleOpened: true,
                    fontColor: _this.invertColor(hex, 'white', '#151514'),
                    colorName: hex,
                    isFirstLetter: false,
                    text: "".concat(_this.state.text),
                    firstLetter: '',
                    style: calcStyle,
                    prevColorStatus: hex
                    // multipleLoadId: [],
                    // multipleLoadSrc: []
                });
            }
            else {
                _this.setState({
                    color: colorObj[color],
                    isTitleOpened: true,
                    fontColor: colorObj.fonts[color],
                    colorName: color,
                    isFirstLetter: false,
                    text: "".concat(_this.state.text),
                    firstLetter: '',
                    style: calcStyle,
                    prevColorStatus: color
                    // multipleLoadId: [],
                    // multipleLoadSrc: []
                });
            }
        };
        _this.handleTextareaFocus = function (e) {
            var _a, _b, _c, _d;
            if (_this.state.secondaryStyle !== '')
                return false;
            var defaultTA = (_b = (_a = _this.textareaRef.current) === null || _a === void 0 ? void 0 : _a.firstChild) === null || _b === void 0 ? void 0 : _b.firstChild;
            defaultTA && defaultTA.focus();
            if (!_this.state.useRating) {
                var coloredTA = (_d = (_c = _this.coloredTextareaRef.current) === null || _c === void 0 ? void 0 : _c.firstChild) === null || _d === void 0 ? void 0 : _d.firstChild;
                coloredTA && coloredTA.focus();
            }
        };
        _this.onColoredTextareaResize = function (e) {
            var _a, _b, _c, _d;
            var height = e.target.offsetHeight;
            var htmlValue = e.target.value;
            var textLength = (_a = e.target.value) === null || _a === void 0 ? void 0 : _a.length;
            var linkProjectId = extractProjectId(htmlValue);
            var maxLengthRules = ((_b = ['annotation', 'block_with_title']) === null || _b === void 0 ? void 0 : _b.includes(_this.state.style)) ? 75 : 800;
            var calcStyle = ((_c = ['annotation', 'block_with_title']) === null || _c === void 0 ? void 0 : _c.includes(_this.state.style)) ?
                _this.state.style : 'normal';
            var calcValue = ((_d = ['annotation', 'block_with_title']) === null || _d === void 0 ? void 0 : _d.includes(_this.state.style)) ?
                htmlValue === null || htmlValue === void 0 ? void 0 : htmlValue.substring(0, maxLengthRules) : htmlValue;
            _this.setState({
                text: calcValue,
                linkProjectId: linkProjectId,
            }, function () {
                if (textLength > maxLengthRules) {
                    _this.props.toasts.error("\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0434\u043B\u0438\u043D\u0430: ".concat(maxLengthRules, " \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432"));
                    _this.setState({
                        text: e.target.value.substring(0, 2400),
                        color: colorObj.white,
                        isTitleOpened: false,
                        fontColor: colorObj.fonts.white,
                        isTextTooBig: true,
                        isColorChoose: false,
                        prevColorStatus: _this.state.colorName,
                        colorName: 'white',
                        style: calcStyle
                    });
                }
            });
            if (textLength > maxLengthRules) {
                setTimeout(function () {
                    return _this.setState({
                        color: colorObj.white,
                        isTitleOpened: false,
                        fontColor: colorObj.fonts.white,
                        isTextTooBig: true,
                        isColorChoose: false,
                        prevColorStatus: _this.state.colorName,
                        colorName: 'white',
                        style: calcStyle
                    });
                });
                // setTimeout(() => this.standartTA.current.focusTextInput(), 1000)
            }
            setTimeout(function () { return _this.setSizes(); });
        };
        _this.onCaptionChange = function (e) {
            var height = e.target.offsetHeight;
            var htmlValue = e.target.value.substring(0, 800);
            var textLength = e.target.value;
            var linkProjectId = extractProjectId(htmlValue);
            _this.setState({
                caption: htmlValue,
            }, function () {
                if (textLength > 800) {
                    _this.props.toasts.error('Максимальная длина: 800 символов');
                }
            });
        };
        _this.onLinkResize = function (e) {
            var height = e.target.offsetHeight;
            _this.setState({
                text: e.target.value
            }, function () {
                if (_this.state.text.length > 200) {
                    _this.props.toasts.error('Максимальная длина: 200 символов');
                    _this.setState({
                        text: e.target.value.substring(0, 200),
                        color: colorObj.white,
                        isTitleOpened: false,
                        fontColor: colorObj.fonts.white,
                        isTextTooBig: true,
                        isColorChoose: false,
                        prevColorStatus: _this.state.colorName,
                        colorName: 'white',
                        style: 'normal',
                        linkText: _this.state.linkText
                    });
                }
            });
            if (_this.state.text.length > 200) {
                setTimeout(function () {
                    return _this.setState({
                        color: colorObj.white,
                        isTitleOpened: false,
                        fontColor: colorObj.fonts.white,
                        isTextTooBig: true,
                        isColorChoose: false,
                        prevColorStatus: _this.state.colorName,
                        colorName: 'white',
                        style: 'normal'
                    });
                });
            }
            setTimeout(function () { return _this.setSizes(); });
        };
        _this.handleSetLink = function (link) {
            var linkProjectId = extractProjectId(link);
            _this.setState({ linkText: link, linkProjectId: linkProjectId });
        };
        _this.onSourcesTextareaChange = function (e) {
            onChangeBibliography(e, _this.state.style, function (val) { return _this.props.toasts.error(val); }, function (val) { return _this.setState(val); });
        };
        _this.onSourcesTextareaKeyUp = function (e) {
            _this.setState(function (prevState) { return (__assign(__assign({}, prevState), { text: modifyToListText(prevState.text, e) })); });
        };
        _this.onStandartTextareaChange = function (e) {
            var linkProjectId = extractProjectId(e.target.value);
            if (e.target.value.length < 2400) {
                _this.setState({
                    text: e.target.value,
                    linkProjectId: linkProjectId
                });
            }
            if (e.target.value.length >= 2400) {
                _this.props.toasts.error('Максимальная длина: 2400 символов');
                _this.setState({
                    text: e.target.value.substring(0, 2400)
                }, function () {
                    if (_this.state.text.length >= 2400) {
                        _this.setState({
                            text: e.target.value.substring(0, 2400)
                        });
                    }
                });
            }
            if (_this.state.text.length < 50) {
                _this.setState({
                    isFirstLetter: false,
                    text: "".concat(e.target.value),
                    firstLetter: ''
                });
            }
        };
        _this.escFunction = function (event) {
            if (event.keyCode === 27) {
                _this.onBlueArea(event);
            }
        };
        _this.setSizes = function () {
            var innerWidth = window.innerWidth;
            // отступ цветного блока
            if (_this.coloredTA.current !== null) {
                var textHeight = _this.coloredTA.current.offsetHeight;
                _this.setPaddings(textHeight, innerWidth);
            }
        };
        _this.setPaddings = function (textHeight, innerWidth) {
            var paddingsCurrent, heightsCurrent, calculatedHeightStyle;
            // проверяем ширину экрана
            if (innerWidth > MEDIA_QUERY) {
                paddingsCurrent = paddings.max;
                heightsCurrent = heights.max;
            }
            else {
                paddingsCurrent = paddings.min;
                heightsCurrent = heights.min;
            }
            // выставляем нужный паддинг
            calculatedHeightStyle = Math.round(textHeight / heightsCurrent);
            if (calculatedHeightStyle >= 4) {
                calculatedHeightStyle = 4;
            }
            _this.setState({
                coloredPadding: paddingsCurrent[calculatedHeightStyle]
            });
        };
        _this.handleTogglePostLikes = function (useRating) {
            _this.setState({ useRating: useRating });
        };
        _this.handleToggleRatingDataChange = function (val, ev) {
            var _a;
            var _b;
            var target = ev.target;
            var value = val;
            var key = (_b = target === null || target === void 0 ? void 0 : target.dataset) === null || _b === void 0 ? void 0 : _b['key'];
            var data = _this.state.ratings;
            data = {
                custom: __assign(__assign(__assign({}, INITIAL_RAITING), data.custom), (_a = {}, _a[key === 'name' ? 'name' : 'value'] = (key === 'name' ? value
                    : Number(value)), _a))
            };
            _this.setState({ ratings: data });
        };
        _this.onChangeImage = function (event, index) { return __awaiter(_this, void 0, void 0, function () {
            var _a, toasts, profile, files, appName, allowed, _b;
            var _this = this;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = this.props, toasts = _a.toasts, profile = _a.profile;
                        files = (_c = Array.from(event.target.files)) === null || _c === void 0 ? void 0 : _c.slice(0, 1);
                        appName = getAppNameFromAppString(this.props.appName);
                        _b = ['geograffee', 'deziiign', 'competition'].includes(appName);
                        if (!_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, uploadValidator({
                                files: files,
                                toasts: toasts,
                                profile: profile,
                                style: 'two_pictures'
                            })];
                    case 1:
                        _b = (_d.sent());
                        _d.label = 2;
                    case 2:
                        allowed = _b;
                        // console.log('onChangeIMAGE', '|', event, '|', index, '|', files, '|', event.target.files, '|', allowed, [...this.state.multiLoadGrouppedImg])
                        if (!allowed) {
                            event.target.value = '';
                            return [2 /*return*/];
                        }
                        this.uppy.reset();
                        files.forEach(function (file, i) {
                            var fr = new FileReader();
                            try {
                                _this.uppy.addFile({
                                    source: 'file input',
                                    name: file.name,
                                    type: file.type || 'application/octet-stream',
                                    data: file,
                                    meta: {
                                        contentType: file.type || 'application/octet-stream'
                                    }
                                });
                            }
                            catch (err) {
                                if (err.isRestriction) {
                                    // handle restrictions
                                    console.error('Restriction error:', err);
                                }
                                else {
                                    // handle other errors
                                    console.error(err);
                                }
                            }
                            fr.onload = function () {
                                var _a;
                                var newImg = (_a = __spreadArray([], _this.state.multiLoadGrouppedImg, true)) === null || _a === void 0 ? void 0 : _a.filter(function (img) {
                                    return (img === null || img === void 0 ? void 0 : img.name) != (file === null || file === void 0 ? void 0 : file.name);
                                    // return img.id
                                    // const nameMatch = !img.id && file.name
                                    // return img?.name != nameMatch
                                });
                                // const itemToStay = [...this.state.multiLoadGrouppedImg].find(img => img?.name != file?.name)
                                var replacedImg = newImg.find(function (img) { return (img === null || img === void 0 ? void 0 : img.name) === (file === null || file === void 0 ? void 0 : file.name); });
                                // console.log('newImg', newImg, this.state.multiLoadGrouppedImg, newImg[index])
                                var newItem = __assign(__assign({}, replacedImg), { name: file.name, isUploaded: false, files: undefined, progress: 0, src: fr.result });
                                // newImg[index] = {
                                //   ...newImg[index],
                                //   name: file.name,
                                //   isUploaded: false,
                                //   files: undefined,
                                //   progress: 0,
                                //   src: fr.result
                                // }
                                if (newImg.length > 1) {
                                    newImg[index] = newItem;
                                }
                                else {
                                    if (index === 0) {
                                        newImg.unshift(newItem);
                                    }
                                    if (index === 1) {
                                        newImg.push(newItem);
                                    }
                                }
                                // console.log('newImg multiLoadGroupState11', newImg, this.state, index, file)
                                _this.setState({
                                    multiLoadGrouppedImg: newImg
                                });
                            };
                            fr.readAsDataURL(file);
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.addFile = function (event, style, droppedFiles) { return __awaiter(_this, void 0, void 0, function () {
            var _a, toasts, profile, appName, isSPvote, isSlider, isCover, isTwoPictures, isPodcast, isEmblem, isAdditionalMultiLoad, files, multipleFilesCheckResult, fr_1;
            var _this = this;
            var _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = this.props, toasts = _a.toasts, profile = _a.profile;
                        appName = getAppNameFromAppString(this.props.appName);
                        isSPvote = style === 'super-puper-vote';
                        isSlider = (_b = ['slider', 'tile']) === null || _b === void 0 ? void 0 : _b.includes(style);
                        isCover = style === 'as_cover';
                        isTwoPictures = style === 'two_pictures';
                        isPodcast = style === 'podcast';
                        isEmblem = style === 'normal_emblem';
                        isAdditionalMultiLoad = !!((_c = this.state.multiLoadGrouppedImg) === null || _c === void 0 ? void 0 : _c.length) || isSlider;
                        multipleFilesCheckResult = [];
                        if (event === null) {
                            files = droppedFiles;
                        }
                        else {
                            files = isPodcast ? (_d = Array.from(event.target.files)) === null || _d === void 0 ? void 0 : _d.slice(0, 1) : Array.from(event.target.files);
                        }
                        if ((isSPvote || isTwoPictures) && ((files === null || files === void 0 ? void 0 : files.length) === 1 || (files === null || files === void 0 ? void 0 : files.length) > 2)) {
                            if ((files === null || files === void 0 ? void 0 : files.length) < 2) {
                                toasts.error('Выберите два изображения');
                            }
                            if ((files === null || files === void 0 ? void 0 : files.length) > 2) {
                                toasts.error('Максимальное количество изображений - 2');
                            }
                            this.setState({
                                spVoteError: true
                            });
                            return [2 /*return*/];
                        }
                        if (!((files === null || files === void 0 ? void 0 : files.length) > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all(files.map(function (img) { return __awaiter(_this, void 0, void 0, function () {
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            _a = ['geograffee', 'deziiign', 'competition'].includes(appName);
                                            if (!_a) return [3 /*break*/, 2];
                                            return [4 /*yield*/, uploadValidator({
                                                    files: [img],
                                                    toasts: toasts,
                                                    isWideImageType: isCover,
                                                    profile: profile,
                                                    style: style
                                                })];
                                        case 1:
                                            _a = (_b.sent());
                                            _b.label = 2;
                                        case 2: return [2 /*return*/, (_a)];
                                    }
                                });
                            }); }))];
                    case 1:
                        multipleFilesCheckResult = _e.sent();
                        _e.label = 2;
                    case 2:
                        if (multipleFilesCheckResult === null || multipleFilesCheckResult === void 0 ? void 0 : multipleFilesCheckResult.includes(false)) {
                            event.target.value = '';
                            return [2 /*return*/];
                        }
                        files.sort(function (a, b) {
                            var fileNameA = a.name[0];
                            var fileNameB = b.name[0];
                            return +fileNameB - +fileNameA;
                        });
                        // случай для одного загруженного файла, все как обычно
                        if (files.length === 1 && !isAdditionalMultiLoad) {
                            fr_1 = new FileReader();
                            this.uppy.reset();
                            this.setState({
                                multiLoadGrouppedImg: [],
                                multipleLoadSrc: [],
                                multipleLoadId: [],
                                firstOfCoverLoad: true,
                                isLoading: true,
                                style: style
                            });
                            files.forEach(function (file) {
                                try {
                                    _this.uppy.addFile({
                                        source: 'file input',
                                        name: file.name,
                                        type: file.type || 'application/octet-stream',
                                        data: file,
                                        meta: {
                                            contentType: file.type || 'application/octet-stream'
                                        }
                                    });
                                }
                                catch (err) {
                                    if (err.isRestriction) {
                                        // handle restrictions
                                        console.error('Restriction error:', err);
                                    }
                                    else {
                                        // handle other errors
                                        console.error(err);
                                    }
                                }
                                fr_1.onload = function () {
                                    var _a;
                                    if (style === 'small') {
                                        _this.setState({
                                            prevImageSrc: fr_1.result
                                        });
                                    }
                                    if (isPodcast) {
                                        _this.setState({
                                            text: ((_a = files[0]) === null || _a === void 0 ? void 0 : _a.name) || '',
                                            audioSrc: fr_1.result,
                                            firstOfCoverLoad: false
                                        });
                                    }
                                    if (style === 'big' || style === 'image' || style === 'as_cover' || style === 'normal_image' || style === 'normal_emblem') {
                                        _this.setState({
                                            bigImageSrc: fr_1.result,
                                            style: style,
                                            isColorChoose: true,
                                            firstOfCoverLoad: false
                                        });
                                    }
                                };
                                fr_1.readAsDataURL(files[0]);
                            });
                        }
                        // случай для нескольких загруженных файлов, отрефакторить как время будет
                        if (files.length > 1 || isAdditionalMultiLoad) {
                            if ((files === null || files === void 0 ? void 0 : files.length) > MAX_FILES_COUNT) {
                                this.props.toasts.error('Максимальное количество изображений 15');
                                return [2 /*return*/];
                            }
                            this.uppy.reset();
                            if (this.state.imageId && isSlider) {
                                // console.log('multiLoadGroupState12', ...this.state.multiLoadGrouppedImg, {
                                //   caption: "",
                                //   id: this.state.imageId,
                                //   isCaptionSetted: false,
                                //   isTextSetted: false,
                                //   isUploaded: true,
                                //   name: "",
                                //   src: this.state.prevImageSrc || this.state.bigImageSrc,
                                //   progress: 100
                                // })
                                this.setState({
                                    bigImageSrc: '',
                                    prevImageSrc: '',
                                    imageId: '',
                                    multiLoadGrouppedImg: __spreadArray([{
                                            caption: "",
                                            id: this.state.imageId,
                                            isCaptionSetted: false,
                                            isTextSetted: false,
                                            isUploaded: true,
                                            name: "",
                                            src: this.state.prevImageSrc || this.state.bigImageSrc,
                                            progress: 100
                                        }], this.state.multiLoadGrouppedImg, true),
                                    multipleLoadSrc: __spreadArray([this.state.prevImageSrc || this.state.bigImageSrc], this.state.multipleLoadSrc, true),
                                    multipleLoadId: [],
                                    spVoteError: false,
                                    style: isSPvote || isSlider || isTwoPictures ? style : 'multiple'
                                });
                            }
                            else {
                                this.setState({
                                    bigImageSrc: '',
                                    // multiLoadGrouppedImg: [],
                                    multipleLoadSrc: [],
                                    multipleLoadId: [],
                                    spVoteError: false,
                                    style: isSPvote || isSlider || isTwoPictures ? style : 'multiple'
                                });
                            }
                            files.forEach(function (file, i) {
                                var fr = new FileReader();
                                try {
                                    _this.uppy.addFile({
                                        source: 'file input',
                                        name: file.name,
                                        type: file.type || 'application/octet-stream',
                                        data: file,
                                        meta: {
                                            contentType: file.type || 'application/octet-stream'
                                        }
                                    });
                                }
                                catch (err) {
                                    if (err.isRestriction) {
                                        // handle restrictions
                                        console.error('Restriction error:', err);
                                    }
                                    else {
                                        // handle other errors
                                        console.error(err);
                                    }
                                }
                                fr.onload = function () {
                                    var _a;
                                    var copiedState = __spreadArray([], _this.state.multipleLoadSrc, true);
                                    var total = copiedState.push(fr.result);
                                    /* Добавляем base64 src */
                                    var grouppedImg = __spreadArray([], _this.state.multiLoadGrouppedImg, true);
                                    var newImg = (_a = __spreadArray([], _this.state.multiLoadGrouppedImg, true)) === null || _a === void 0 ? void 0 : _a.map(function (img) {
                                        if ((img === null || img === void 0 ? void 0 : img.name) === (file === null || file === void 0 ? void 0 : file.name)) {
                                            return __assign(__assign({}, img), { src: fr.result });
                                        }
                                        return img;
                                    });
                                    // console.log('multiLoadGroupState13', newImg)
                                    _this.setState({
                                        multipleLoadSrc: copiedState,
                                        multiLoadGrouppedImg: newImg
                                        // imageId: 'multiple',
                                    });
                                };
                                fr.readAsDataURL(file);
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.closeChooser = function () {
            _this.setState({
                isColorChoose: false,
                isTitleOpened: false,
                fontColor: colorObj.fonts.white,
                color: colorObj.white,
                colorName: 'white',
                style: 'normal',
                prevColorStatus: 'white'
            });
        };
        _this.onFocusArea = function (e) {
            e.target.setSelectionRange(e.target.value.length, e.target.value.length);
            _this.setState({
                isFocused: true
            });
            _this.props.setEditLongRead(true, _this.props.num);
            if (_this.wrapRef.current !== null) {
                _this.wrapRef.current.scrollIntoView({ block: 'center' });
            }
            var isFirstCover = _this.props.firstAsCover;
            var blocksLength = _this.props.blocksLength;
            // todo use styled components
            if (!isFirstCover && blocksLength > 0) {
                document.body.classList.add('opened__editor');
            }
        };
        _this.handleTileViewTypeChange = function (type) {
            _this.setState({
                tileViewType: type
            });
        };
        _this.handleTextPositionChange = function (text, position) {
            var isEmpty = !(text === null || text === void 0 ? void 0 : text.length);
            if (position === 'caption-bottom') {
                _this.setState({
                    imageCaption: text,
                    text: ''
                });
            }
            else {
                _this.setState({
                    text: text,
                    postTextPos: isEmpty ? '' : position,
                    imageCaption: ''
                });
            }
        };
        _this.handleSlideChecked = function (checked) {
            _this.setState({
                isRibbon: checked
            });
        };
        _this.handleChangeAdditionalStyle = function () {
            _this.setState({ secondaryStyle: '' });
        };
        _this.handleTitleBlock = function () {
            _this.setState({ style: 'block_with_title' });
        };
        _this.onBlueArea = function (e) {
            _this.setState({
                isFocused: false,
                style: 'normal'
            });
            if (_this.props.blocksLength === 0) {
                _this.props.setChooserEditor();
            }
            _this.setState({ animation: 'out' });
            _this.animationTimeout = setTimeout(function () {
                _this.props.setEditLongRead(false, -1);
            }, 500);
            setTimeout(function () {
                document.body.classList.remove('opened__editor');
            }, 0);
        };
        _this.addText = function (e) {
            if (e.target.value.length < 300) {
                _this.setState({
                    text: e.target.value,
                    imageCaption: ''
                });
            }
            if (e.target.value.length >= 300) {
                _this.setState({
                    text: e.target.value.substring(0, 298),
                    imageCaption: ''
                }, function () {
                    if (_this.state.text.length >= 300) {
                        _this.setState({
                            text: e.target.value.substring(0, 298),
                            imageCaption: ''
                        });
                    }
                });
            }
        };
        _this.state = {
            text: '',
            title: '',
            caption: '',
            editingCaption: false,
            postTextPos: 'inside',
            addButtonsOpened: false,
            color: colorObj.white,
            fontColor: colorObj.fonts.white,
            colorName: 'white',
            isColorChoose: false,
            isTitleOpened: false,
            tileViewType: TileViewType.twoRow,
            imageId: '',
            imageCaption: '',
            prevImageSrc: '',
            audioSrc: '',
            bigImageSrc: '',
            style: '',
            secondaryStyle: '',
            isTextTooBig: false,
            prevColorStatus: 'white',
            isFirstLetter: false,
            firstLetter: '',
            isLoading: false,
            isFocused: false,
            isRibbon: false,
            linkProjectId: '',
            coloredPadding: 57,
            multipleLoadId: [],
            multipleLoadSrc: [],
            multiLoadisStart: false,
            multiLoadPosition: 0,
            multiLoadCaptionMode: '',
            multiLoadGrouppedImg: [],
            projectIds: [],
            isMultiLoad: false,
            isMultipleFetchStart: false,
            animation: 'in',
            isUnsavedImages: false,
            prevStateValue: null,
            isTest: false,
            imagesUploaded: null,
            firstOfCoverLoad: false,
            spVoteError: false,
            formId: '',
            formPosition: FORM_CENTER_POS,
            anchorText: '',
            iframeLink: '',
            linkText: '',
            buttons: [],
            lessonPostDisabled: true,
            cardIds: [],
            useRating: false,
            ratings: {
            // like: {
            //   name: [{lang: 'ru', name: 'Официальный рейтинг'}, {lang: 'en', name: 'Official rating'}],
            //   value: 0
            // }
            },
            onLessonSave: function () { }
        };
        _this.fileRef = React.createRef();
        _this.standartTA = React.createRef();
        _this.bigimageRef = React.createRef();
        _this.coloredTA = React.createRef();
        _this.wrapRef = React.createRef();
        _this.overlayRef = React.createRef();
        _this.textareaRef = React.createRef();
        _this.coloredTextareaRef = React.createRef();
        // потом возможно в отдельную сущность вынести
        _this.uppy = new Uppy({
            restrictions: { maxNumberOfFiles: MAX_FILES_COUNT },
            allowMultipleUploads: true,
            meta: { type: 'image/jpeg' },
            autoProceed: true,
            onBeforeUpload: function (files) {
                var _a, _b, _c;
                var isSlider = _this.state.style === 'slider';
                var isTile = _this.state.style === 'tile';
                var isTwoPictures = _this.state.style === 'two_pictures';
                var total = (_a = _this.state.multiLoadGrouppedImg) === null || _a === void 0 ? void 0 : _a.length;
                var maxFiles = isTwoPictures ? 2 : isTile ? 9 : MAX_FILES_COUNT;
                var isMaxFilesCount = (isSlider || isTile || (isTwoPictures && !((_b = _this.state.multiLoadGrouppedImg) === null || _b === void 0 ? void 0 : _b.length))) && total > maxFiles;
                if (isMaxFilesCount) {
                    _this.props.toasts.error("\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E ".concat(isSlider ? 'cлайдов' : 'изображений', " - ").concat(maxFiles));
                    // console.log('multiLoadGroupState1', [...this.state.multiLoadGrouppedImg].slice(0, maxFiles), this.state.multiLoadGrouppedImg, maxFiles)
                    _this.setState({
                        multiLoadGrouppedImg: __spreadArray([], _this.state.multiLoadGrouppedImg, true).slice(0, maxFiles)
                    });
                }
                if (((_c = Object.keys(files)) === null || _c === void 0 ? void 0 : _c.length) > 1) {
                    var isSPvote = _this.state.style === 'super-puper-vote';
                    _this.setState({
                        style: isSPvote
                            ? 'super-puper-vote'
                            : isSlider
                                ? 'slider'
                                : isTile
                                    ? 'tile'
                                    : _this.state.style === 'two_pictures'
                                        ? 'two_pictures'
                                        : 'multiple',
                        isMultiLoad: true
                    });
                }
            }
        })
            .use(Tus, {
            endpoint: "".concat(Endpoints.uploader, "/upload/"),
            chunkSize: 4194304
        })
            .use(FileInput, {
            target: _this.fileRef.current,
            id: 'fileRef',
            pretty: true,
            inputName: 'files[]',
            locale: {}
        })
            .use(FileInput, {
            target: _this.bigimageRef.current,
            id: 'bigimage',
            pretty: true,
            inputName: 'files[]',
            locale: {}
        });
        _this.uppy.on('file-added', function (file) {
            var _a;
            var isMultipleLoad = ['multiple', 'super-puper-vote', 'slider', 'two_pictures', 'tile'].includes(_this.state.style)
                || !!((_a = _this.state.multiLoadGrouppedImg) === null || _a === void 0 ? void 0 : _a.length);
            /* Добавляем имя и дополнительные поля */
            if (isMultipleLoad) {
                var result = [];
                result.push.apply(result, __spreadArray(__spreadArray([], _this.state.multiLoadGrouppedImg, false), [{
                        name: file === null || file === void 0 ? void 0 : file.name,
                        isUploaded: false,
                        caption: '',
                        isCaptionSetted: false,
                        text: '',
                        isTextSetted: false,
                        progress: 0,
                    }], false));
                // console.log('multiLoadGroupState2', result)
                _this.setState({
                    multiLoadGrouppedImg: result
                });
            }
        });
        _this.uppy.on('upload-progress', function (file, progress) {
            var _a;
            if (_this.state.isMultiLoad) {
                var uppyState_1 = (_a = _this.uppy.getState()) === null || _a === void 0 ? void 0 : _a.files;
                setTimeout(function () {
                    var _loop_1 = function (key) {
                        var name_1 = uppyState_1[key].name;
                        var progress_1 = uppyState_1[key].progress.percentage;
                        /* Добавляем проценты прогресса */
                        // console.log(`PROGRESS FOR ${name} ->  ${progress}`)
                        var result = __spreadArray([], _this.state.multiLoadGrouppedImg, true).map(function (i) {
                            var isUploaded = (i === null || i === void 0 ? void 0 : i.progress) === 100;
                            if (isUploaded) {
                                return i;
                            }
                            if ((i === null || i === void 0 ? void 0 : i.name) === name_1) {
                                return __assign(__assign({}, i), { progress: progress_1 });
                            }
                            return i;
                        });
                        // console.log('multiLoadGroupState3', result)
                        _this.setState({
                            multiLoadGrouppedImg: result
                        });
                    };
                    for (var key in uppyState_1) {
                        _loop_1(key);
                    }
                }, 1500);
            }
        });
        _this.uppy.on('upload-success', function (file, response) {
            var _a;
            var isSuccess = ((_a = response === null || response === void 0 ? void 0 : response.uploadURL) === null || _a === void 0 ? void 0 : _a.length) > 1;
            setTimeout(function () {
                if (isSuccess) {
                    /* Добавляем поле об успешном добавлении */
                    var result = __spreadArray([], _this.state.multiLoadGrouppedImg, true).map(function (i) {
                        if ((i === null || i === void 0 ? void 0 : i.name) === (file === null || file === void 0 ? void 0 : file.name)) {
                            return __assign(__assign({}, i), { isUploaded: true });
                        }
                        return i;
                    });
                    // console.log('multiLoadGroupState4', result)
                    _this.setState({
                        multiLoadGrouppedImg: result
                    });
                }
            }, 1500);
        });
        _this.uppy.on('complete', function (result) {
            var _a;
            var isAdditionalMultiLoad = !!((_a = _this.state.multiLoadGrouppedImg) === null || _a === void 0 ? void 0 : _a.length);
            try {
                if (result.successful.length > 1 || isAdditionalMultiLoad) {
                    // загрузка сразу пачки картинок, добавляем айди от каждой
                    result.successful.forEach(function (item, idx) {
                        var url = item.uploadURL;
                        var linkT = url.split('/');
                        var lngh = linkT.length - 1;
                        var id = linkT[lngh];
                        var grouppedImg = __spreadArray([], _this.state.multiLoadGrouppedImg, true);
                        var imgIndex = grouppedImg.findIndex(function (i) {
                            return (i === null || i === void 0 ? void 0 : i.name) === (item === null || item === void 0 ? void 0 : item.name) && !(i === null || i === void 0 ? void 0 : i.isUploaded);
                        });
                        var newImg = [];
                        if (grouppedImg.find(function (i) { return (i === null || i === void 0 ? void 0 : i.id) === id; })) {
                            _this.props.toasts.error("\u0424\u0430\u0439\u043B \u0441 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435\u043C ".concat(item === null || item === void 0 ? void 0 : item.name, " \u0443\u0436\u0435 \u0431\u044B\u043B \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D"));
                            newImg = grouppedImg.filter(function (i, index) { return index !== imgIndex; });
                        }
                        else {
                            newImg = grouppedImg.map(function (i) {
                                if ((i === null || i === void 0 ? void 0 : i.name) === (item === null || item === void 0 ? void 0 : item.name)) {
                                    return __assign(__assign({}, i), { id: id });
                                }
                                return i;
                            });
                        }
                        // console.log('multiLoadGroupState5', newImg)
                        _this.setState({
                            multiLoadGrouppedImg: newImg
                        });
                    });
                    return;
                }
                if (result.successful.length === 1) {
                    var url = result.successful[0].uploadURL;
                    var linkT = url.split('/');
                    var lngh = linkT.length - 1;
                    var id = linkT[lngh];
                    _this.setState({
                        imageId: id,
                        isLoading: false
                    });
                    // setTimeout(() => {
                    //   this.setState({
                    //     imageId: id,
                    //     isLoading: false
                    //   })
                    // }, [3000])
                }
            }
            catch (e) {
                console.error(e);
            }
        });
        return _this;
    }
    NewEl.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        var _a, _b, _c, _d;
        if (this.props.addlgpost.isFetching === false &&
            ((_a = this.state.multiLoadGrouppedImg) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
            this.state.multiLoadisStart === true) {
            var userid = localStorage.getItem('userId');
            var reverseParam = this.props.isFeed;
            var isSlider = this.state.style === 'slider' || this.state.style === 'tile';
            var isTwoPictures = this.state.style === 'two_pictures';
            var isRibbon = this.state.isRibbon;
            var grouppedImage = this.state.multiLoadGrouppedImg;
            var newAdditionalInfo = addOrChangeAdditionalInfo(this.state.additionalInfo || [], [
                { "name": "tileViewType", "value": this.state.tileViewType }
            ]);
            this.props.addManyLongReadPost(grouppedImage, userid, this.props.lgid, false, '', isSlider || isTwoPictures ? this.state.text : '', 'white', this.props.num, this.props.thematic, this.handleSetIsMultiLoadingStart, this.state.style, isSlider || isTwoPictures ? this.state.imageCaption : '', this.state.postTextPos, this.state.anchorText, this.props.generalProps, this.state.style !== 'multiple' ? this.state.useRating : null, isRibbon, reverseParam, newAdditionalInfo);
            var newmulptipleId = __spreadArray([], this.state.multipleLoadId, true);
            var newmultiPost = __spreadArray([], this.state.multipleLoadSrc, true);
            // const removedPost = newmultiPost.splice(0, 1)
            // const removedId = newmulptipleId.splice(0, 1)
            this.setState({
                multipleLoadSrc: newmultiPost,
                multipleLoadId: newmulptipleId,
                multiLoadPosition: this.state.multiLoadPosition++,
                multiLoadisStart: false,
                isMultipleFetchStart: true
            }, function () {
                if (_this.state.multipleLoadSrc.length === 0) {
                    window.location.reload();
                }
            });
            if (this.props.isFeed) {
                setTimeout(function () {
                    _this.setState({
                        multiLoadGrouppedImg: [],
                        multipleLoadSrc: [],
                        style: '',
                        isMultipleFetchStart: false
                    });
                }, 2000);
            }
        }
        if (((_b = [
            'colored',
            'link',
            'normal_image',
            'normal',
            'normal_card',
            'normal_emblem'
        ]) === null || _b === void 0 ? void 0 : _b.includes(this.state.style)) &&
            !!((_c = this.state.linkProjectId) === null || _c === void 0 ? void 0 : _c.length)) {
            var field = ((_d = [
                'colored',
                'normal_image',
                'normal',
                'normal_card',
                'normal_emblem'
            ]) === null || _d === void 0 ? void 0 : _d.includes(this.state.style)) ? 'text' : 'linkText';
            this.replaceHiddenProjectLink(this.state.linkProjectId, field);
        }
    };
    NewEl.prototype.componentWillUnmount = function () {
        this.uppy.close();
        this.props.toggleMobileEditor && this.props.toggleMobileEditor(false);
        document.removeEventListener('keydown', this.escFunction, false);
    };
    NewEl.prototype.componentDidMount = function () {
        // document.body.classList.add('opened__editor')
        document.addEventListener('keydown', this.escFunction, false);
        if (this.props.importantStyle === 'annotation') {
            var hex = this.state.color === colorObj.white ? '#000000' : this.state.color;
            this.setState({
                style: this.props.importantStyle,
                fontColor: this.invertColor(hex, 'white', '#151514'),
                colorName: hex,
                color: hex
            });
        }
        if (this.props.ev && this.props.ev.length > 0) {
            if (this.props.dropZone === 'small') {
                this.addFile(null, 'small', this.props.ev);
            }
            if (this.props.dropZone === 'big') {
                this.addFile(null, 'big', this.props.ev);
            }
            if (this.props.dropZone === 'image') {
                this.addFile(null, 'image', this.props.ev);
            }
            if (this.props.dropZone === 'multiple') {
                this.addFile(null, 'multiple', this.props.ev);
            }
            if (this.props.dropZone === 'super-puper-vote') {
                this.addFile(null, 'super-puper-vote', this.props.ev);
            }
            if (this.props.dropZone === 'slider') {
                this.addFile(null, 'slider', this.props.ev);
            }
            if (this.props.dropZone === 'tile') {
                this.addFile(null, 'tile', this.props.ev);
            }
            if (this.props.dropZone === 'two_pictures') {
                this.addFile(null, 'two_pictures', this.props.ev);
            }
            if (this.props.dropZone === 'as_cover') {
                this.addFile(null, 'presentation', this.props.ev);
            }
        }
        // if (this.props.isPresentation && this.props.firstAsCover) {
        //   this.setState({
        //     style: 'as_cover'
        //   })
        // }
        if (this.props.dropZone === 'video') {
            this.setState({
                style: 'video'
            });
        }
        if (this.props.dropZone === 'audio') {
            this.setState({
                style: 'audio'
            });
        }
    };
    NewEl.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        var isMultiLoadDisabled = (_a = this.state.multiLoadGrouppedImg) === null || _a === void 0 ? void 0 : _a.every(function (img) { return img.isUploaded; });
        var isMultipleLoadingStart = this.state.isMultipleFetchStart;
        var isMultiLoad = this.state.style === 'multiple';
        var isSPvote = this.state.style === 'super-puper-vote';
        var isSlider = (_b = ['slider', 'tile']) === null || _b === void 0 ? void 0 : _b.includes(this.state.style);
        var isProjects = this.state.style === 'projects';
        var isForms = this.state.style === 'forms';
        var isProducts = this.state.style === 'products';
        var isCard = this.state.style === 'card';
        var isTwoPictures = this.state.style === 'two_pictures';
        var canSaveWPimage = (this.state.style === 'normal_image' && (this.state.bigImageSrc === '' || this.state.text.length === 0));
        var canSaveWPcard = (this.state.style === 'normal_card' && (!((_c = this.state.additionalInfo) === null || _c === void 0 ? void 0 : _c.find(function (i) { return (i === null || i === void 0 ? void 0 : i.name) === CARDS_INFO_KEY; })) || this.state.text.length === 0));
        var isDisabled = this.state.style === 'podcast' ? (((_d = this.state.text) === null || _d === void 0 ? void 0 : _d.length) === 0 && ((_e = this.state.iframeLink) === null || _e === void 0 ? void 0 : _e.length) === 0) : this.state.style === 'course_lesson' ? this.state.lessonPostDisabled : (this.state.style === 'projects' || this.state.style === 'course_presentation') ? ((_f = this.state.projectIds) === null || _f === void 0 ? void 0 : _f.length) === 0
            : this.state.style === 'multiple' ? (!isMultiLoadDisabled || isMultipleLoadingStart)
                : isForms ? this.state.formId === ''
                    : (isProducts || isCard) ? !((_g = getCardIdsFromAdditionalInfo(this.state.additionalInfo, this.state.cardIds)) === null || _g === void 0 ? void 0 : _g.length) : (isSPvote || isSlider || isTwoPictures) ? (!isMultiLoadDisabled
                        || isMultipleLoadingStart
                        || this.state.spVoteError
                        || ((_h = this.state.multiLoadGrouppedImg) === null || _h === void 0 ? void 0 : _h.length) < 2
                        || (isSlider && ((_j = this.state.multiLoadGrouppedImg) === null || _j === void 0 ? void 0 : _j.length) > MAX_FILES_COUNT)
                        || (isTwoPictures && this.state.ratioError))
                        : this.state.style === 'as_cover' ? (this.state.imageId === '') :
                            (canSaveWPimage || canSaveWPcard) ? true
                                : (this.state.style === 'normal_card' && (!((_k = this.state.additionalInfo) === null || _k === void 0 ? void 0 : _k.find(function (i) { return (i === null || i === void 0 ? void 0 : i.name) === CARDS_INFO_KEY; })) || this.state.text.length === 0)) ? true
                                    : !!((this.state.text.length === 0 && this.state.imageId === '') || this.state.isLoading);
        var isImageUploaded = this.state.imageId !== '';
        var multipleImagesLoad = (_l = this.state.multiLoadGrouppedImg) === null || _l === void 0 ? void 0 : _l.every(function (img) { return img.src; });
        var _0 = this.props, blocksLength = _0.blocksLength, alreadyHasBibliography = _0.alreadyHasBibliography, alreadyHasImageSources = _0.alreadyHasImageSources, t = _0.t, hasSpecialSourcesBlocks = _0.hasSpecialSourcesBlocks, canAddSpBLock = _0.canAddSpBLock, isFeed = _0.isFeed, commentsAllowed = _0.commentsAllowed;
        var showInModal = blocksLength > 0;
        var isModal = (this.props.editLongRead.isEdit && showInModal && !commentsAllowed);
        var hideOffset = (this.props.isLMS && !isModal) || (this.props.isPresentation && window.innerWidth <= 992) /*&& !!this.props.posts?.length*/;
        var _1 = this.state, style = _1.style, imageCaption = _1.imageCaption, editingCaption = _1.editingCaption, postTextPos = _1.postTextPos;
        var colorStyle = this.props.colorStyle;
        var additionalStyle = this.state.secondaryStyle;
        var isImage = ['image', 'big'].includes(style);
        var isMedia = ['video', 'audio'].includes(style);
        var isImageCaptionSetted = this.state.style === 'image' && this.state.imageCaption !== '';
        var isBigImageTextSetted = this.state.style === 'big' && this.state.text !== '';
        var currentActiveCaption = isImageCaptionSetted ? 'small-caption' : isBigImageTextSetted ? 'big-caption' : null;
        var hasImage = this.state.bigImageSrc !== '' || !!((_m = this.state.multiLoadGrouppedImg) === null || _m === void 0 ? void 0 : _m.length);
        var hasCover = (_o = this.props.posts) === null || _o === void 0 ? void 0 : _o.some(function (post) { return (post === null || post === void 0 ? void 0 : post.style) === 'as_cover'; });
        var isExam = (_p = this.props.posts) === null || _p === void 0 ? void 0 : _p.some(function (post) { return (post === null || post === void 0 ? void 0 : post.style) === 'course_exam'; });
        var isPresentation = ((this.props.firstAsCover && this.props.isPresentation) || style === 'as_cover') && !isModal;
        var firstBlockAsCover = ((this.props.firstAsCover && !isPresentation) || this.props.style === 'as_cover') && !isModal && !hasCover;
        var ratingEditorVisible = !!this.state.useRating;
        var isPresentationLoader = this.props.firstAsCover && !isModal && !this.props.isLMS;
        var ImagesNotUploaded = (this.state.imagesUploaded === false && !isPresentation) || (!isPresentation && this.state.isLoading);
        var showLoader = !!this.state.firstOfCoverLoad;
        var showPresentationLoader = isPresentation && (!!this.state.isLoading || this.state.imagesUploaded === false);
        var height = (_r = (_q = this.overlayRef) === null || _q === void 0 ? void 0 : _q.current) === null || _r === void 0 ? void 0 : _r.scrollHeight;
        var scroll = (_t = (_s = this.overlayRef) === null || _s === void 0 ? void 0 : _s.current) === null || _t === void 0 ? void 0 : _t.scrollTop;
        var bottomOffset = this.props.isFeed ? 0 : 50;
        var updatePortal = !hasCover && blocksLength === 0;
        var hideBackground = isPresentation; /*&& (this.state.postTextPos === 'outside' || !!this.props.editorComponent)*/
        var blackBG = (this.state.style === 'multiple' || isSlider) && !!((_u = this.state.multiLoadGrouppedImg) === null || _u === void 0 ? void 0 : _u.length);
        var captionColorStyle = isModal ? 'contrast' : colorStyle;
        var isBottom = !isImage && !isMultiLoad && !isPresentation && !isSlider && !isProjects && !isTwoPictures;
        var isTop = isImage || isSlider || isPresentation || isProjects || isMultiLoad || isTwoPictures;
        var textValue = !((_v = this.state.text) === null || _v === void 0 ? void 0 : _v.length) ? imageCaption : !(imageCaption === null || imageCaption === void 0 ? void 0 : imageCaption.length) ? this.state.text : this.state.text;
        var disableReason = isTwoPictures && this.state.ratioError
            ? 'Высота блока слишком большая. Минимальное \n соотношение сторон - 0.6. Выберите \n изображения с другими пропорциями.'
            : null;
        var cardIds = getCardIdsFromAdditionalInfo(this.state.additionalInfo, this.state.cardIds);
        var appName = getAppNameFromAppString(this.props.appName);
        var isGallllery = ['gallllery'].includes(appName);
        // console.log('srcList newel',this.state.multiLoadGrouppedImg)
        var editorToolbar = (React.createElement(EditorToolbar, { style: style, position: isBottom ? 'bottom' : isTop ? 'top' : 'none', additionalStyle: additionalStyle, variant: 'add', typeConnection: this.props.typeConnection, bookId: this.props.bookId, cardId: (cardIds === null || cardIds === void 0 ? void 0 : cardIds.length) > 0 ? cardIds[0] : this.state.cardId, disableReason: disableReason, hasBibliography: !alreadyHasBibliography && hasSpecialSourcesBlocks, hasImageSources: !alreadyHasImageSources && hasSpecialSourcesBlocks, isExam: isExam, localAllowedActions: this.props.allowedActions, canAddSpBLock: canAddSpBLock, editingCaption: editingCaption, postDisabled: isDisabled, spVoteError: this.state.spVoteError, onAdditionalStyleDelete: this.handleChangeAdditionalStyle, onClose: this.handleUnsavedChange, onAddCaption: this.handleCaptionButton, onAddText: this.handleTextButton, onAddVideo: this.handleVideoButton, onAddProjects: this.handleProjects, onAddAudio: this.handleAudioButton, onAddButtonLink: this.handleButtonLink, onAddAnchorButton: this.handleAnchorButton, onAddImageSources: this.handleImageSources, onAddBibliography: this.handleBibliography, onAddCard: this.handleCardButton, onAddProduct: this.handleProductsButton, onAddSpecialTools: this.handleAddSpecialTools, onAddColoredPost: this.handleColoredPostButton, onAddLinkPost: this.handleLinkPostButton, onAddWhitePost: this.handleWhitePostButton, onAddWhitePostImages: this.handleWhitePostImageButton, onAddLesson: this.handleAddLesson, onAddPodcast: this.handleAddPodcast, onAddCoursePresentation: this.handleAddCoursePresentation, onTogglePostLikes: this.handleTogglePostLikes, onSubmit: style === 'course_lesson' ? this.addNewLGLessonPost : this.addNewLGPost, onAddImage: this.addFile, onAddTitlePost: this.handleTitleBlock, onAddVotePost: this.handleSPvote, onAddSlider: this.handleAddSlider, onAddTile: this.handleAddTile, onAddForms: this.handleAddForms, anchorText: this.state.anchorText, onAnchorChange: this.handleAnchorChange, onToggleWidePreviewer: this.handleTogglePreviewer, onToggleMultiCaption: this.handleToggleMultiCaption, fileRef: this.fileRef, specialTools: this.props.specialTools, appName: this.props.appName, postWithRaiting: this.state.useRating, multiLoadCaptionMode: this.state.multiLoadCaptionMode, additionalInfo: this.state.additionalInfo, setAdditionalInfo: function (additionalInfo) {
                _this.setState({ additionalInfo: additionalInfo });
            }, currentActiveCaption: currentActiveCaption, hasImage: hasImage, isPresentationLoader: isPresentationLoader, postTextPos: this.state.postTextPos, isPresentation: isPresentation, setSliderControlsPlacer: function () {
                var sliderControlsPlacer = document.querySelector('#slider-controls-portal');
                _this.setState({ sliderControlsPlacer: sliderControlsPlacer });
            }, colorPickerComponent: React.createElement(React.Fragment, null, (style === 'colored' || style === "link" || style === 'annotation') && (React.createElement(ColorMenuComp, { color: this.state.color, closeChooser: this.closeChooser, chooseColor: this.chooseColor, bigimageRef: this.bigimageRef, addFile: this.addFile, clickedAction: this.addNewLGPost, isDisabled: isDisabled, postType: this.state.style, style: 'add', src: this.state.bigImageSrc }))), isGalleryBp: this.props.isGalleryBp }));
        return (React.createElement(React.Fragment, null,
            React.createElement(FixedOverlay, { ref: this.overlayRef, isModal: isModal, animation: this.state.animation, isMultiLoad: isMultiLoad, visibleOnMobile: !!isPresentation },
                React.createElement(FixedOverlay2, { isModal: isModal, isPresentation: isPresentation, bottomOffset: bottomOffset },
                    isModal && React.createElement(FixedBg, { onClick: function (e) { return _this.onBlueArea(e); } }),
                    (this.state.style === 'image_sources' ||
                        this.state.style === 'bibliography') && (React.createElement(UpdateHeaderToggle, { colorStyle: colorStyle, isModal: isModal }, t('editor.' + this.state.style))),
                    showLoader && React.createElement(LoaderModal, { placeholder: t('modal.load') }),
                    React.createElement(Wrap, { isGalllleryNewStyle: isGallllery, isGalleryBp: this.props.isGalleryBp, ref: this.wrapRef, isFeed: this.props.isFeed, isFocused: this.props.editLongRead.isEdit, colorStyle: this.props.colorStyle, withHeader: this.state.style === 'image_sources' ||
                            this.state.style === 'bibliography', hideBackground: hideBackground, hideOffset: hideOffset, blackBG: blackBG, className: this.state.className, isModal: isModal, viewType: this.props.viewType, isPresentationLoader: isPresentationLoader },
                        ImagesNotUploaded && React.createElement(MultipleLoaderModal, null),
                        this.state.isUnsavedImages && React.createElement(NotSavedImagesModal, { onClick: this.handleToggleUnsavedModal, prevStyle: style, height: height, scroll: scroll }),
                        !((_w = this.props) === null || _w === void 0 ? void 0 : _w.isLMSMain) && isTop && editorToolbar,
                        editingCaption && ['slider', 'image', 'projects', 'two_pictures', 'tile'].includes(style) && (React.createElement(CaptionEdit, { value: textValue, onSubmit: function (value) { return _this.setCaption(value); }, onCancel: function () { return _this.setState({ editingCaption: false }); } })),
                        style === 'big' || style === 'image' ? (React.createElement(React.Fragment, null,
                            additionalStyle !== '' && (React.createElement(ButtonBlock, { type: additionalStyle, uprise: UPRISE_TYPE.dropdown, onAddNewButton: this.handlePostButtonsChange })),
                            React.createElement(BigImageComp, { isLoading: this.state.isLoading, uppy: this.uppy, src: this.state.bigImageSrc, TAvalue: textValue, TAOnChange: this.addText, style: this.state.style, textPosition: postTextPos }))) : style === 'card' ? (React.createElement(BigImageCard, { isLoading: this.state.isLoading, uppy: this.uppy, src: this.state.bigImageSrc, TAvalue: textValue, cardIds: getCardIdsFromAdditionalInfo(this.state.additionalInfo, this.state.cardIds), TAOnChange: this.addText, style: this.state.style, textPosition: postTextPos })) : isPresentation ? (React.createElement(PresentationBlock, { theme: this.props.theme, blocksLength: this.props.blockLength, colorStyle: this.props.colorStyle, src: this.state.bigImageSrc, fileRef: this.fileRef, onAddImage: this.addFile, TAvalue: this.state.text, TAOnChange: this.addText, postDisabled: isDisabled, isEditingCaption: editingCaption, postTextPos: this.state.postTextPos, onPresentationHeaderChange: this.props.onPresentationHeaderChange, editorComponent: this.props.editorComponent, isImagesUploaded: isImageUploaded, onSubmit: this.addNewLGPost, isLoading: showPresentationLoader, updatePortal: updatePortal })) : style === 'multiple' && multipleImagesLoad ? (React.createElement(MultipleUploadBlock, { isLoading: ImagesNotUploaded, uppy: this.uppy, captionMode: this.state.multiLoadCaptionMode, onCaptionChange: this.handleMultiImgCaptionValueChange, onTextChange: this.handleMultiImgCaptionValueChange, 
                            // onImgRemove={this.handleRemoveMultiloadImgClick}
                            onSetSortedImg: this.handleSortedMultipleImgChange, onImgRemove: this.handleImgRemove, srcList: this.state.multiLoadGrouppedImg })) : ((_x = ['annotation', 'block_with_title']) === null || _x === void 0 ? void 0 : _x.includes(this.state.style)) ? (React.createElement(BlockWithTitleEdit, { onClick: this.handleTextareaFocus, ref: this.coloredTextareaRef, style: this.state.style, onChange: function (e) { return _this.onColoredTextareaResize(e); }, onCaptionChange: function (e) { return _this.onCaptionChange(e); }, 
                            // onFocus={(e) => this.onFocusArea(e)}
                            text: this.state.text, fontColor: this.state.fontColor, caption: this.state.caption, bgcolor: this.state.color })) : this.state.style === 'colored' ? (React.createElement(EditTitle, { bgcolor: this.state.color, isFeed: this.props.isFeed, fontColor: this.state.fontColor, onClick: this.handleTextareaFocus, viewType: this.props.viewType },
                            React.createElement("div", { ref: this.coloredTextareaRef },
                                React.createElement(TextArea, { value: this.state.text, onChange: function (e) { return _this.onColoredTextareaResize(e); }, placeholder: t('editor.inputs.placeholder'), 
                                    // onResize={this.onColoredTextareaResize}
                                    ref: this.coloredTA, onFocus: function (e) { return _this.onFocusArea(e); }, postType: this.state.style, autoFocus: true, resize: false }),
                                additionalStyle !== '' && (React.createElement(ButtonBlock, { type: additionalStyle, uprise: UPRISE_TYPE.colored, onAddNewButton: this.handlePostButtonsChange }))),
                            ratingEditorVisible && (React.createElement(RaitingBox, { onChange: this.handleToggleRatingDataChange, data: this.state.ratings })))) : this.state.style === 'link' ? (React.createElement(EditTitle, { bgcolor: this.state.color, fontColor: this.state.fontColor, onClick: this.handleTextareaFocus, isFeed: this.props.isFeed, viewType: this.props.viewType, isLinkBlock: true },
                            React.createElement("div", { ref: this.coloredTextareaRef },
                                React.createElement(LinkArea, { value: this.state.text, onChange: function (e) { return _this.onLinkResize(e); }, linkText: this.state.linkText, onLinkChange: function (linkText) { return _this.handleSetLink(linkText); }, placeholder: t('editor.inputs.link_placeholder'), ref: this.coloredTA, onFocus: function (e) { return _this.onFocusArea(e); }, fontColor: this.state.fontColor, bgcolor: this.state.color, postType: this.state.style, autoFocus: true, resize: false }),
                                additionalStyle !== '' && (React.createElement(ButtonBlock, { type: additionalStyle, uprise: UPRISE_TYPE.colored, onAddNewButton: this.handlePostButtonsChange }))))) : this.state.style === 'forms' ? (React.createElement(FormsBlock, { isEditing: false, onSetFormPosition: this.handleSetFormPosition, onFormIdSet: this.handleSetFormId, isLoading: this.state.isLoading })) : this.state.style === 'podcast' ? (React.createElement(PodcastEditBlock, { podcastTimecodes: JSON.parse(getAdditionalInfoVal(this.state.additionalInfo, 'podcastTimeCodes') || "[]"), isLoading: this.state.isLoading, audioSrc: this.state.audioSrc, podcastName: this.state.text, iframeLink: this.state.iframeLink, onClearPodcastFile: function () {
                                _this.setState({ text: '', audioSrc: '', iframeLink: '' });
                                if (_this.fileRef.current)
                                    _this.fileRef.current.value = '';
                            }, onSetPodcastTimeCodes: function (podcastTimeCodes) {
                                _this.setState({ additionalInfo: addOrChangeAdditionalInfo(_this.state.additionalInfo, [{ "name": "podcastTimeCodes", "value": JSON.stringify(podcastTimeCodes) }]) });
                            }, onSetPodcastTotalTime: function (podcastTime) {
                                _this.setState({ additionalInfo: addOrChangeAdditionalInfo(_this.state.additionalInfo, [{ "name": "podcastTime", "value": String(podcastTime) }]) });
                            }, onSetIframeLink: function (iframeLink) {
                                _this.setState({ iframeLink: iframeLink });
                            }, fileRef: this.fileRef, onAddImage: this.addFile })) : this.state.style === 'course_lesson' ? (React.createElement(LessonEditBlock, { lessonId: this.state.text, isLoading: this.state.isLoading, onSubmit: function (text) { return _this.setState({ text: text }); }, setLessonPostDisabled: function (lessonPostDisabled) { return _this.setState({ lessonPostDisabled: lessonPostDisabled }); }, setOnLessonSave: function (onLessonSave) { return _this.setState({ onLessonSave: onLessonSave }); } })) : this.state.style === 'image_sources' ||
                            this.state.style === 'bibliography' ? (React.createElement("div", null,
                            React.createElement(EditorWrap, { onClick: this.handleTextareaFocus, isBiblio: true, inputType: TEXTAREA_TYPE.bibliography },
                                React.createElement(TextWrapper, null,
                                    React.createElement(LeftColumn, { isBiblio: true },
                                        React.createElement(FlexBox, { direction: "column", directionMobile: "column", offsetLeft: 36, gy: 16 },
                                            (!alreadyHasBibliography || this.state.style === 'bibliography') && React.createElement(RadioButton, { checked: this.state.style === 'bibliography', onChange: function () { return _this.setState({ style: 'bibliography' }); }, name: 'bibliography' },
                                                React.createElement("span", { style: { color: '#909090', marginLeft: '4px' }, className: 'radio-text' }, t('editor.bibliography'))),
                                            (!alreadyHasImageSources || this.state.style === 'image_sources') && React.createElement(RadioButton, { checked: this.state.style === 'image_sources', onChange: function () { return _this.setState({ style: 'image_sources' }); }, name: 'image_sources' },
                                                React.createElement("span", { style: { color: '#909090', marginLeft: '4px' }, className: 'radio-text' }, t('editor.image_sources'))))),
                                    React.createElement(RightColumn, null,
                                        React.createElement("div", { ref: this.textareaRef },
                                            React.createElement(TextArea, { value: this.state.text, onChange: function (e) { return _this.onSourcesTextareaChange(e); }, onKeyUp: function (e) { return _this.onSourcesTextareaKeyUp(e); }, placeholder: t('editor.inputs.placeholder'), onResize: this.onSourcesTextareaChange, maxLength: this.state.style === 'image_sources' ? 100000 : 50000, onFocus: function (e) { return _this.onFocusArea(e); }, postType: this.state.style, type: TEXTAREA_TYPE.bibliography, autoFocus: true }))))))) : this.state.style === 'super-puper-vote' ? (React.createElement(MultipleUploadBlock, { isLoading: this.state.isLoading, uppy: this.uppy, srcList: this.state.multiLoadGrouppedImg, onSetSortedImg: this.handleSortedMultipleImgChange, onImgRemove: this.handleImgRemove, isVoting: true })) : this.state.style === 'two_pictures' ? (React.createElement(TwoPicturesBlock, { isLoading: this.state.isLoading || !isMultiLoadDisabled, uppy: this.uppy, srcList: this.state.multiLoadGrouppedImg, onChange: this.handleSortedMultipleImgChange, onSlideTextChange: this.handleSlideTextChange, onImgRemove: this.handleImgRemove, onRatioError: function (value) { return _this.setState({ ratioError: value }); }, textPosition: postTextPos, controlsPlacer: this.state.sliderControlsPlacer, onCaptionEdit: this.handleCaptionButton, onChangeImage: this.onChangeImage, fileRef: this.fileRef, isEditable: true })) : style === 'slider' || style === 'tile' ? (React.createElement(SliderEditBlock, { isLoading: ImagesNotUploaded, uppy: this.uppy, srcList: this.state.multiLoadGrouppedImg, onSetSortedImg: this.handleSortedMultipleImgChange, onImgRemove: this.handleImgRemove, onSlideTextChange: this.handleSlideTextChange, onTileViewTypeChange: this.handleTileViewTypeChange, TAvalue: textValue, TAOnChange: this.handleTextPositionChange, handleSlideChecked: this.handleSlideChecked, editingText: this.state.editingText, captionMode: this.state.multiLoadCaptionMode, controlsPlacer: this.state.sliderControlsPlacer, caption: textValue, style: style, tileViewType: this.state.tileViewType })) : style === 'projects' ? (React.createElement(ProjectEditBlock, { style: style, projectIds: this.state.projectIds, onSetSortedProject: this.handleSortedProjects, onDeleteProject: this.handleDeleteProjects })) : style === 'products' ? (React.createElement(ProductsBlock, { cardIds: getCardIdsFromAdditionalInfo(this.state.additionalInfo, this.state.cardIds), onChange: this.handleProductsChange, isEditable: true })) : style === 'course_presentation' ? (React.createElement(CoursePresentationEditBlock, { style: style, onSelect: this.handleSetCoursePresentation, selectedProject: this.state.projectIds })) : isMedia ? (React.createElement(MediaInputGroup, { style: style, value: this.state.text, onSubmit: function (text) { return _this.setState({ text: text }); } })) : ((_y = ['normal_image', 'normal', 'normal_card', 'normal_emblem']) === null || _y === void 0 ? void 0 : _y.includes(style)) ? (React.createElement("div", null,
                            React.createElement(EditorWrap, { onClick: this.handleTextareaFocus },
                                React.createElement(TextWrapper, { isEmblem: style === 'normal_emblem' },
                                    React.createElement(LeftColumn, { className: 'left-column' },
                                        React.createElement(WhitePostImageBlock, { fileRef: this.fileRef, uppy: this.uppy, style: style, onAddCard: this.handleCardButton, onAddImage: this.addFile, onImageRemove: this.removeImage, cardIds: getCardIdsFromAdditionalInfo(this.state.additionalInfo, this.state.cardIds), src: this.state.bigImageSrc })),
                                    React.createElement(RightColumn, { className: 'right-column' },
                                        React.createElement("div", { ref: this.textareaRef },
                                            React.createElement(TextArea, { value: textValue, onChange: function (e) { return _this.onStandartTextareaChange(e); }, placeholder: t('editor.inputs.placeholder'), onFocus: function (e) { return _this.onFocusArea(e); }, postType: this.state.style, 
                                                // onBlur={(e) => this.onBlueArea(e)} пока не удаляю
                                                autoFocus: true })),
                                        this.state.prevImageSrc === '' ? ('') : (React.createElement(AttachedImage, { isLoading: this.state.isLoading },
                                            React.createElement(AttachedImageProgress, { isLoading: this.state.isLoading },
                                                React.createElement(ProgressBar, { uppy: this.uppy, hideAfterFinish: true })),
                                            React.createElement("img", { src: this.state.prevImageSrc, alt: 'prev' }),
                                            React.createElement(RemoveImage, { onClick: function () { return _this.removeImage(); } }))),
                                        additionalStyle !== '' && (React.createElement(ButtonBlock, { type: additionalStyle, uprise: UPRISE_TYPE.normal, onAddNewButton: this.handlePostButtonsChange }))))))) : (React.createElement(DefaultBlock, { colorStyle: this.props.colorStyle })),
                        isBottom && editorToolbar),
                    imageCaption && !((_z = ['top', 'center', 'bottom']) === null || _z === void 0 ? void 0 : _z.includes(postTextPos)) && (React.createElement(CaptionBlock, { colorStyle: captionColorStyle },
                        React.createElement(CaptionMarkdownText, { rehypePlugins: [rehypeRaw, rehypeSanitize] }, formatLinks(imageCaption)))))),
            React.createElement(GlobalEditor, null)));
    };
    return NewEl;
}(Component));
var mapStateToProps = function (store, _a) {
    var currentId = _a.lgid;
    var newLongread = getCurrentLongread(store, currentId);
    var newEditLongread = getCurrentEditLongread(store, currentId);
    var addLongread = getAddLongread(store, currentId);
    var toggleLongReadPostUpdate = getToggleLongReadPostUpdate(store, currentId);
    return {
        editLongRead: newEditLongread,
        blocksLength: newLongread.blocks.length,
        alreadyHasImageSources: newLongread.blocks
            ? newLongread.blocks.some(function (block) { return (block === null || block === void 0 ? void 0 : block.style) === 'image_sources'; })
            : false,
        alreadyHasBibliography: newLongread.blocks
            ? newLongread.blocks.some(function (block) { return (block === null || block === void 0 ? void 0 : block.style) === 'bibliography'; })
            : false,
        addlgpost: addLongread,
        updateStatus: toggleLongReadPostUpdate.updateStatus,
        posts: newLongread.blocks
        // countryInnerPageData: store.countryInnerPage.data,
        // doiserStates: store.doiserStates
    };
};
var mapDispatchToProps = function (dispatch, _a) {
    var currentId = _a.lgid;
    return {
        // setCreator: (creatorOptions) => dispatch(setCreator(creatorOptions))
        addLongReadPost: function (args) {
            return dispatch(addLongReadPost(args));
        },
        addManyLongReadPost: function (arr, id, title, text, color, imageid, lgid, isFL, imgCaption, style, num, imageData, thematic, anchorText, generalProps, useRating, ratings, isRibbon, reverseParam, additionalInfo) {
            return dispatch(addManyLongReadPost(arr, id, title, text, color, imageid, lgid, isFL, imgCaption, style, num, imageData, thematic, anchorText, generalProps, useRating, ratings, isRibbon, reverseParam, additionalInfo));
        },
        getLongRead: function (idArea, idCountry, type) {
            return dispatch(getLongRead(idArea, idCountry, type));
        },
        setEditLongRead: function (status, num) { return dispatch(setEditLongRead(status, num, currentId)); },
        getLongReadPosts: function (idUser, idLongRead, sign, thematic) {
            return dispatch(getLongReadPosts(idUser, idLongRead, sign, thematic));
        },
        toggleLongReadPostUpdate: function (postid, updateStatus) {
            return dispatch(toggleLongReadPostUpdate(postid, updateStatus, currentId));
        },
        toggleWidePreviewer: function (val, src) {
            return dispatch(toggleWidePreviewer(val, src));
        },
        clearWidePreviewer: function () {
            return dispatch(clearWidePreviewer());
        }
    };
};
NewEl.propTypes = {};
var ConnectedComponent = connect(mapStateToProps, mapDispatchToProps)(toastHook(withProfile(withModal(withLocalization(NewEl))), useToasts));
export default ConnectedComponent;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28;
//# sourceMappingURL=newel.js.map